
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91id_93yzEYYFc3A2Meta } from "/build/client/pages/apps/consent/[id].vue?macro=true";
import { default as indexwwMxLO9XkcMeta } from "/build/client/pages/apps/faq/index.vue?macro=true";
import { default as _91id_934l75MFEX2nMeta } from "/build/client/pages/apps/manage/[id].vue?macro=true";
import { default as indexZ5P0DsD4ySMeta } from "/build/client/pages/apps/manage/index.vue?macro=true";
import { default as _91name_93qBQogZ7VGIMeta } from "/build/client/pages/apps/partner/[name].vue?macro=true";
import { default as _91name_93FTuC1H7XEuMeta } from "/build/client/pages/apps/pd/[name].vue?macro=true";
import { default as indexS0luP2HbY0Meta } from "/build/client/pages/apps/profile/index.vue?macro=true";
import { default as indexMfDeFpLDF8Meta } from "/build/client/pages/apps/register/index.vue?macro=true";
import { default as indexTZGK7ZQnqrMeta } from "/build/client/pages/apps/viewAll/index.vue?macro=true";
import { default as _91id_93GomDq3cOdjMeta } from "/build/client/pages/arcade/details/[id].vue?macro=true";
import { default as _91article_930Xa2RavOiqMeta } from "/build/client/pages/articles/[category]/[subcategory]/[article].vue?macro=true";
import { default as indexTZEuUtRe19Meta } from "/build/client/pages/articles/[category]/[subcategory]/index.vue?macro=true";
import { default as indexpXGrrgc1yOMeta } from "/build/client/pages/articles/[category]/index.vue?macro=true";
import { default as _91article_93JrHjdWrfnOMeta } from "/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue?macro=true";
import { default as indexqAPFE0JKKzMeta } from "/build/client/pages/articles/premium/[category]/[subcategory]/index.vue?macro=true";
import { default as indexKTLhPnLtC8Meta } from "/build/client/pages/articles/premium/[category]/index.vue?macro=true";
import { default as indexjWIXHdGL2iMeta } from "/build/client/pages/articles/premium/index.vue?macro=true";
import { default as _91id_93Rwphx6lXlfMeta } from "/build/client/pages/audiobook/artists/[id].vue?macro=true";
import { default as indexDcQ8dG0mb7Meta } from "/build/client/pages/audiobook/category/index.vue?macro=true";
import { default as _91id_93cTZucMCDMwMeta } from "/build/client/pages/audiobook/details/[id].vue?macro=true";
import { default as _91name_93uMfJQbjPtnMeta } from "/build/client/pages/audiobook/genre/[name].vue?macro=true";
import { default as indexrKK4NVrvyWMeta } from "/build/client/pages/audiobook/list/index.vue?macro=true";
import { default as indexpXiJHKiwEaMeta } from "/build/client/pages/billing-history/index.vue?macro=true";
import { default as logouthr9OODKZTcMeta } from "/build/client/pages/external/logout.vue?macro=true";
import { default as indexxIo9aJhbexMeta } from "/build/client/pages/favorites/index.vue?macro=true";
import { default as indexGC6MebaE1PMeta } from "/build/client/pages/games/category/[name]/index.vue?macro=true";
import { default as _91id_93O10yRuahh6Meta } from "/build/client/pages/games/details/[id].vue?macro=true";
import { default as _91id_93JHGgUJDpHMMeta } from "/build/client/pages/games/list/[name]/[id].vue?macro=true";
import { default as indexwqv6dPHHwMMeta } from "/build/client/pages/games/list/[name]/index.vue?macro=true";
import { default as indexonlwVPE06TMeta } from "/build/client/pages/games/publisher/[name]/index.vue?macro=true";
import { default as indexlOaMmYAV5cMeta } from "/build/client/pages/history/index.vue?macro=true";
import { default as indexS9eHXdPx1zMeta } from "/build/client/pages/impressum/index.vue?macro=true";
import { default as indexPJ1ba4UEMEMeta } from "/build/client/pages/index.vue?macro=true";
import { default as _91name_938dBaKqdsMiMeta } from "/build/client/pages/info/[name].vue?macro=true";
import { default as indexR6FNvP4FlUMeta } from "/build/client/pages/internal-redirect/index.vue?macro=true";
import { default as indexJpuqfd4B2aMeta } from "/build/client/pages/launch/index.vue?macro=true";
import { default as _91name_93Nn9h1jjjH4Meta } from "/build/client/pages/main/[name].vue?macro=true";
import { default as _91name_93BdFXGLczV3Meta } from "/build/client/pages/marketing/[name].vue?macro=true";
import { default as _91category_93Xvw0gd3b7VMeta } from "/build/client/pages/mp/[category].vue?macro=true";
import { default as _91name_93Eu17hMMqDqMeta } from "/build/client/pages/mp/[name].vue?macro=true";
import { default as _91album_93uuPOCtCX3mMeta } from "/build/client/pages/music/albums/[artist]/[album].vue?macro=true";
import { default as indexXRdfpPsGNJMeta } from "/build/client/pages/music/albums/category/[name]/index.vue?macro=true";
import { default as indexOpwVwA1KIiMeta } from "/build/client/pages/music/albums/index.vue?macro=true";
import { default as _91id_93n8I7jeg1EXMeta } from "/build/client/pages/music/artists/[id].vue?macro=true";
import { default as _91name_93frRWgteusYMeta } from "/build/client/pages/music/genre/[name].vue?macro=true";
import { default as indexOxC3bzgmv4Meta } from "/build/client/pages/music/list/index.vue?macro=true";
import { default as _91playlist_93IQRFq5FWmEMeta } from "/build/client/pages/music/playlists/[playlist].vue?macro=true";
import { default as index0KW8e2AsAwMeta } from "/build/client/pages/music/playlists/index.vue?macro=true";
import { default as _91track_93GN6azv8NBlMeta } from "/build/client/pages/music/tracks/[track].vue?macro=true";
import { default as indexA1gUcYMeLKMeta } from "/build/client/pages/music/tracks/category/index.vue?macro=true";
import { default as indexMd73SjKNW0Meta } from "/build/client/pages/music/tracks/index.vue?macro=true";
import { default as _91id_93SOzP1BGHwuMeta } from "/build/client/pages/music/video/details/[id].vue?macro=true";
import { default as index33vftUGZmHMeta } from "/build/client/pages/myCart/index.vue?macro=true";
import { default as index6pGKKfDkOHMeta } from "/build/client/pages/MyPaymentMethods/index.vue?macro=true";
import { default as indexIY0ZLhc27tMeta } from "/build/client/pages/myPurchases/index.vue?macro=true";
import { default as _91article_9360un6B7bUkMeta } from "/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue?macro=true";
import { default as indexn5d2d7y0ZgMeta } from "/build/client/pages/news/[category]/[subcategory]/index.vue?macro=true";
import { default as indexcyDubduV4lMeta } from "/build/client/pages/news/[category]/index.vue?macro=true";
import { default as indexrui7bfnA3CMeta } from "/build/client/pages/notifications/index.vue?macro=true";
import { default as indexDsxnMO4uncMeta } from "/build/client/pages/parentalControl/index.vue?macro=true";
import { default as indexzlUKgUSNNbMeta } from "/build/client/pages/partner-registration/index.vue?macro=true";
import { default as _91id_93rWtBi4wOgNMeta } from "/build/client/pages/partner-subscriptions/[id].vue?macro=true";
import { default as index7VVRjMbykUMeta } from "/build/client/pages/partner-subscriptions/index.vue?macro=true";
import { default as _91name_93D7k5LeIGx8Meta } from "/build/client/pages/partners/[name].vue?macro=true";
import { default as _91name_93QCcSm9rPpxMeta } from "/build/client/pages/partners/info-services/[name].vue?macro=true";
import { default as indexOap3VIvsgdMeta } from "/build/client/pages/partners/info-services/index.vue?macro=true";
import { default as _91id_93NVGt6VIQcHMeta } from "/build/client/pages/podcast/details/[id].vue?macro=true";
import { default as _91id_93a0TtNiZzOqMeta } from "/build/client/pages/podcast/episode/[id].vue?macro=true";
import { default as indexKHdyBEkQR1Meta } from "/build/client/pages/podcast/list/index.vue?macro=true";
import { default as index5dStAfsfgtMeta } from "/build/client/pages/profile/index.vue?macro=true";
import { default as info_45service_45subscriptionsDCgXVbxQeeMeta } from "/build/client/pages/profile/info-service-subscriptions.vue?macro=true";
import { default as infol5cACWvfvzMeta } from "/build/client/pages/profile/info.vue?macro=true";
import { default as manage53bNHwVbM6Meta } from "/build/client/pages/profile/manage.vue?macro=true";
import { default as preferencesQDAk4HZ3xZMeta } from "/build/client/pages/profile/preferences.vue?macro=true";
import { default as privacy_45settingsHaWimkB2XAMeta } from "/build/client/pages/profile/privacy-settings.vue?macro=true";
import { default as index8rw0NWP1v0Meta } from "/build/client/pages/resetpassword/index.vue?macro=true";
import { default as indexlmTaoVSpovMeta } from "/build/client/pages/reward/index.vue?macro=true";
import { default as index7CY0Z7zhnNMeta } from "/build/client/pages/search/index.vue?macro=true";
import { default as indexOKQ8xhawXWMeta } from "/build/client/pages/subscription/index.vue?macro=true";
import { default as _91id_93bGiFISPABbMeta } from "/build/client/pages/tournaments/details/[id].vue?macro=true";
import { default as _91id_93LPVlw7BayrMeta } from "/build/client/pages/tournaments/news/details/[id].vue?macro=true";
import { default as _91id_93dO7aKfHLXtMeta } from "/build/client/pages/tournaments/videos/details/[id].vue?macro=true";
import { default as emailVd2RuYgearMeta } from "/build/client/pages/user/login/email.vue?macro=true";
import { default as indexcsQ0CMG5wQMeta } from "/build/client/pages/user/login/index.vue?macro=true";
import { default as indexs0QGI5ioDqMeta } from "/build/client/pages/user/register/index.vue?macro=true";
import { default as _91id_933cqCD8738ZMeta } from "/build/client/pages/video/[ex]/category/[id].vue?macro=true";
import { default as _91id_93vBAh0MFQSDMeta } from "/build/client/pages/video/[ex]/details/[id].vue?macro=true";
import { default as _91id_93LZFvzd3MRDMeta } from "/build/client/pages/video/[ex]/stream/[id].vue?macro=true";
import { default as _91id_93fXc9pfOypwMeta } from "/build/client/pages/video/category/[name]/[id].vue?macro=true";
import { default as _91id_93pvP6Xo2PmfMeta } from "/build/client/pages/video/details/[id].vue?macro=true";
import { default as _91name_93bGYIw10bpfMeta } from "/build/client/pages/video/list/[name].vue?macro=true";
import { default as _91id_932I2uvZhsLWMeta } from "/build/client/pages/video/series/details/[id].vue?macro=true";
import { default as _91id_9327jJgaGxYmMeta } from "/build/client/pages/video/stream/[id].vue?macro=true";
import { default as testRm0JxZFBuIMeta } from "/build/client/pages/video/test.vue?macro=true";
import { default as _91name_93ZtLlNObCTIMeta } from "/build/client/pages/voucherbooks/[name].vue?macro=true";
import { default as _91id_93UD22VGTJodMeta } from "/build/client/pages/vouchers/category/[id].vue?macro=true";
import { default as _91id_93eiTf6ArfPAMeta } from "/build/client/pages/vouchers/details/[id].vue?macro=true";
import { default as _91id_93TlB8mq31jsMeta } from "/build/client/pages/vouchers/genre/[id].vue?macro=true";
export default [
  {
    name: "apps-consent-id___default",
    path: "/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___en",
    path: "/en/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___ar",
    path: "/ar/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___fr",
    path: "/fr/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___de",
    path: "/de/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___es",
    path: "/es/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-consent-id___ro",
    path: "/ro/apps/consent/:id()",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "apps-faq___default",
    path: "/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___en",
    path: "/en/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___ar",
    path: "/ar/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___fr",
    path: "/fr/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___de",
    path: "/de/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___es",
    path: "/es/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-faq___ro",
    path: "/ro/apps/faq",
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "apps-manage-id___default",
    path: "/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___en",
    path: "/en/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___ar",
    path: "/ar/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___fr",
    path: "/fr/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___de",
    path: "/de/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___es",
    path: "/es/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage-id___ro",
    path: "/ro/apps/manage/:id()",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "apps-manage___default",
    path: "/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___en",
    path: "/en/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___ar",
    path: "/ar/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___fr",
    path: "/fr/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___de",
    path: "/de/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___es",
    path: "/es/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-manage___ro",
    path: "/ro/apps/manage",
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "apps-partner-name___default",
    path: "/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___en",
    path: "/en/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___ar",
    path: "/ar/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___fr",
    path: "/fr/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___de",
    path: "/de/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___es",
    path: "/es/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-partner-name___ro",
    path: "/ro/apps/partner/:name()",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "apps-pd-name___default",
    path: "/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___en",
    path: "/en/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___ar",
    path: "/ar/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___fr",
    path: "/fr/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___de",
    path: "/de/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___es",
    path: "/es/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-pd-name___ro",
    path: "/ro/apps/pd/:name()",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "apps-profile___default",
    path: "/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___en",
    path: "/en/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___ar",
    path: "/ar/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___fr",
    path: "/fr/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___de",
    path: "/de/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___es",
    path: "/es/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-profile___ro",
    path: "/ro/apps/profile",
    meta: indexS0luP2HbY0Meta || {},
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "apps-register___default",
    path: "/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___en",
    path: "/en/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___ar",
    path: "/ar/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___fr",
    path: "/fr/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___de",
    path: "/de/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___es",
    path: "/es/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-register___ro",
    path: "/ro/apps/register",
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "apps-viewAll___default",
    path: "/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___en",
    path: "/en/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___ar",
    path: "/ar/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___fr",
    path: "/fr/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___de",
    path: "/de/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___es",
    path: "/es/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "apps-viewAll___ro",
    path: "/ro/apps/viewAll",
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "arcade-details-id___default",
    path: "/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___en",
    path: "/en/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___ar",
    path: "/ar/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___fr",
    path: "/fr/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___de",
    path: "/de/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___es",
    path: "/es/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details-id___ro",
    path: "/ro/arcade/details/:id()",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "articles-category-subcategory-article___default",
    path: "/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___en",
    path: "/en/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___ar",
    path: "/ar/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___fr",
    path: "/fr/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___de",
    path: "/de/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___es",
    path: "/es/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory-article___ro",
    path: "/ro/articles/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-subcategory___default",
    path: "/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___en",
    path: "/en/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___ar",
    path: "/ar/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___fr",
    path: "/fr/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___de",
    path: "/de/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___es",
    path: "/es/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category-subcategory___ro",
    path: "/ro/articles/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-category___default",
    path: "/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___en",
    path: "/en/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___ar",
    path: "/ar/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___fr",
    path: "/fr/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___de",
    path: "/de/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___es",
    path: "/es/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-category___ro",
    path: "/ro/articles/:category()",
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory-article___default",
    path: "/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___en",
    path: "/en/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___ar",
    path: "/ar/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___fr",
    path: "/fr/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___de",
    path: "/de/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___es",
    path: "/es/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory-article___ro",
    path: "/ro/articles/premium/:category()/:subcategory()/:article()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-premium-category-subcategory___default",
    path: "/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___en",
    path: "/en/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___ar",
    path: "/ar/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___fr",
    path: "/fr/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___de",
    path: "/de/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___es",
    path: "/es/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category-subcategory___ro",
    path: "/ro/articles/premium/:category()/:subcategory()",
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "articles-premium-category___default",
    path: "/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___en",
    path: "/en/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___ar",
    path: "/ar/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___fr",
    path: "/fr/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___de",
    path: "/de/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___es",
    path: "/es/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium-category___ro",
    path: "/ro/articles/premium/:category()",
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "articles-premium___default",
    path: "/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___en",
    path: "/en/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___ar",
    path: "/ar/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___fr",
    path: "/fr/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___de",
    path: "/de/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___es",
    path: "/es/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "articles-premium___ro",
    path: "/ro/articles/premium",
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "audiobook-artists-id___default",
    path: "/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___en",
    path: "/en/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___ar",
    path: "/ar/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___fr",
    path: "/fr/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___de",
    path: "/de/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___es",
    path: "/es/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists-id___ro",
    path: "/ro/audiobook/artists/:id()",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-category___default",
    path: "/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___en",
    path: "/en/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___ar",
    path: "/ar/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___fr",
    path: "/fr/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___de",
    path: "/de/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___es",
    path: "/es/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-category___ro",
    path: "/ro/audiobook/category",
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "audiobook-details-id___default",
    path: "/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___en",
    path: "/en/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___ar",
    path: "/ar/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___fr",
    path: "/fr/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___de",
    path: "/de/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___es",
    path: "/es/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details-id___ro",
    path: "/ro/audiobook/details/:id()",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-genre-name___default",
    path: "/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___en",
    path: "/en/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___ar",
    path: "/ar/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___fr",
    path: "/fr/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___de",
    path: "/de/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___es",
    path: "/es/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-genre-name___ro",
    path: "/ro/audiobook/genre/:name()",
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "audiobook-list___default",
    path: "/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___en",
    path: "/en/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___ar",
    path: "/ar/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___fr",
    path: "/fr/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___de",
    path: "/de/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___es",
    path: "/es/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "audiobook-list___ro",
    path: "/ro/audiobook/list",
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "billing-history___default",
    path: "/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___en",
    path: "/en/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___ar",
    path: "/ar/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___fr",
    path: "/fr/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___de",
    path: "/de/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___es",
    path: "/es/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "billing-history___ro",
    path: "/ro/billing-history",
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "external-logout___default",
    path: "/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___en",
    path: "/en/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___ar",
    path: "/ar/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___fr",
    path: "/fr/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___de",
    path: "/de/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___es",
    path: "/es/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "external-logout___ro",
    path: "/ro/external/logout",
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "favorites___default",
    path: "/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___en",
    path: "/en/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___ar",
    path: "/ar/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___fr",
    path: "/fr/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___de",
    path: "/de/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___es",
    path: "/es/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "favorites___ro",
    path: "/ro/favorites",
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "games-category-name___default",
    path: "/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___en",
    path: "/en/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___ar",
    path: "/ar/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___fr",
    path: "/fr/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___de",
    path: "/de/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___es",
    path: "/es/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category-name___ro",
    path: "/ro/games/category/:name()",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-details-id___default",
    path: "/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___en",
    path: "/en/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___ar",
    path: "/ar/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___fr",
    path: "/fr/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___de",
    path: "/de/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___es",
    path: "/es/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details-id___ro",
    path: "/ro/games/details/:id()",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-list-name-id___default",
    path: "/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___en",
    path: "/en/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___ar",
    path: "/ar/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___fr",
    path: "/fr/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___de",
    path: "/de/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___es",
    path: "/es/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name-id___ro",
    path: "/ro/games/list/:name()/:id()",
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "games-list-name___default",
    path: "/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___en",
    path: "/en/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___ar",
    path: "/ar/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___fr",
    path: "/fr/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___de",
    path: "/de/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___es",
    path: "/es/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list-name___ro",
    path: "/ro/games/list/:name()",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-publisher-name___default",
    path: "/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___en",
    path: "/en/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___ar",
    path: "/ar/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___fr",
    path: "/fr/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___de",
    path: "/de/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___es",
    path: "/es/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "games-publisher-name___ro",
    path: "/ro/games/publisher/:name()",
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "history___default",
    path: "/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___en",
    path: "/en/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___ar",
    path: "/ar/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___fr",
    path: "/fr/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___de",
    path: "/de/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___es",
    path: "/es/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "history___ro",
    path: "/ro/history",
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "impressum___default",
    path: "/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___en",
    path: "/en/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___ar",
    path: "/ar/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___fr",
    path: "/fr/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___de",
    path: "/de/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___es",
    path: "/es/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "impressum___ro",
    path: "/ro/impressum",
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "index___default",
    path: "/",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "info-name___default",
    path: "/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___en",
    path: "/en/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___ar",
    path: "/ar/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___fr",
    path: "/fr/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___de",
    path: "/de/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___es",
    path: "/es/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "info-name___ro",
    path: "/ro/info/:name()",
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "internal-redirect___default",
    path: "/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___en",
    path: "/en/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___ar",
    path: "/ar/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___fr",
    path: "/fr/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___de",
    path: "/de/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___es",
    path: "/es/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "internal-redirect___ro",
    path: "/ro/internal-redirect",
    meta: indexR6FNvP4FlUMeta || {},
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "launch___default",
    path: "/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___en",
    path: "/en/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___ar",
    path: "/ar/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___fr",
    path: "/fr/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___de",
    path: "/de/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___es",
    path: "/es/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "launch___ro",
    path: "/ro/launch",
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "main-name___default",
    path: "/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___en",
    path: "/en/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___ar",
    path: "/ar/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___fr",
    path: "/fr/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___de",
    path: "/de/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___es",
    path: "/es/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main-name___ro",
    path: "/ro/main/:name()",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "marketing-name___default",
    path: "/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___en",
    path: "/en/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___ar",
    path: "/ar/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___fr",
    path: "/fr/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___de",
    path: "/de/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___es",
    path: "/es/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "marketing-name___ro",
    path: "/ro/marketing/:name()",
    meta: _91name_93BdFXGLczV3Meta || {},
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "mp-category___default",
    path: "/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___en",
    path: "/en/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___ar",
    path: "/ar/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___fr",
    path: "/fr/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___de",
    path: "/de/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___es",
    path: "/es/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-category___ro",
    path: "/ro/mp/:category()",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "mp-name___default",
    path: "/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___en",
    path: "/en/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___ar",
    path: "/ar/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___fr",
    path: "/fr/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___de",
    path: "/de/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___es",
    path: "/es/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "mp-name___ro",
    path: "/ro/mp/:name()",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "music-albums-artist-album___default",
    path: "/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___en",
    path: "/en/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___ar",
    path: "/ar/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___fr",
    path: "/fr/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___de",
    path: "/de/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___es",
    path: "/es/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-artist-album___ro",
    path: "/ro/music/albums/:artist()/:album()",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-albums-category-name___default",
    path: "/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___en",
    path: "/en/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___ar",
    path: "/ar/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___fr",
    path: "/fr/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___de",
    path: "/de/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___es",
    path: "/es/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums-category-name___ro",
    path: "/ro/music/albums/category/:name()",
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "music-albums___default",
    path: "/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___en",
    path: "/en/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___ar",
    path: "/ar/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___fr",
    path: "/fr/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___de",
    path: "/de/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___es",
    path: "/es/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-albums___ro",
    path: "/ro/music/albums",
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "music-artists-id___default",
    path: "/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___en",
    path: "/en/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___ar",
    path: "/ar/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___fr",
    path: "/fr/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___de",
    path: "/de/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___es",
    path: "/es/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artists-id___ro",
    path: "/ro/music/artists/:id()",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-genre-name___default",
    path: "/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___en",
    path: "/en/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___ar",
    path: "/ar/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___fr",
    path: "/fr/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___de",
    path: "/de/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___es",
    path: "/es/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-genre-name___ro",
    path: "/ro/music/genre/:name()",
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "music-list___default",
    path: "/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___en",
    path: "/en/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___ar",
    path: "/ar/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___fr",
    path: "/fr/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___de",
    path: "/de/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___es",
    path: "/es/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-list___ro",
    path: "/ro/music/list",
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "music-playlists-playlist___default",
    path: "/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___en",
    path: "/en/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___ar",
    path: "/ar/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___fr",
    path: "/fr/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___de",
    path: "/de/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___es",
    path: "/es/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists-playlist___ro",
    path: "/ro/music/playlists/:playlist()",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlists___default",
    path: "/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___en",
    path: "/en/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___ar",
    path: "/ar/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___fr",
    path: "/fr/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___de",
    path: "/de/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___es",
    path: "/es/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-playlists___ro",
    path: "/ro/music/playlists",
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "music-tracks-track___default",
    path: "/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___en",
    path: "/en/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___ar",
    path: "/ar/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___fr",
    path: "/fr/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___de",
    path: "/de/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___es",
    path: "/es/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-track___ro",
    path: "/ro/music/tracks/:track()",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-tracks-category___default",
    path: "/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___en",
    path: "/en/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___ar",
    path: "/ar/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___fr",
    path: "/fr/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___de",
    path: "/de/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___es",
    path: "/es/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks-category___ro",
    path: "/ro/music/tracks/category",
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "music-tracks___default",
    path: "/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___en",
    path: "/en/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___ar",
    path: "/ar/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___fr",
    path: "/fr/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___de",
    path: "/de/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___es",
    path: "/es/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-tracks___ro",
    path: "/ro/music/tracks",
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "music-video-details-id___default",
    path: "/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___en",
    path: "/en/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___ar",
    path: "/ar/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___fr",
    path: "/fr/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___de",
    path: "/de/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___es",
    path: "/es/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "music-video-details-id___ro",
    path: "/ro/music/video/details/:id()",
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "myCart___default",
    path: "/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___en",
    path: "/en/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___ar",
    path: "/ar/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___fr",
    path: "/fr/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___de",
    path: "/de/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___es",
    path: "/es/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "myCart___ro",
    path: "/ro/myCart",
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "MyPaymentMethods___default",
    path: "/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___en",
    path: "/en/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___ar",
    path: "/ar/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___fr",
    path: "/fr/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___de",
    path: "/de/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___es",
    path: "/es/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "MyPaymentMethods___ro",
    path: "/ro/MyPaymentMethods",
    meta: index6pGKKfDkOHMeta || {},
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "myPurchases___default",
    path: "/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___en",
    path: "/en/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___ar",
    path: "/ar/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___fr",
    path: "/fr/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___de",
    path: "/de/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___es",
    path: "/es/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "myPurchases___ro",
    path: "/ro/myPurchases",
    meta: indexIY0ZLhc27tMeta || {},
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "news-category-subcategory-articlename-article___default",
    path: "/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___en",
    path: "/en/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___ar",
    path: "/ar/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___fr",
    path: "/fr/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___de",
    path: "/de/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___es",
    path: "/es/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory-articlename-article___ro",
    path: "/ro/news/:category()/:subcategory()/:articlename()/:article()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "news-category-subcategory___default",
    path: "/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___en",
    path: "/en/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___ar",
    path: "/ar/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___fr",
    path: "/fr/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___de",
    path: "/de/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___es",
    path: "/es/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category-subcategory___ro",
    path: "/ro/news/:category()/:subcategory()",
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "news-category___default",
    path: "/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___en",
    path: "/en/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___ar",
    path: "/ar/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___fr",
    path: "/fr/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___de",
    path: "/de/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___es",
    path: "/es/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "news-category___ro",
    path: "/ro/news/:category()",
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "notifications___default",
    path: "/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___ar",
    path: "/ar/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___fr",
    path: "/fr/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___de",
    path: "/de/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___es",
    path: "/es/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "notifications___ro",
    path: "/ro/notifications",
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "parentalControl___default",
    path: "/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___en",
    path: "/en/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___ar",
    path: "/ar/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___fr",
    path: "/fr/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___de",
    path: "/de/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___es",
    path: "/es/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "parentalControl___ro",
    path: "/ro/parentalControl",
    meta: indexDsxnMO4uncMeta || {},
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "partner-registration___default",
    path: "/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___en",
    path: "/en/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___ar",
    path: "/ar/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___fr",
    path: "/fr/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___de",
    path: "/de/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___es",
    path: "/es/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-registration___ro",
    path: "/ro/partner-registration",
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "partner-subscriptions-id___default",
    path: "/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___en",
    path: "/en/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___ar",
    path: "/ar/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___fr",
    path: "/fr/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___de",
    path: "/de/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___es",
    path: "/es/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions-id___ro",
    path: "/ro/partner-subscriptions/:id()",
    meta: _91id_93rWtBi4wOgNMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "partner-subscriptions___default",
    path: "/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___en",
    path: "/en/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___ar",
    path: "/ar/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___fr",
    path: "/fr/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___de",
    path: "/de/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___es",
    path: "/es/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partner-subscriptions___ro",
    path: "/ro/partner-subscriptions",
    meta: index7VVRjMbykUMeta || {},
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "partners-name___default",
    path: "/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___en",
    path: "/en/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___ar",
    path: "/ar/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___fr",
    path: "/fr/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___de",
    path: "/de/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___es",
    path: "/es/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-name___ro",
    path: "/ro/partners/:name()",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "partners-info-services-name___default",
    path: "/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___en",
    path: "/en/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___ar",
    path: "/ar/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___fr",
    path: "/fr/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___de",
    path: "/de/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___es",
    path: "/es/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services-name___ro",
    path: "/ro/partners/info-services/:name()",
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "partners-info-services___default",
    path: "/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___en",
    path: "/en/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___ar",
    path: "/ar/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___fr",
    path: "/fr/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___de",
    path: "/de/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___es",
    path: "/es/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "partners-info-services___ro",
    path: "/ro/partners/info-services",
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "podcast-details-id___default",
    path: "/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___en",
    path: "/en/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___ar",
    path: "/ar/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___fr",
    path: "/fr/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___de",
    path: "/de/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___es",
    path: "/es/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details-id___ro",
    path: "/ro/podcast/details/:id()",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-episode-id___default",
    path: "/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___en",
    path: "/en/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___ar",
    path: "/ar/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___fr",
    path: "/fr/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___de",
    path: "/de/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___es",
    path: "/es/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode-id___ro",
    path: "/ro/podcast/episode/:id()",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-list___default",
    path: "/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___en",
    path: "/en/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___ar",
    path: "/ar/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___fr",
    path: "/fr/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___de",
    path: "/de/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___es",
    path: "/es/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "podcast-list___ro",
    path: "/ro/podcast/list",
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "profile___default",
    path: "/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___ar",
    path: "/ar/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___es",
    path: "/es/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile___ro",
    path: "/ro/profile",
    meta: index5dStAfsfgtMeta || {},
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "profile-info-service-subscriptions___default",
    path: "/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___en",
    path: "/en/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___ar",
    path: "/ar/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___fr",
    path: "/fr/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___de",
    path: "/de/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___es",
    path: "/es/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info-service-subscriptions___ro",
    path: "/ro/profile/info-service-subscriptions",
    meta: info_45service_45subscriptionsDCgXVbxQeeMeta || {},
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "profile-info___default",
    path: "/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___en",
    path: "/en/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___ar",
    path: "/ar/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___fr",
    path: "/fr/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___de",
    path: "/de/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___es",
    path: "/es/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-info___ro",
    path: "/ro/profile/info",
    meta: infol5cACWvfvzMeta || {},
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "profile-manage___default",
    path: "/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___en",
    path: "/en/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___ar",
    path: "/ar/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___fr",
    path: "/fr/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___de",
    path: "/de/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___es",
    path: "/es/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-manage___ro",
    path: "/ro/profile/manage",
    meta: manage53bNHwVbM6Meta || {},
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "profile-preferences___default",
    path: "/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___en",
    path: "/en/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___ar",
    path: "/ar/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___fr",
    path: "/fr/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___de",
    path: "/de/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___es",
    path: "/es/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-preferences___ro",
    path: "/ro/profile/preferences",
    meta: preferencesQDAk4HZ3xZMeta || {},
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "profile-privacy-settings___default",
    path: "/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___en",
    path: "/en/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___ar",
    path: "/ar/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___fr",
    path: "/fr/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___de",
    path: "/de/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___es",
    path: "/es/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "profile-privacy-settings___ro",
    path: "/ro/profile/privacy-settings",
    meta: privacy_45settingsHaWimkB2XAMeta || {},
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "resetpassword___default",
    path: "/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___en",
    path: "/en/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___ar",
    path: "/ar/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___fr",
    path: "/fr/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___de",
    path: "/de/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___es",
    path: "/es/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "resetpassword___ro",
    path: "/ro/resetpassword",
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "reward___default",
    path: "/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___en",
    path: "/en/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___ar",
    path: "/ar/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___fr",
    path: "/fr/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___de",
    path: "/de/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___es",
    path: "/es/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "reward___ro",
    path: "/ro/reward",
    meta: indexlmTaoVSpovMeta || {},
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "search___default",
    path: "/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___ar",
    path: "/ar/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search___ro",
    path: "/ro/search",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "subscription___default",
    path: "/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___en",
    path: "/en/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___ar",
    path: "/ar/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___fr",
    path: "/fr/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___de",
    path: "/de/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___es",
    path: "/es/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "subscription___ro",
    path: "/ro/subscription",
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "tournaments-details-id___default",
    path: "/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___en",
    path: "/en/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___ar",
    path: "/ar/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___fr",
    path: "/fr/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___de",
    path: "/de/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___es",
    path: "/es/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-details-id___ro",
    path: "/ro/tournaments/details/:id()",
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___default",
    path: "/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___en",
    path: "/en/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___ar",
    path: "/ar/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___fr",
    path: "/fr/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___de",
    path: "/de/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___es",
    path: "/es/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-news-details-id___ro",
    path: "/ro/tournaments/news/details/:id()",
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___default",
    path: "/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___en",
    path: "/en/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___ar",
    path: "/ar/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___fr",
    path: "/fr/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___de",
    path: "/de/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___es",
    path: "/es/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "tournaments-videos-details-id___ro",
    path: "/ro/tournaments/videos/details/:id()",
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "user-login-email___default",
    path: "/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___en",
    path: "/en/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___ar",
    path: "/ar/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___fr",
    path: "/fr/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___de",
    path: "/de/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___es",
    path: "/es/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login-email___ro",
    path: "/ro/user/login/email",
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "user-login___default",
    path: "/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___en",
    path: "/en/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___ar",
    path: "/ar/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___fr",
    path: "/fr/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___de",
    path: "/de/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___es",
    path: "/es/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-login___ro",
    path: "/ro/user/login",
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "user-register___default",
    path: "/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___en",
    path: "/en/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___ar",
    path: "/ar/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___fr",
    path: "/fr/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___de",
    path: "/de/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___es",
    path: "/es/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "user-register___ro",
    path: "/ro/user/register",
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "video-ex-category-id___default",
    path: "/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___en",
    path: "/en/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___ar",
    path: "/ar/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___fr",
    path: "/fr/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___de",
    path: "/de/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___es",
    path: "/es/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-category-id___ro",
    path: "/ro/video/:ex()/category/:id()",
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "video-ex-details-id___default",
    path: "/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___en",
    path: "/en/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___ar",
    path: "/ar/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___fr",
    path: "/fr/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___de",
    path: "/de/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___es",
    path: "/es/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-details-id___ro",
    path: "/ro/video/:ex()/details/:id()",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-ex-stream-id___default",
    path: "/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___en",
    path: "/en/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___ar",
    path: "/ar/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___fr",
    path: "/fr/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___de",
    path: "/de/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___es",
    path: "/es/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-ex-stream-id___ro",
    path: "/ro/video/:ex()/stream/:id()",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "video-category-name-id___default",
    path: "/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___en",
    path: "/en/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___ar",
    path: "/ar/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___fr",
    path: "/fr/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___de",
    path: "/de/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___es",
    path: "/es/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category-name-id___ro",
    path: "/ro/video/category/:name()/:id()",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-details-id___default",
    path: "/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___en",
    path: "/en/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___ar",
    path: "/ar/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___fr",
    path: "/fr/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___de",
    path: "/de/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___es",
    path: "/es/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details-id___ro",
    path: "/ro/video/details/:id()",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-list-name___default",
    path: "/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___en",
    path: "/en/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___ar",
    path: "/ar/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___fr",
    path: "/fr/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___de",
    path: "/de/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___es",
    path: "/es/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-list-name___ro",
    path: "/ro/video/list/:name()",
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "video-series-details-id___default",
    path: "/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___en",
    path: "/en/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___ar",
    path: "/ar/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___fr",
    path: "/fr/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___de",
    path: "/de/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___es",
    path: "/es/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series-details-id___ro",
    path: "/ro/video/series/details/:id()",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-stream-id___default",
    path: "/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___en",
    path: "/en/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___ar",
    path: "/ar/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___fr",
    path: "/fr/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___de",
    path: "/de/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___es",
    path: "/es/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream-id___ro",
    path: "/ro/video/stream/:id()",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-test___default",
    path: "/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___en",
    path: "/en/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___ar",
    path: "/ar/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___fr",
    path: "/fr/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___de",
    path: "/de/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___es",
    path: "/es/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "video-test___ro",
    path: "/ro/video/test",
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "voucherbooks-name___default",
    path: "/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___en",
    path: "/en/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___ar",
    path: "/ar/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___fr",
    path: "/fr/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___de",
    path: "/de/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___es",
    path: "/es/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "voucherbooks-name___ro",
    path: "/ro/voucherbooks/:name()",
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "vouchers-category-id___default",
    path: "/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___en",
    path: "/en/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___ar",
    path: "/ar/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___fr",
    path: "/fr/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___de",
    path: "/de/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___es",
    path: "/es/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-category-id___ro",
    path: "/ro/vouchers/category/:id()",
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "vouchers-details-id___default",
    path: "/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___en",
    path: "/en/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___ar",
    path: "/ar/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___fr",
    path: "/fr/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___de",
    path: "/de/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___es",
    path: "/es/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-id___ro",
    path: "/ro/vouchers/details/:id()",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-genre-id___default",
    path: "/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___en",
    path: "/en/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___ar",
    path: "/ar/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___fr",
    path: "/fr/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___de",
    path: "/de/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___es",
    path: "/es/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "vouchers-genre-id___ro",
    path: "/ro/vouchers/genre/:id()",
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "main___default",
    path: "/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___en",
    path: "/en/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___ar",
    path: "/ar/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___fr",
    path: "/fr/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___de",
    path: "/de/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___es",
    path: "/es/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "main___ro",
    path: "/ro/:name",
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "music-track___default",
    path: "/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___en",
    path: "/en/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___ar",
    path: "/ar/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___fr",
    path: "/fr/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___de",
    path: "/de/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___es",
    path: "/es/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "music-track___ro",
    path: "/ro/music/tracks/:title/:track",
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "monsooq-app-consent-details___default",
    path: "/apps/consent/:id",
    meta: _91id_93yzEYYFc3A2Meta || {},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___en",
    path: "/en/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___ar",
    path: "/ar/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___fr",
    path: "/fr/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___de",
    path: "/de/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___es",
    path: "/es/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-consent-details___ro",
    path: "/ro/apps/consent/:id",
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "monsooq-app-partner-detail___default",
    path: "/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___en",
    path: "/en/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___ar",
    path: "/ar/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___fr",
    path: "/fr/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___de",
    path: "/de/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___es",
    path: "/es/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-detail___ro",
    path: "/ro/apps/partner/:title/:name",
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___default",
    path: "/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___en",
    path: "/en/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___ar",
    path: "/ar/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___fr",
    path: "/fr/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___de",
    path: "/de/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___es",
    path: "/es/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "monsooq-app-partner-details___ro",
    path: "/ro/apps/pd/:title/:name",
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ment-app-partner-details___default",
    path: "/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___en",
    path: "/en/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___ar",
    path: "/ar/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___fr",
    path: "/fr/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___de",
    path: "/de/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___es",
    path: "/es/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-details___ro",
    path: "/ro/mp/:title/:name",
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ment-app-partner-categories-details___default",
    path: "/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___en",
    path: "/en/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___ar",
    path: "/ar/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___fr",
    path: "/fr/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___de",
    path: "/de/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___es",
    path: "/es/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ment-app-partner-categories-details___ro",
    path: "/ro/mp/:category",
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "manage-subscription-details___default",
    path: "/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___en",
    path: "/en/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___ar",
    path: "/ar/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___fr",
    path: "/fr/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___de",
    path: "/de/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___es",
    path: "/es/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "manage-subscription-details___ro",
    path: "/ro/apps/manage/:id",
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "music-artistName-albumName___default",
    path: "/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___en",
    path: "/en/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___ar",
    path: "/ar/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___fr",
    path: "/fr/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___de",
    path: "/de/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___es",
    path: "/es/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artistName-albumName___ro",
    path: "/ro/music/albums/:artist/:artistName/:albumName/:album",
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "music-artist___default",
    path: "/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___en",
    path: "/en/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___ar",
    path: "/ar/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___fr",
    path: "/fr/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___de",
    path: "/de/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___es",
    path: "/es/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-artist___ro",
    path: "/ro/music/artists/:artistName/:id",
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "music-playlist___default",
    path: "/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___en",
    path: "/en/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___ar",
    path: "/ar/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___fr",
    path: "/fr/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___de",
    path: "/de/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___es",
    path: "/es/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "music-playlist___ro",
    path: "/ro/music/playlists/:title/:playlist",
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "podcast-details___default",
    path: "/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___en",
    path: "/en/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___ar",
    path: "/ar/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___fr",
    path: "/fr/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___de",
    path: "/de/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___es",
    path: "/es/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___ro",
    path: "/ro/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-episode___default",
    path: "/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___en",
    path: "/en/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___ar",
    path: "/ar/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___fr",
    path: "/fr/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___de",
    path: "/de/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___es",
    path: "/es/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___ro",
    path: "/ro/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "audiobook-details___default",
    path: "/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___en",
    path: "/en/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___ar",
    path: "/ar/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___fr",
    path: "/fr/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___de",
    path: "/de/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___es",
    path: "/es/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-details___ro",
    path: "/ro/audiobook/details/:title/:id",
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "audiobook-artists___default",
    path: "/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___en",
    path: "/en/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___ar",
    path: "/ar/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___fr",
    path: "/fr/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___de",
    path: "/de/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___es",
    path: "/es/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "audiobook-artists___ro",
    path: "/ro/audiobook/artists/:title/:id",
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "games-category___default",
    path: "/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___en",
    path: "/en/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___ar",
    path: "/ar/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___fr",
    path: "/fr/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___de",
    path: "/de/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___es",
    path: "/es/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-category___ro",
    path: "/ro/games/category/:name/:id",
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "games-details___default",
    path: "/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___en",
    path: "/en/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___ar",
    path: "/ar/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___fr",
    path: "/fr/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___de",
    path: "/de/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___es",
    path: "/es/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-details___ro",
    path: "/ro/games/details/:name/:id",
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "games-list___default",
    path: "/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___en",
    path: "/en/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___ar",
    path: "/ar/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___fr",
    path: "/fr/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___de",
    path: "/de/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___es",
    path: "/es/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "games-list___ro",
    path: "/ro/games/list",
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "arcade-details___default",
    path: "/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___en",
    path: "/en/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___ar",
    path: "/ar/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___fr",
    path: "/fr/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___de",
    path: "/de/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___es",
    path: "/es/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "arcade-details___ro",
    path: "/ro/arcade/details/:name/:id",
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "podcast-details___default",
    path: "/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___en",
    path: "/en/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___ar",
    path: "/ar/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___fr",
    path: "/fr/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___de",
    path: "/de/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___es",
    path: "/es/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-details___ro",
    path: "/ro/podcast/details/:title/:id",
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "podcast-episode___default",
    path: "/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___en",
    path: "/en/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___ar",
    path: "/ar/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___fr",
    path: "/fr/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___de",
    path: "/de/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___es",
    path: "/es/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "podcast-episode___ro",
    path: "/ro/podcast/episode/:title/:id",
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "video-details___default",
    path: "/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___en",
    path: "/en/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___ar",
    path: "/ar/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___fr",
    path: "/fr/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___de",
    path: "/de/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___es",
    path: "/es/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "video-details___ro",
    path: "/ro/video/details/:name/:id",
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ex-video-details___default",
    path: "/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___en",
    path: "/en/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___ar",
    path: "/ar/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___fr",
    path: "/fr/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___de",
    path: "/de/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___es",
    path: "/es/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ex-video-details___ro",
    path: "/ro/video/:ex/details/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "video-series___default",
    path: "/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___en",
    path: "/en/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___ar",
    path: "/ar/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___fr",
    path: "/fr/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___de",
    path: "/de/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___es",
    path: "/es/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-series___ro",
    path: "/ro/video/series/details/:name/:id",
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "video-stream___default",
    path: "/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___en",
    path: "/en/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___ar",
    path: "/ar/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___fr",
    path: "/fr/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___de",
    path: "/de/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___es",
    path: "/es/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-stream___ro",
    path: "/ro/video/stream/:name/:id",
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "video-category___default",
    path: "/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___en",
    path: "/en/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___ar",
    path: "/ar/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___fr",
    path: "/fr/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___de",
    path: "/de/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___es",
    path: "/es/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "video-category___ro",
    path: "/ro/video/category/:id",
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ex-video-stream___default",
    path: "/video/:ex/stream/:name/:id",
    meta: _91id_93LZFvzd3MRDMeta || {},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___en",
    path: "/en/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___ar",
    path: "/ar/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___fr",
    path: "/fr/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___de",
    path: "/de/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___es",
    path: "/es/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ex-video-stream___ro",
    path: "/ro/video/:ex/stream/:name/:id",
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "services-page___default",
    path: "/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___en",
    path: "/en/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___ar",
    path: "/ar/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___fr",
    path: "/fr/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___de",
    path: "/de/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___es",
    path: "/es/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "services-page___ro",
    path: "/ro/services/:name",
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "search-q___default",
    path: "/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___en",
    path: "/en/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___ar",
    path: "/ar/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___fr",
    path: "/fr/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___de",
    path: "/de/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___es",
    path: "/es/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "search-q___ro",
    path: "/ro/search-q",
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "vouchers-details-voucher___default",
    path: "/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___en",
    path: "/en/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___ar",
    path: "/ar/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___fr",
    path: "/fr/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___de",
    path: "/de/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___es",
    path: "/es/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "vouchers-details-voucher___ro",
    path: "/ro/vouchers/details/:id/:voucherId",
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "articles-category-article___default",
    path: "/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___en",
    path: "/en/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___ar",
    path: "/ar/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___fr",
    path: "/fr/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___de",
    path: "/de/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___es",
    path: "/es/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "articles-category-article___ro",
    path: "/ro/articles/:category?/:article",
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukapps-consent-id___default",
    path: "/uk/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___en",
    path: "/uk/en/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___ar",
    path: "/uk/ar/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___fr",
    path: "/uk/fr/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___de",
    path: "/uk/de/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___es",
    path: "/uk/es/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-consent-id___ro",
    path: "/uk/ro/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukapps-faq___default",
    path: "/uk/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___en",
    path: "/uk/en/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___ar",
    path: "/uk/ar/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___fr",
    path: "/uk/fr/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___de",
    path: "/uk/de/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___es",
    path: "/uk/es/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-faq___ro",
    path: "/uk/ro/apps/faq",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "ukapps-manage-id___default",
    path: "/uk/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___en",
    path: "/uk/en/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___ar",
    path: "/uk/ar/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___fr",
    path: "/uk/fr/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___de",
    path: "/uk/de/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___es",
    path: "/uk/es/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage-id___ro",
    path: "/uk/ro/apps/manage/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukapps-manage___default",
    path: "/uk/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___en",
    path: "/uk/en/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___ar",
    path: "/uk/ar/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___fr",
    path: "/uk/fr/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___de",
    path: "/uk/de/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___es",
    path: "/uk/es/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-manage___ro",
    path: "/uk/ro/apps/manage",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "ukapps-partner-name___default",
    path: "/uk/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___en",
    path: "/uk/en/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___ar",
    path: "/uk/ar/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___fr",
    path: "/uk/fr/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___de",
    path: "/uk/de/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___es",
    path: "/uk/es/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-partner-name___ro",
    path: "/uk/ro/apps/partner/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukapps-pd-name___default",
    path: "/uk/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___en",
    path: "/uk/en/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___ar",
    path: "/uk/ar/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___fr",
    path: "/uk/fr/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___de",
    path: "/uk/de/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___es",
    path: "/uk/es/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-pd-name___ro",
    path: "/uk/ro/apps/pd/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukapps-profile___default",
    path: "/uk/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___en",
    path: "/uk/en/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___ar",
    path: "/uk/ar/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___fr",
    path: "/uk/fr/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___de",
    path: "/uk/de/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___es",
    path: "/uk/es/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-profile___ro",
    path: "/uk/ro/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "ukapps-register___default",
    path: "/uk/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___en",
    path: "/uk/en/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___ar",
    path: "/uk/ar/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___fr",
    path: "/uk/fr/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___de",
    path: "/uk/de/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___es",
    path: "/uk/es/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-register___ro",
    path: "/uk/ro/apps/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "ukapps-viewAll___default",
    path: "/uk/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___en",
    path: "/uk/en/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___ar",
    path: "/uk/ar/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___fr",
    path: "/uk/fr/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___de",
    path: "/uk/de/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___es",
    path: "/uk/es/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukapps-viewAll___ro",
    path: "/uk/ro/apps/viewAll",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "ukarcade-details-id___default",
    path: "/uk/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___en",
    path: "/uk/en/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___ar",
    path: "/uk/ar/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___fr",
    path: "/uk/fr/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___de",
    path: "/uk/de/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___es",
    path: "/uk/es/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details-id___ro",
    path: "/uk/ro/arcade/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___default",
    path: "/uk/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___en",
    path: "/uk/en/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___ar",
    path: "/uk/ar/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___fr",
    path: "/uk/fr/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___de",
    path: "/uk/de/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___es",
    path: "/uk/es/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory-article___ro",
    path: "/uk/ro/articles/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-subcategory___default",
    path: "/uk/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___en",
    path: "/uk/en/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___ar",
    path: "/uk/ar/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___fr",
    path: "/uk/fr/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___de",
    path: "/uk/de/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___es",
    path: "/uk/es/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category-subcategory___ro",
    path: "/uk/ro/articles/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-category___default",
    path: "/uk/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___en",
    path: "/uk/en/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___ar",
    path: "/uk/ar/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___fr",
    path: "/uk/fr/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___de",
    path: "/uk/de/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___es",
    path: "/uk/es/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-category___ro",
    path: "/uk/ro/articles/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___default",
    path: "/uk/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___en",
    path: "/uk/en/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___ar",
    path: "/uk/ar/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___fr",
    path: "/uk/fr/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___de",
    path: "/uk/de/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___es",
    path: "/uk/es/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory-article___ro",
    path: "/uk/ro/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___default",
    path: "/uk/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___en",
    path: "/uk/en/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___ar",
    path: "/uk/ar/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___fr",
    path: "/uk/fr/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___de",
    path: "/uk/de/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___es",
    path: "/uk/es/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category-subcategory___ro",
    path: "/uk/ro/articles/premium/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "ukarticles-premium-category___default",
    path: "/uk/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___en",
    path: "/uk/en/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___ar",
    path: "/uk/ar/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___fr",
    path: "/uk/fr/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___de",
    path: "/uk/de/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___es",
    path: "/uk/es/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium-category___ro",
    path: "/uk/ro/articles/premium/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "ukarticles-premium___default",
    path: "/uk/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___en",
    path: "/uk/en/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___ar",
    path: "/uk/ar/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___fr",
    path: "/uk/fr/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___de",
    path: "/uk/de/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___es",
    path: "/uk/es/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukarticles-premium___ro",
    path: "/uk/ro/articles/premium",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "ukaudiobook-artists-id___default",
    path: "/uk/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___en",
    path: "/uk/en/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___ar",
    path: "/uk/ar/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___fr",
    path: "/uk/fr/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___de",
    path: "/uk/de/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___es",
    path: "/uk/es/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists-id___ro",
    path: "/uk/ro/audiobook/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-category___default",
    path: "/uk/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___en",
    path: "/uk/en/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___ar",
    path: "/uk/ar/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___fr",
    path: "/uk/fr/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___de",
    path: "/uk/de/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___es",
    path: "/uk/es/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-category___ro",
    path: "/uk/ro/audiobook/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "ukaudiobook-details-id___default",
    path: "/uk/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___en",
    path: "/uk/en/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___ar",
    path: "/uk/ar/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___fr",
    path: "/uk/fr/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___de",
    path: "/uk/de/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___es",
    path: "/uk/es/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details-id___ro",
    path: "/uk/ro/audiobook/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-genre-name___default",
    path: "/uk/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___en",
    path: "/uk/en/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___ar",
    path: "/uk/ar/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___fr",
    path: "/uk/fr/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___de",
    path: "/uk/de/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___es",
    path: "/uk/es/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-genre-name___ro",
    path: "/uk/ro/audiobook/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "ukaudiobook-list___default",
    path: "/uk/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___en",
    path: "/uk/en/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___ar",
    path: "/uk/ar/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___fr",
    path: "/uk/fr/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___de",
    path: "/uk/de/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___es",
    path: "/uk/es/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukaudiobook-list___ro",
    path: "/uk/ro/audiobook/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "ukbilling-history___default",
    path: "/uk/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___en",
    path: "/uk/en/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___ar",
    path: "/uk/ar/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___fr",
    path: "/uk/fr/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___de",
    path: "/uk/de/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___es",
    path: "/uk/es/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukbilling-history___ro",
    path: "/uk/ro/billing-history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "ukexternal-logout___default",
    path: "/uk/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___en",
    path: "/uk/en/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___ar",
    path: "/uk/ar/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___fr",
    path: "/uk/fr/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___de",
    path: "/uk/de/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___es",
    path: "/uk/es/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukexternal-logout___ro",
    path: "/uk/ro/external/logout",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "ukfavorites___default",
    path: "/uk/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___en",
    path: "/uk/en/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___ar",
    path: "/uk/ar/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___fr",
    path: "/uk/fr/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___de",
    path: "/uk/de/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___es",
    path: "/uk/es/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukfavorites___ro",
    path: "/uk/ro/favorites",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "ukgames-category-name___default",
    path: "/uk/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___en",
    path: "/uk/en/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___ar",
    path: "/uk/ar/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___fr",
    path: "/uk/fr/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___de",
    path: "/uk/de/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___es",
    path: "/uk/es/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category-name___ro",
    path: "/uk/ro/games/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-details-id___default",
    path: "/uk/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___en",
    path: "/uk/en/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___ar",
    path: "/uk/ar/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___fr",
    path: "/uk/fr/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___de",
    path: "/uk/de/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___es",
    path: "/uk/es/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details-id___ro",
    path: "/uk/ro/games/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-list-name-id___default",
    path: "/uk/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___en",
    path: "/uk/en/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___ar",
    path: "/uk/ar/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___fr",
    path: "/uk/fr/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___de",
    path: "/uk/de/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___es",
    path: "/uk/es/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name-id___ro",
    path: "/uk/ro/games/list/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "ukgames-list-name___default",
    path: "/uk/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___en",
    path: "/uk/en/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___ar",
    path: "/uk/ar/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___fr",
    path: "/uk/fr/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___de",
    path: "/uk/de/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___es",
    path: "/uk/es/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list-name___ro",
    path: "/uk/ro/games/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___default",
    path: "/uk/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___en",
    path: "/uk/en/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___ar",
    path: "/uk/ar/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___fr",
    path: "/uk/fr/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___de",
    path: "/uk/de/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___es",
    path: "/uk/es/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukgames-publisher-name___ro",
    path: "/uk/ro/games/publisher/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "ukhistory___default",
    path: "/uk/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___en",
    path: "/uk/en/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___ar",
    path: "/uk/ar/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___fr",
    path: "/uk/fr/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___de",
    path: "/uk/de/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___es",
    path: "/uk/es/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukhistory___ro",
    path: "/uk/ro/history",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "ukimpressum___default",
    path: "/uk/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___en",
    path: "/uk/en/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___ar",
    path: "/uk/ar/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___fr",
    path: "/uk/fr/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___de",
    path: "/uk/de/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___es",
    path: "/uk/es/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukimpressum___ro",
    path: "/uk/ro/impressum",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "ukindex___default",
    path: "/uk/",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___en",
    path: "/uk/en",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___ar",
    path: "/uk/ar",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___fr",
    path: "/uk/fr",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___de",
    path: "/uk/de",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___es",
    path: "/uk/es",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukindex___ro",
    path: "/uk/ro",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "ukinfo-name___default",
    path: "/uk/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___en",
    path: "/uk/en/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___ar",
    path: "/uk/ar/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___fr",
    path: "/uk/fr/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___de",
    path: "/uk/de/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___es",
    path: "/uk/es/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinfo-name___ro",
    path: "/uk/ro/info/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "ukinternal-redirect___default",
    path: "/uk/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___en",
    path: "/uk/en/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___ar",
    path: "/uk/ar/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___fr",
    path: "/uk/fr/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___de",
    path: "/uk/de/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___es",
    path: "/uk/es/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "ukinternal-redirect___ro",
    path: "/uk/ro/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "uklaunch___default",
    path: "/uk/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___en",
    path: "/uk/en/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___ar",
    path: "/uk/ar/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___fr",
    path: "/uk/fr/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___de",
    path: "/uk/de/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___es",
    path: "/uk/es/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "uklaunch___ro",
    path: "/uk/ro/launch",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "ukmain-name___default",
    path: "/uk/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___en",
    path: "/uk/en/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___ar",
    path: "/uk/ar/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___fr",
    path: "/uk/fr/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___de",
    path: "/uk/de/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___es",
    path: "/uk/es/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain-name___ro",
    path: "/uk/ro/main/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmarketing-name___default",
    path: "/uk/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___en",
    path: "/uk/en/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___ar",
    path: "/uk/ar/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___fr",
    path: "/uk/fr/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___de",
    path: "/uk/de/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___es",
    path: "/uk/es/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmarketing-name___ro",
    path: "/uk/ro/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "ukmp-category___default",
    path: "/uk/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___en",
    path: "/uk/en/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___ar",
    path: "/uk/ar/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___fr",
    path: "/uk/fr/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___de",
    path: "/uk/de/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___es",
    path: "/uk/es/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-category___ro",
    path: "/uk/ro/mp/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmp-name___default",
    path: "/uk/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___en",
    path: "/uk/en/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___ar",
    path: "/uk/ar/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___fr",
    path: "/uk/fr/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___de",
    path: "/uk/de/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___es",
    path: "/uk/es/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmp-name___ro",
    path: "/uk/ro/mp/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukmusic-albums-artist-album___default",
    path: "/uk/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___en",
    path: "/uk/en/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___ar",
    path: "/uk/ar/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___fr",
    path: "/uk/fr/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___de",
    path: "/uk/de/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___es",
    path: "/uk/es/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-artist-album___ro",
    path: "/uk/ro/music/albums/:artist()/:album()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-albums-category-name___default",
    path: "/uk/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___en",
    path: "/uk/en/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___ar",
    path: "/uk/ar/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___fr",
    path: "/uk/fr/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___de",
    path: "/uk/de/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___es",
    path: "/uk/es/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums-category-name___ro",
    path: "/uk/ro/music/albums/category/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "ukmusic-albums___default",
    path: "/uk/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___en",
    path: "/uk/en/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___ar",
    path: "/uk/ar/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___fr",
    path: "/uk/fr/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___de",
    path: "/uk/de/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___es",
    path: "/uk/es/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-albums___ro",
    path: "/uk/ro/music/albums",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "ukmusic-artists-id___default",
    path: "/uk/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___en",
    path: "/uk/en/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___ar",
    path: "/uk/ar/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___fr",
    path: "/uk/fr/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___de",
    path: "/uk/de/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___es",
    path: "/uk/es/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artists-id___ro",
    path: "/uk/ro/music/artists/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-genre-name___default",
    path: "/uk/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___en",
    path: "/uk/en/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___ar",
    path: "/uk/ar/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___fr",
    path: "/uk/fr/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___de",
    path: "/uk/de/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___es",
    path: "/uk/es/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-genre-name___ro",
    path: "/uk/ro/music/genre/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "ukmusic-list___default",
    path: "/uk/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___en",
    path: "/uk/en/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___ar",
    path: "/uk/ar/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___fr",
    path: "/uk/fr/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___de",
    path: "/uk/de/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___es",
    path: "/uk/es/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-list___ro",
    path: "/uk/ro/music/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "ukmusic-playlists-playlist___default",
    path: "/uk/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___en",
    path: "/uk/en/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___ar",
    path: "/uk/ar/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___fr",
    path: "/uk/fr/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___de",
    path: "/uk/de/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___es",
    path: "/uk/es/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists-playlist___ro",
    path: "/uk/ro/music/playlists/:playlist()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlists___default",
    path: "/uk/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___en",
    path: "/uk/en/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___ar",
    path: "/uk/ar/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___fr",
    path: "/uk/fr/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___de",
    path: "/uk/de/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___es",
    path: "/uk/es/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-playlists___ro",
    path: "/uk/ro/music/playlists",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "ukmusic-tracks-track___default",
    path: "/uk/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___en",
    path: "/uk/en/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___ar",
    path: "/uk/ar/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___fr",
    path: "/uk/fr/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___de",
    path: "/uk/de/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___es",
    path: "/uk/es/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-track___ro",
    path: "/uk/ro/music/tracks/:track()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-tracks-category___default",
    path: "/uk/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___en",
    path: "/uk/en/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___ar",
    path: "/uk/ar/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___fr",
    path: "/uk/fr/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___de",
    path: "/uk/de/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___es",
    path: "/uk/es/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks-category___ro",
    path: "/uk/ro/music/tracks/category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "ukmusic-tracks___default",
    path: "/uk/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___en",
    path: "/uk/en/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___ar",
    path: "/uk/ar/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___fr",
    path: "/uk/fr/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___de",
    path: "/uk/de/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___es",
    path: "/uk/es/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-tracks___ro",
    path: "/uk/ro/music/tracks",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "ukmusic-video-details-id___default",
    path: "/uk/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___en",
    path: "/uk/en/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___ar",
    path: "/uk/ar/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___fr",
    path: "/uk/fr/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___de",
    path: "/uk/de/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___es",
    path: "/uk/es/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmusic-video-details-id___ro",
    path: "/uk/ro/music/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "ukmyCart___default",
    path: "/uk/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___en",
    path: "/uk/en/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___ar",
    path: "/uk/ar/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___fr",
    path: "/uk/fr/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___de",
    path: "/uk/de/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___es",
    path: "/uk/es/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukmyCart___ro",
    path: "/uk/ro/myCart",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "ukMyPaymentMethods___default",
    path: "/uk/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___en",
    path: "/uk/en/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___ar",
    path: "/uk/ar/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___fr",
    path: "/uk/fr/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___de",
    path: "/uk/de/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___es",
    path: "/uk/es/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukMyPaymentMethods___ro",
    path: "/uk/ro/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "ukmyPurchases___default",
    path: "/uk/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___en",
    path: "/uk/en/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___ar",
    path: "/uk/ar/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___fr",
    path: "/uk/fr/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___de",
    path: "/uk/de/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___es",
    path: "/uk/es/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "ukmyPurchases___ro",
    path: "/uk/ro/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___default",
    path: "/uk/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___en",
    path: "/uk/en/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___ar",
    path: "/uk/ar/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___fr",
    path: "/uk/fr/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___de",
    path: "/uk/de/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___es",
    path: "/uk/es/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory-articlename-article___ro",
    path: "/uk/ro/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "uknews-category-subcategory___default",
    path: "/uk/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___en",
    path: "/uk/en/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___ar",
    path: "/uk/ar/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___fr",
    path: "/uk/fr/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___de",
    path: "/uk/de/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___es",
    path: "/uk/es/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category-subcategory___ro",
    path: "/uk/ro/news/:category()/:subcategory()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "uknews-category___default",
    path: "/uk/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___en",
    path: "/uk/en/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___ar",
    path: "/uk/ar/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___fr",
    path: "/uk/fr/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___de",
    path: "/uk/de/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___es",
    path: "/uk/es/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknews-category___ro",
    path: "/uk/ro/news/:category()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "uknotifications___default",
    path: "/uk/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___en",
    path: "/uk/en/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___ar",
    path: "/uk/ar/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___fr",
    path: "/uk/fr/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___de",
    path: "/uk/de/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___es",
    path: "/uk/es/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "uknotifications___ro",
    path: "/uk/ro/notifications",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "ukparentalControl___default",
    path: "/uk/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___en",
    path: "/uk/en/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___ar",
    path: "/uk/ar/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___fr",
    path: "/uk/fr/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___de",
    path: "/uk/de/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___es",
    path: "/uk/es/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukparentalControl___ro",
    path: "/uk/ro/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "ukpartner-registration___default",
    path: "/uk/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___en",
    path: "/uk/en/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___ar",
    path: "/uk/ar/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___fr",
    path: "/uk/fr/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___de",
    path: "/uk/de/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___es",
    path: "/uk/es/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-registration___ro",
    path: "/uk/ro/partner-registration",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "ukpartner-subscriptions-id___default",
    path: "/uk/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___en",
    path: "/uk/en/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___ar",
    path: "/uk/ar/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___fr",
    path: "/uk/fr/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___de",
    path: "/uk/de/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___es",
    path: "/uk/es/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions-id___ro",
    path: "/uk/ro/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "ukpartner-subscriptions___default",
    path: "/uk/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___en",
    path: "/uk/en/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___ar",
    path: "/uk/ar/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___fr",
    path: "/uk/fr/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___de",
    path: "/uk/de/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___es",
    path: "/uk/es/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartner-subscriptions___ro",
    path: "/uk/ro/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "ukpartners-name___default",
    path: "/uk/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___en",
    path: "/uk/en/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___ar",
    path: "/uk/ar/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___fr",
    path: "/uk/fr/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___de",
    path: "/uk/de/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___es",
    path: "/uk/es/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-name___ro",
    path: "/uk/ro/partners/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___default",
    path: "/uk/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___en",
    path: "/uk/en/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___ar",
    path: "/uk/ar/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___fr",
    path: "/uk/fr/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___de",
    path: "/uk/de/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___es",
    path: "/uk/es/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services-name___ro",
    path: "/uk/ro/partners/info-services/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "ukpartners-info-services___default",
    path: "/uk/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___en",
    path: "/uk/en/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___ar",
    path: "/uk/ar/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___fr",
    path: "/uk/fr/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___de",
    path: "/uk/de/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___es",
    path: "/uk/es/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpartners-info-services___ro",
    path: "/uk/ro/partners/info-services",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "ukpodcast-details-id___default",
    path: "/uk/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___en",
    path: "/uk/en/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___ar",
    path: "/uk/ar/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___fr",
    path: "/uk/fr/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___de",
    path: "/uk/de/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___es",
    path: "/uk/es/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details-id___ro",
    path: "/uk/ro/podcast/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___default",
    path: "/uk/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___en",
    path: "/uk/en/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___ar",
    path: "/uk/ar/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___fr",
    path: "/uk/fr/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___de",
    path: "/uk/de/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___es",
    path: "/uk/es/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode-id___ro",
    path: "/uk/ro/podcast/episode/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-list___default",
    path: "/uk/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___en",
    path: "/uk/en/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___ar",
    path: "/uk/ar/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___fr",
    path: "/uk/fr/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___de",
    path: "/uk/de/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___es",
    path: "/uk/es/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukpodcast-list___ro",
    path: "/uk/ro/podcast/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "ukprofile___default",
    path: "/uk/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___en",
    path: "/uk/en/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___ar",
    path: "/uk/ar/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___fr",
    path: "/uk/fr/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___de",
    path: "/uk/de/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___es",
    path: "/uk/es/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile___ro",
    path: "/uk/ro/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___default",
    path: "/uk/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___en",
    path: "/uk/en/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___ar",
    path: "/uk/ar/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___fr",
    path: "/uk/fr/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___de",
    path: "/uk/de/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___es",
    path: "/uk/es/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info-service-subscriptions___ro",
    path: "/uk/ro/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "ukprofile-info___default",
    path: "/uk/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___en",
    path: "/uk/en/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___ar",
    path: "/uk/ar/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___fr",
    path: "/uk/fr/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___de",
    path: "/uk/de/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___es",
    path: "/uk/es/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-info___ro",
    path: "/uk/ro/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "ukprofile-manage___default",
    path: "/uk/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___en",
    path: "/uk/en/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___ar",
    path: "/uk/ar/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___fr",
    path: "/uk/fr/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___de",
    path: "/uk/de/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___es",
    path: "/uk/es/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-manage___ro",
    path: "/uk/ro/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "ukprofile-preferences___default",
    path: "/uk/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___en",
    path: "/uk/en/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___ar",
    path: "/uk/ar/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___fr",
    path: "/uk/fr/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___de",
    path: "/uk/de/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___es",
    path: "/uk/es/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-preferences___ro",
    path: "/uk/ro/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "ukprofile-privacy-settings___default",
    path: "/uk/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___en",
    path: "/uk/en/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___ar",
    path: "/uk/ar/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___fr",
    path: "/uk/fr/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___de",
    path: "/uk/de/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___es",
    path: "/uk/es/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukprofile-privacy-settings___ro",
    path: "/uk/ro/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "ukresetpassword___default",
    path: "/uk/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___en",
    path: "/uk/en/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___ar",
    path: "/uk/ar/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___fr",
    path: "/uk/fr/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___de",
    path: "/uk/de/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___es",
    path: "/uk/es/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukresetpassword___ro",
    path: "/uk/ro/resetpassword",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "ukreward___default",
    path: "/uk/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___en",
    path: "/uk/en/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___ar",
    path: "/uk/ar/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___fr",
    path: "/uk/fr/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___de",
    path: "/uk/de/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___es",
    path: "/uk/es/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ukreward___ro",
    path: "/uk/ro/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "uksearch___default",
    path: "/uk/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___en",
    path: "/uk/en/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___ar",
    path: "/uk/ar/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___fr",
    path: "/uk/fr/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___de",
    path: "/uk/de/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___es",
    path: "/uk/es/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch___ro",
    path: "/uk/ro/search",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksubscription___default",
    path: "/uk/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___en",
    path: "/uk/en/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___ar",
    path: "/uk/ar/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___fr",
    path: "/uk/fr/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___de",
    path: "/uk/de/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___es",
    path: "/uk/es/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uksubscription___ro",
    path: "/uk/ro/subscription",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "uktournaments-details-id___default",
    path: "/uk/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___en",
    path: "/uk/en/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___ar",
    path: "/uk/ar/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___fr",
    path: "/uk/fr/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___de",
    path: "/uk/de/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___es",
    path: "/uk/es/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-details-id___ro",
    path: "/uk/ro/tournaments/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___default",
    path: "/uk/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___en",
    path: "/uk/en/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___ar",
    path: "/uk/ar/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___fr",
    path: "/uk/fr/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___de",
    path: "/uk/de/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___es",
    path: "/uk/es/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-news-details-id___ro",
    path: "/uk/ro/tournaments/news/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___default",
    path: "/uk/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___en",
    path: "/uk/en/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___ar",
    path: "/uk/ar/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___fr",
    path: "/uk/fr/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___de",
    path: "/uk/de/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___es",
    path: "/uk/es/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "uktournaments-videos-details-id___ro",
    path: "/uk/ro/tournaments/videos/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "ukuser-login-email___default",
    path: "/uk/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___en",
    path: "/uk/en/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___ar",
    path: "/uk/ar/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___fr",
    path: "/uk/fr/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___de",
    path: "/uk/de/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___es",
    path: "/uk/es/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login-email___ro",
    path: "/uk/ro/user/login/email",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "ukuser-login___default",
    path: "/uk/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___en",
    path: "/uk/en/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___ar",
    path: "/uk/ar/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___fr",
    path: "/uk/fr/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___de",
    path: "/uk/de/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___es",
    path: "/uk/es/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-login___ro",
    path: "/uk/ro/user/login",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "ukuser-register___default",
    path: "/uk/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___en",
    path: "/uk/en/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___ar",
    path: "/uk/ar/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___fr",
    path: "/uk/fr/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___de",
    path: "/uk/de/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___es",
    path: "/uk/es/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukuser-register___ro",
    path: "/uk/ro/user/register",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "ukvideo-ex-category-id___default",
    path: "/uk/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___en",
    path: "/uk/en/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___ar",
    path: "/uk/ar/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___fr",
    path: "/uk/fr/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___de",
    path: "/uk/de/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___es",
    path: "/uk/es/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-category-id___ro",
    path: "/uk/ro/video/:ex()/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___default",
    path: "/uk/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___en",
    path: "/uk/en/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___ar",
    path: "/uk/ar/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___fr",
    path: "/uk/fr/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___de",
    path: "/uk/de/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___es",
    path: "/uk/es/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-details-id___ro",
    path: "/uk/ro/video/:ex()/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___default",
    path: "/uk/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___en",
    path: "/uk/en/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___ar",
    path: "/uk/ar/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___fr",
    path: "/uk/fr/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___de",
    path: "/uk/de/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___es",
    path: "/uk/es/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-ex-stream-id___ro",
    path: "/uk/ro/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"uk"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___default",
    path: "/uk/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___en",
    path: "/uk/en/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___ar",
    path: "/uk/ar/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___fr",
    path: "/uk/fr/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___de",
    path: "/uk/de/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___es",
    path: "/uk/es/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category-name-id___ro",
    path: "/uk/ro/video/category/:name()/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-details-id___default",
    path: "/uk/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___en",
    path: "/uk/en/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___ar",
    path: "/uk/ar/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___fr",
    path: "/uk/fr/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___de",
    path: "/uk/de/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___es",
    path: "/uk/es/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details-id___ro",
    path: "/uk/ro/video/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-list-name___default",
    path: "/uk/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___en",
    path: "/uk/en/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___ar",
    path: "/uk/ar/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___fr",
    path: "/uk/fr/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___de",
    path: "/uk/de/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___es",
    path: "/uk/es/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-list-name___ro",
    path: "/uk/ro/video/list/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "ukvideo-series-details-id___default",
    path: "/uk/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___en",
    path: "/uk/en/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___ar",
    path: "/uk/ar/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___fr",
    path: "/uk/fr/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___de",
    path: "/uk/de/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___es",
    path: "/uk/es/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series-details-id___ro",
    path: "/uk/ro/video/series/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-stream-id___default",
    path: "/uk/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___en",
    path: "/uk/en/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___ar",
    path: "/uk/ar/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___fr",
    path: "/uk/fr/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___de",
    path: "/uk/de/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___es",
    path: "/uk/es/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream-id___ro",
    path: "/uk/ro/video/stream/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-test___default",
    path: "/uk/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___en",
    path: "/uk/en/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___ar",
    path: "/uk/ar/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___fr",
    path: "/uk/fr/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___de",
    path: "/uk/de/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___es",
    path: "/uk/es/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvideo-test___ro",
    path: "/uk/ro/video/test",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "ukvoucherbooks-name___default",
    path: "/uk/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___en",
    path: "/uk/en/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___ar",
    path: "/uk/ar/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___fr",
    path: "/uk/fr/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___de",
    path: "/uk/de/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___es",
    path: "/uk/es/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvoucherbooks-name___ro",
    path: "/uk/ro/voucherbooks/:name()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "ukvouchers-category-id___default",
    path: "/uk/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___en",
    path: "/uk/en/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___ar",
    path: "/uk/ar/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___fr",
    path: "/uk/fr/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___de",
    path: "/uk/de/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___es",
    path: "/uk/es/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-category-id___ro",
    path: "/uk/ro/vouchers/category/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "ukvouchers-details-id___default",
    path: "/uk/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___en",
    path: "/uk/en/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___ar",
    path: "/uk/ar/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___fr",
    path: "/uk/fr/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___de",
    path: "/uk/de/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___es",
    path: "/uk/es/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-id___ro",
    path: "/uk/ro/vouchers/details/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___default",
    path: "/uk/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___en",
    path: "/uk/en/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___ar",
    path: "/uk/ar/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___fr",
    path: "/uk/fr/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___de",
    path: "/uk/de/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___es",
    path: "/uk/es/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukvouchers-genre-id___ro",
    path: "/uk/ro/vouchers/genre/:id()",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "ukmain___default",
    path: "/uk/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___en",
    path: "/uk/en/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___ar",
    path: "/uk/ar/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___fr",
    path: "/uk/fr/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___de",
    path: "/uk/de/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___es",
    path: "/uk/es/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmain___ro",
    path: "/uk/ro/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "ukmusic-track___default",
    path: "/uk/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___en",
    path: "/uk/en/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___ar",
    path: "/uk/ar/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___fr",
    path: "/uk/fr/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___de",
    path: "/uk/de/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___es",
    path: "/uk/es/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmusic-track___ro",
    path: "/uk/ro/music/tracks/:title/:track",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___default",
    path: "/uk/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___en",
    path: "/uk/en/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___ar",
    path: "/uk/ar/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___fr",
    path: "/uk/fr/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___de",
    path: "/uk/de/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___es",
    path: "/uk/es/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-consent-details___ro",
    path: "/uk/ro/apps/consent/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___default",
    path: "/uk/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___en",
    path: "/uk/en/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___ar",
    path: "/uk/ar/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___fr",
    path: "/uk/fr/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___de",
    path: "/uk/de/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___es",
    path: "/uk/es/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-detail___ro",
    path: "/uk/ro/apps/partner/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___default",
    path: "/uk/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___en",
    path: "/uk/en/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___ar",
    path: "/uk/ar/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___fr",
    path: "/uk/fr/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___de",
    path: "/uk/de/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___es",
    path: "/uk/es/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukmonsooq-app-partner-details___ro",
    path: "/uk/ro/apps/pd/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "ukment-app-partner-details___default",
    path: "/uk/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___en",
    path: "/uk/en/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___ar",
    path: "/uk/ar/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___fr",
    path: "/uk/fr/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___de",
    path: "/uk/de/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___es",
    path: "/uk/es/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-details___ro",
    path: "/uk/ro/mp/:title/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "ukment-app-partner-categories-details___default",
    path: "/uk/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___en",
    path: "/uk/en/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___ar",
    path: "/uk/ar/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___fr",
    path: "/uk/fr/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___de",
    path: "/uk/de/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___es",
    path: "/uk/es/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukment-app-partner-categories-details___ro",
    path: "/uk/ro/mp/:category",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "ukmanage-subscription-details___default",
    path: "/uk/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___en",
    path: "/uk/en/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___ar",
    path: "/uk/ar/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___fr",
    path: "/uk/fr/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___de",
    path: "/uk/de/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___es",
    path: "/uk/es/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmanage-subscription-details___ro",
    path: "/uk/ro/apps/manage/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "ukmusic-artistName-albumName___default",
    path: "/uk/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___en",
    path: "/uk/en/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___ar",
    path: "/uk/ar/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___fr",
    path: "/uk/fr/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___de",
    path: "/uk/de/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___es",
    path: "/uk/es/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artistName-albumName___ro",
    path: "/uk/ro/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "ukmusic-artist___default",
    path: "/uk/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___en",
    path: "/uk/en/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___ar",
    path: "/uk/ar/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___fr",
    path: "/uk/fr/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___de",
    path: "/uk/de/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___es",
    path: "/uk/es/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-artist___ro",
    path: "/uk/ro/music/artists/:artistName/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "ukmusic-playlist___default",
    path: "/uk/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___en",
    path: "/uk/en/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___ar",
    path: "/uk/ar/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___fr",
    path: "/uk/fr/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___de",
    path: "/uk/de/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___es",
    path: "/uk/es/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukmusic-playlist___ro",
    path: "/uk/ro/music/playlists/:title/:playlist",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "ukpodcast-details___default",
    path: "/uk/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___en",
    path: "/uk/en/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___ar",
    path: "/uk/ar/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___fr",
    path: "/uk/fr/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___de",
    path: "/uk/de/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___es",
    path: "/uk/es/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___ro",
    path: "/uk/ro/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-episode___default",
    path: "/uk/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___en",
    path: "/uk/en/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___ar",
    path: "/uk/ar/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___fr",
    path: "/uk/fr/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___de",
    path: "/uk/de/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___es",
    path: "/uk/es/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___ro",
    path: "/uk/ro/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukaudiobook-details___default",
    path: "/uk/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___en",
    path: "/uk/en/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___ar",
    path: "/uk/ar/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___fr",
    path: "/uk/fr/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___de",
    path: "/uk/de/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___es",
    path: "/uk/es/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-details___ro",
    path: "/uk/ro/audiobook/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "ukaudiobook-artists___default",
    path: "/uk/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___en",
    path: "/uk/en/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___ar",
    path: "/uk/ar/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___fr",
    path: "/uk/fr/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___de",
    path: "/uk/de/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___es",
    path: "/uk/es/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukaudiobook-artists___ro",
    path: "/uk/ro/audiobook/artists/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "ukgames-category___default",
    path: "/uk/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___en",
    path: "/uk/en/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___ar",
    path: "/uk/ar/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___fr",
    path: "/uk/fr/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___de",
    path: "/uk/de/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___es",
    path: "/uk/es/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-category___ro",
    path: "/uk/ro/games/category/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "ukgames-details___default",
    path: "/uk/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___en",
    path: "/uk/en/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___ar",
    path: "/uk/ar/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___fr",
    path: "/uk/fr/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___de",
    path: "/uk/de/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___es",
    path: "/uk/es/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-details___ro",
    path: "/uk/ro/games/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "ukgames-list___default",
    path: "/uk/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___en",
    path: "/uk/en/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___ar",
    path: "/uk/ar/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___fr",
    path: "/uk/fr/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___de",
    path: "/uk/de/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___es",
    path: "/uk/es/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukgames-list___ro",
    path: "/uk/ro/games/list",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "ukarcade-details___default",
    path: "/uk/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___en",
    path: "/uk/en/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___ar",
    path: "/uk/ar/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___fr",
    path: "/uk/fr/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___de",
    path: "/uk/de/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___es",
    path: "/uk/es/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukarcade-details___ro",
    path: "/uk/ro/arcade/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "ukpodcast-details___default",
    path: "/uk/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___en",
    path: "/uk/en/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___ar",
    path: "/uk/ar/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___fr",
    path: "/uk/fr/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___de",
    path: "/uk/de/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___es",
    path: "/uk/es/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-details___ro",
    path: "/uk/ro/podcast/details/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "ukpodcast-episode___default",
    path: "/uk/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___en",
    path: "/uk/en/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___ar",
    path: "/uk/ar/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___fr",
    path: "/uk/fr/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___de",
    path: "/uk/de/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___es",
    path: "/uk/es/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukpodcast-episode___ro",
    path: "/uk/ro/podcast/episode/:title/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "ukvideo-details___default",
    path: "/uk/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___en",
    path: "/uk/en/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___ar",
    path: "/uk/ar/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___fr",
    path: "/uk/fr/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___de",
    path: "/uk/de/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___es",
    path: "/uk/es/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukvideo-details___ro",
    path: "/uk/ro/video/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "ukex-video-details___default",
    path: "/uk/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___en",
    path: "/uk/en/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___ar",
    path: "/uk/ar/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___fr",
    path: "/uk/fr/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___de",
    path: "/uk/de/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___es",
    path: "/uk/es/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukex-video-details___ro",
    path: "/uk/ro/video/:ex/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "ukvideo-series___default",
    path: "/uk/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___en",
    path: "/uk/en/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___ar",
    path: "/uk/ar/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___fr",
    path: "/uk/fr/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___de",
    path: "/uk/de/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___es",
    path: "/uk/es/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-series___ro",
    path: "/uk/ro/video/series/details/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "ukvideo-stream___default",
    path: "/uk/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___en",
    path: "/uk/en/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___ar",
    path: "/uk/ar/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___fr",
    path: "/uk/fr/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___de",
    path: "/uk/de/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___es",
    path: "/uk/es/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-stream___ro",
    path: "/uk/ro/video/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "ukvideo-category___default",
    path: "/uk/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___en",
    path: "/uk/en/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___ar",
    path: "/uk/ar/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___fr",
    path: "/uk/fr/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___de",
    path: "/uk/de/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___es",
    path: "/uk/es/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukvideo-category___ro",
    path: "/uk/ro/video/category/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "ukex-video-stream___default",
    path: "/uk/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___en",
    path: "/uk/en/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___ar",
    path: "/uk/ar/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___fr",
    path: "/uk/fr/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___de",
    path: "/uk/de/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___es",
    path: "/uk/es/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukex-video-stream___ro",
    path: "/uk/ro/video/:ex/stream/:name/:id",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "ukservices-page___default",
    path: "/uk/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___en",
    path: "/uk/en/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___ar",
    path: "/uk/ar/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___fr",
    path: "/uk/fr/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___de",
    path: "/uk/de/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___es",
    path: "/uk/es/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ukservices-page___ro",
    path: "/uk/ro/services/:name",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "uksearch-q___default",
    path: "/uk/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___en",
    path: "/uk/en/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___ar",
    path: "/uk/ar/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___fr",
    path: "/uk/fr/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___de",
    path: "/uk/de/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___es",
    path: "/uk/es/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "uksearch-q___ro",
    path: "/uk/ro/search-q",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ukvouchers-details-voucher___default",
    path: "/uk/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___en",
    path: "/uk/en/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___ar",
    path: "/uk/ar/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___fr",
    path: "/uk/fr/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___de",
    path: "/uk/de/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___es",
    path: "/uk/es/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukvouchers-details-voucher___ro",
    path: "/uk/ro/vouchers/details/:id/:voucherId",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "ukarticles-category-article___default",
    path: "/uk/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___en",
    path: "/uk/en/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___ar",
    path: "/uk/ar/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___fr",
    path: "/uk/fr/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___de",
    path: "/uk/de/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___es",
    path: "/uk/es/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "ukarticles-category-article___ro",
    path: "/uk/ro/articles/:category?/:article",
    meta: {"country":"uk"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grapps-consent-id___default",
    path: "/gr/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___en",
    path: "/gr/en/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___ar",
    path: "/gr/ar/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___fr",
    path: "/gr/fr/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___de",
    path: "/gr/de/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___es",
    path: "/gr/es/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-consent-id___ro",
    path: "/gr/ro/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grapps-faq___default",
    path: "/gr/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___en",
    path: "/gr/en/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___ar",
    path: "/gr/ar/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___fr",
    path: "/gr/fr/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___de",
    path: "/gr/de/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___es",
    path: "/gr/es/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-faq___ro",
    path: "/gr/ro/apps/faq",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "grapps-manage-id___default",
    path: "/gr/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___en",
    path: "/gr/en/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___ar",
    path: "/gr/ar/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___fr",
    path: "/gr/fr/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___de",
    path: "/gr/de/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___es",
    path: "/gr/es/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage-id___ro",
    path: "/gr/ro/apps/manage/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grapps-manage___default",
    path: "/gr/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___en",
    path: "/gr/en/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___ar",
    path: "/gr/ar/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___fr",
    path: "/gr/fr/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___de",
    path: "/gr/de/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___es",
    path: "/gr/es/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-manage___ro",
    path: "/gr/ro/apps/manage",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "grapps-partner-name___default",
    path: "/gr/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___en",
    path: "/gr/en/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___ar",
    path: "/gr/ar/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___fr",
    path: "/gr/fr/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___de",
    path: "/gr/de/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___es",
    path: "/gr/es/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-partner-name___ro",
    path: "/gr/ro/apps/partner/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grapps-pd-name___default",
    path: "/gr/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___en",
    path: "/gr/en/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___ar",
    path: "/gr/ar/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___fr",
    path: "/gr/fr/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___de",
    path: "/gr/de/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___es",
    path: "/gr/es/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-pd-name___ro",
    path: "/gr/ro/apps/pd/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grapps-profile___default",
    path: "/gr/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___en",
    path: "/gr/en/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___ar",
    path: "/gr/ar/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___fr",
    path: "/gr/fr/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___de",
    path: "/gr/de/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___es",
    path: "/gr/es/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-profile___ro",
    path: "/gr/ro/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "grapps-register___default",
    path: "/gr/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___en",
    path: "/gr/en/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___ar",
    path: "/gr/ar/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___fr",
    path: "/gr/fr/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___de",
    path: "/gr/de/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___es",
    path: "/gr/es/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-register___ro",
    path: "/gr/ro/apps/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "grapps-viewAll___default",
    path: "/gr/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___en",
    path: "/gr/en/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___ar",
    path: "/gr/ar/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___fr",
    path: "/gr/fr/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___de",
    path: "/gr/de/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___es",
    path: "/gr/es/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grapps-viewAll___ro",
    path: "/gr/ro/apps/viewAll",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "grarcade-details-id___default",
    path: "/gr/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___en",
    path: "/gr/en/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___ar",
    path: "/gr/ar/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___fr",
    path: "/gr/fr/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___de",
    path: "/gr/de/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___es",
    path: "/gr/es/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details-id___ro",
    path: "/gr/ro/arcade/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarticles-category-subcategory-article___default",
    path: "/gr/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___en",
    path: "/gr/en/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___ar",
    path: "/gr/ar/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___fr",
    path: "/gr/fr/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___de",
    path: "/gr/de/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___es",
    path: "/gr/es/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory-article___ro",
    path: "/gr/ro/articles/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-subcategory___default",
    path: "/gr/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___en",
    path: "/gr/en/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___ar",
    path: "/gr/ar/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___fr",
    path: "/gr/fr/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___de",
    path: "/gr/de/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___es",
    path: "/gr/es/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category-subcategory___ro",
    path: "/gr/ro/articles/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-category___default",
    path: "/gr/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___en",
    path: "/gr/en/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___ar",
    path: "/gr/ar/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___fr",
    path: "/gr/fr/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___de",
    path: "/gr/de/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___es",
    path: "/gr/es/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-category___ro",
    path: "/gr/ro/articles/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___default",
    path: "/gr/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___en",
    path: "/gr/en/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___ar",
    path: "/gr/ar/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___fr",
    path: "/gr/fr/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___de",
    path: "/gr/de/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___es",
    path: "/gr/es/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory-article___ro",
    path: "/gr/ro/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-premium-category-subcategory___default",
    path: "/gr/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___en",
    path: "/gr/en/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___ar",
    path: "/gr/ar/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___fr",
    path: "/gr/fr/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___de",
    path: "/gr/de/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___es",
    path: "/gr/es/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category-subcategory___ro",
    path: "/gr/ro/articles/premium/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "grarticles-premium-category___default",
    path: "/gr/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___en",
    path: "/gr/en/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___ar",
    path: "/gr/ar/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___fr",
    path: "/gr/fr/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___de",
    path: "/gr/de/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___es",
    path: "/gr/es/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium-category___ro",
    path: "/gr/ro/articles/premium/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "grarticles-premium___default",
    path: "/gr/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___en",
    path: "/gr/en/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___ar",
    path: "/gr/ar/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___fr",
    path: "/gr/fr/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___de",
    path: "/gr/de/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___es",
    path: "/gr/es/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "grarticles-premium___ro",
    path: "/gr/ro/articles/premium",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "graudiobook-artists-id___default",
    path: "/gr/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___en",
    path: "/gr/en/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___ar",
    path: "/gr/ar/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___fr",
    path: "/gr/fr/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___de",
    path: "/gr/de/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___es",
    path: "/gr/es/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists-id___ro",
    path: "/gr/ro/audiobook/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-category___default",
    path: "/gr/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___en",
    path: "/gr/en/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___ar",
    path: "/gr/ar/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___fr",
    path: "/gr/fr/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___de",
    path: "/gr/de/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___es",
    path: "/gr/es/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-category___ro",
    path: "/gr/ro/audiobook/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "graudiobook-details-id___default",
    path: "/gr/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___en",
    path: "/gr/en/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___ar",
    path: "/gr/ar/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___fr",
    path: "/gr/fr/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___de",
    path: "/gr/de/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___es",
    path: "/gr/es/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details-id___ro",
    path: "/gr/ro/audiobook/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-genre-name___default",
    path: "/gr/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___en",
    path: "/gr/en/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___ar",
    path: "/gr/ar/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___fr",
    path: "/gr/fr/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___de",
    path: "/gr/de/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___es",
    path: "/gr/es/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-genre-name___ro",
    path: "/gr/ro/audiobook/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "graudiobook-list___default",
    path: "/gr/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___en",
    path: "/gr/en/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___ar",
    path: "/gr/ar/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___fr",
    path: "/gr/fr/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___de",
    path: "/gr/de/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___es",
    path: "/gr/es/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "graudiobook-list___ro",
    path: "/gr/ro/audiobook/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "grbilling-history___default",
    path: "/gr/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___en",
    path: "/gr/en/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___ar",
    path: "/gr/ar/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___fr",
    path: "/gr/fr/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___de",
    path: "/gr/de/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___es",
    path: "/gr/es/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grbilling-history___ro",
    path: "/gr/ro/billing-history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "grexternal-logout___default",
    path: "/gr/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___en",
    path: "/gr/en/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___ar",
    path: "/gr/ar/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___fr",
    path: "/gr/fr/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___de",
    path: "/gr/de/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___es",
    path: "/gr/es/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grexternal-logout___ro",
    path: "/gr/ro/external/logout",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "grfavorites___default",
    path: "/gr/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___en",
    path: "/gr/en/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___ar",
    path: "/gr/ar/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___fr",
    path: "/gr/fr/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___de",
    path: "/gr/de/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___es",
    path: "/gr/es/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grfavorites___ro",
    path: "/gr/ro/favorites",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "grgames-category-name___default",
    path: "/gr/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___en",
    path: "/gr/en/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___ar",
    path: "/gr/ar/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___fr",
    path: "/gr/fr/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___de",
    path: "/gr/de/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___es",
    path: "/gr/es/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category-name___ro",
    path: "/gr/ro/games/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-details-id___default",
    path: "/gr/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___en",
    path: "/gr/en/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___ar",
    path: "/gr/ar/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___fr",
    path: "/gr/fr/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___de",
    path: "/gr/de/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___es",
    path: "/gr/es/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details-id___ro",
    path: "/gr/ro/games/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-list-name-id___default",
    path: "/gr/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___en",
    path: "/gr/en/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___ar",
    path: "/gr/ar/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___fr",
    path: "/gr/fr/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___de",
    path: "/gr/de/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___es",
    path: "/gr/es/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name-id___ro",
    path: "/gr/ro/games/list/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "grgames-list-name___default",
    path: "/gr/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___en",
    path: "/gr/en/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___ar",
    path: "/gr/ar/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___fr",
    path: "/gr/fr/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___de",
    path: "/gr/de/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___es",
    path: "/gr/es/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list-name___ro",
    path: "/gr/ro/games/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___default",
    path: "/gr/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___en",
    path: "/gr/en/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___ar",
    path: "/gr/ar/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___fr",
    path: "/gr/fr/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___de",
    path: "/gr/de/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___es",
    path: "/gr/es/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grgames-publisher-name___ro",
    path: "/gr/ro/games/publisher/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "grhistory___default",
    path: "/gr/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___en",
    path: "/gr/en/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___ar",
    path: "/gr/ar/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___fr",
    path: "/gr/fr/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___de",
    path: "/gr/de/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___es",
    path: "/gr/es/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grhistory___ro",
    path: "/gr/ro/history",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "grimpressum___default",
    path: "/gr/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___en",
    path: "/gr/en/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___ar",
    path: "/gr/ar/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___fr",
    path: "/gr/fr/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___de",
    path: "/gr/de/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___es",
    path: "/gr/es/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grimpressum___ro",
    path: "/gr/ro/impressum",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "grindex___default",
    path: "/gr/",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___en",
    path: "/gr/en",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___ar",
    path: "/gr/ar",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___fr",
    path: "/gr/fr",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___de",
    path: "/gr/de",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___es",
    path: "/gr/es",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grindex___ro",
    path: "/gr/ro",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "grinfo-name___default",
    path: "/gr/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___en",
    path: "/gr/en/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___ar",
    path: "/gr/ar/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___fr",
    path: "/gr/fr/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___de",
    path: "/gr/de/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___es",
    path: "/gr/es/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinfo-name___ro",
    path: "/gr/ro/info/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "grinternal-redirect___default",
    path: "/gr/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___en",
    path: "/gr/en/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___ar",
    path: "/gr/ar/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___fr",
    path: "/gr/fr/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___de",
    path: "/gr/de/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___es",
    path: "/gr/es/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grinternal-redirect___ro",
    path: "/gr/ro/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "grlaunch___default",
    path: "/gr/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___en",
    path: "/gr/en/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___ar",
    path: "/gr/ar/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___fr",
    path: "/gr/fr/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___de",
    path: "/gr/de/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___es",
    path: "/gr/es/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grlaunch___ro",
    path: "/gr/ro/launch",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "grmain-name___default",
    path: "/gr/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___en",
    path: "/gr/en/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___ar",
    path: "/gr/ar/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___fr",
    path: "/gr/fr/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___de",
    path: "/gr/de/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___es",
    path: "/gr/es/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain-name___ro",
    path: "/gr/ro/main/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmarketing-name___default",
    path: "/gr/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___en",
    path: "/gr/en/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___ar",
    path: "/gr/ar/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___fr",
    path: "/gr/fr/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___de",
    path: "/gr/de/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___es",
    path: "/gr/es/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmarketing-name___ro",
    path: "/gr/ro/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "grmp-category___default",
    path: "/gr/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___en",
    path: "/gr/en/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___ar",
    path: "/gr/ar/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___fr",
    path: "/gr/fr/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___de",
    path: "/gr/de/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___es",
    path: "/gr/es/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-category___ro",
    path: "/gr/ro/mp/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmp-name___default",
    path: "/gr/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___en",
    path: "/gr/en/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___ar",
    path: "/gr/ar/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___fr",
    path: "/gr/fr/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___de",
    path: "/gr/de/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___es",
    path: "/gr/es/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmp-name___ro",
    path: "/gr/ro/mp/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grmusic-albums-artist-album___default",
    path: "/gr/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___en",
    path: "/gr/en/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___ar",
    path: "/gr/ar/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___fr",
    path: "/gr/fr/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___de",
    path: "/gr/de/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___es",
    path: "/gr/es/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-artist-album___ro",
    path: "/gr/ro/music/albums/:artist()/:album()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-albums-category-name___default",
    path: "/gr/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___en",
    path: "/gr/en/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___ar",
    path: "/gr/ar/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___fr",
    path: "/gr/fr/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___de",
    path: "/gr/de/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___es",
    path: "/gr/es/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums-category-name___ro",
    path: "/gr/ro/music/albums/category/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "grmusic-albums___default",
    path: "/gr/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___en",
    path: "/gr/en/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___ar",
    path: "/gr/ar/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___fr",
    path: "/gr/fr/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___de",
    path: "/gr/de/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___es",
    path: "/gr/es/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-albums___ro",
    path: "/gr/ro/music/albums",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "grmusic-artists-id___default",
    path: "/gr/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___en",
    path: "/gr/en/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___ar",
    path: "/gr/ar/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___fr",
    path: "/gr/fr/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___de",
    path: "/gr/de/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___es",
    path: "/gr/es/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artists-id___ro",
    path: "/gr/ro/music/artists/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-genre-name___default",
    path: "/gr/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___en",
    path: "/gr/en/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___ar",
    path: "/gr/ar/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___fr",
    path: "/gr/fr/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___de",
    path: "/gr/de/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___es",
    path: "/gr/es/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-genre-name___ro",
    path: "/gr/ro/music/genre/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "grmusic-list___default",
    path: "/gr/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___en",
    path: "/gr/en/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___ar",
    path: "/gr/ar/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___fr",
    path: "/gr/fr/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___de",
    path: "/gr/de/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___es",
    path: "/gr/es/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-list___ro",
    path: "/gr/ro/music/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "grmusic-playlists-playlist___default",
    path: "/gr/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___en",
    path: "/gr/en/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___ar",
    path: "/gr/ar/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___fr",
    path: "/gr/fr/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___de",
    path: "/gr/de/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___es",
    path: "/gr/es/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists-playlist___ro",
    path: "/gr/ro/music/playlists/:playlist()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlists___default",
    path: "/gr/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___en",
    path: "/gr/en/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___ar",
    path: "/gr/ar/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___fr",
    path: "/gr/fr/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___de",
    path: "/gr/de/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___es",
    path: "/gr/es/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-playlists___ro",
    path: "/gr/ro/music/playlists",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "grmusic-tracks-track___default",
    path: "/gr/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___en",
    path: "/gr/en/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___ar",
    path: "/gr/ar/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___fr",
    path: "/gr/fr/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___de",
    path: "/gr/de/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___es",
    path: "/gr/es/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-track___ro",
    path: "/gr/ro/music/tracks/:track()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-tracks-category___default",
    path: "/gr/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___en",
    path: "/gr/en/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___ar",
    path: "/gr/ar/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___fr",
    path: "/gr/fr/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___de",
    path: "/gr/de/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___es",
    path: "/gr/es/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks-category___ro",
    path: "/gr/ro/music/tracks/category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "grmusic-tracks___default",
    path: "/gr/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___en",
    path: "/gr/en/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___ar",
    path: "/gr/ar/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___fr",
    path: "/gr/fr/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___de",
    path: "/gr/de/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___es",
    path: "/gr/es/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-tracks___ro",
    path: "/gr/ro/music/tracks",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "grmusic-video-details-id___default",
    path: "/gr/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___en",
    path: "/gr/en/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___ar",
    path: "/gr/ar/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___fr",
    path: "/gr/fr/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___de",
    path: "/gr/de/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___es",
    path: "/gr/es/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmusic-video-details-id___ro",
    path: "/gr/ro/music/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "grmyCart___default",
    path: "/gr/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___en",
    path: "/gr/en/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___ar",
    path: "/gr/ar/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___fr",
    path: "/gr/fr/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___de",
    path: "/gr/de/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___es",
    path: "/gr/es/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grmyCart___ro",
    path: "/gr/ro/myCart",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "grMyPaymentMethods___default",
    path: "/gr/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___en",
    path: "/gr/en/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___ar",
    path: "/gr/ar/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___fr",
    path: "/gr/fr/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___de",
    path: "/gr/de/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___es",
    path: "/gr/es/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grMyPaymentMethods___ro",
    path: "/gr/ro/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "grmyPurchases___default",
    path: "/gr/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___en",
    path: "/gr/en/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___ar",
    path: "/gr/ar/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___fr",
    path: "/gr/fr/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___de",
    path: "/gr/de/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___es",
    path: "/gr/es/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grmyPurchases___ro",
    path: "/gr/ro/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___default",
    path: "/gr/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___en",
    path: "/gr/en/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___ar",
    path: "/gr/ar/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___fr",
    path: "/gr/fr/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___de",
    path: "/gr/de/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___es",
    path: "/gr/es/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory-articlename-article___ro",
    path: "/gr/ro/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "grnews-category-subcategory___default",
    path: "/gr/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___en",
    path: "/gr/en/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___ar",
    path: "/gr/ar/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___fr",
    path: "/gr/fr/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___de",
    path: "/gr/de/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___es",
    path: "/gr/es/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category-subcategory___ro",
    path: "/gr/ro/news/:category()/:subcategory()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "grnews-category___default",
    path: "/gr/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___en",
    path: "/gr/en/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___ar",
    path: "/gr/ar/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___fr",
    path: "/gr/fr/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___de",
    path: "/gr/de/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___es",
    path: "/gr/es/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnews-category___ro",
    path: "/gr/ro/news/:category()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "grnotifications___default",
    path: "/gr/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___en",
    path: "/gr/en/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___ar",
    path: "/gr/ar/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___fr",
    path: "/gr/fr/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___de",
    path: "/gr/de/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___es",
    path: "/gr/es/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grnotifications___ro",
    path: "/gr/ro/notifications",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "grparentalControl___default",
    path: "/gr/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___en",
    path: "/gr/en/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___ar",
    path: "/gr/ar/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___fr",
    path: "/gr/fr/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___de",
    path: "/gr/de/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___es",
    path: "/gr/es/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grparentalControl___ro",
    path: "/gr/ro/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "grpartner-registration___default",
    path: "/gr/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___en",
    path: "/gr/en/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___ar",
    path: "/gr/ar/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___fr",
    path: "/gr/fr/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___de",
    path: "/gr/de/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___es",
    path: "/gr/es/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-registration___ro",
    path: "/gr/ro/partner-registration",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "grpartner-subscriptions-id___default",
    path: "/gr/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___en",
    path: "/gr/en/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___ar",
    path: "/gr/ar/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___fr",
    path: "/gr/fr/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___de",
    path: "/gr/de/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___es",
    path: "/gr/es/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions-id___ro",
    path: "/gr/ro/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "grpartner-subscriptions___default",
    path: "/gr/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___en",
    path: "/gr/en/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___ar",
    path: "/gr/ar/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___fr",
    path: "/gr/fr/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___de",
    path: "/gr/de/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___es",
    path: "/gr/es/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartner-subscriptions___ro",
    path: "/gr/ro/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "grpartners-name___default",
    path: "/gr/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___en",
    path: "/gr/en/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___ar",
    path: "/gr/ar/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___fr",
    path: "/gr/fr/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___de",
    path: "/gr/de/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___es",
    path: "/gr/es/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-name___ro",
    path: "/gr/ro/partners/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grpartners-info-services-name___default",
    path: "/gr/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___en",
    path: "/gr/en/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___ar",
    path: "/gr/ar/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___fr",
    path: "/gr/fr/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___de",
    path: "/gr/de/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___es",
    path: "/gr/es/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services-name___ro",
    path: "/gr/ro/partners/info-services/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "grpartners-info-services___default",
    path: "/gr/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___en",
    path: "/gr/en/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___ar",
    path: "/gr/ar/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___fr",
    path: "/gr/fr/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___de",
    path: "/gr/de/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___es",
    path: "/gr/es/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpartners-info-services___ro",
    path: "/gr/ro/partners/info-services",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "grpodcast-details-id___default",
    path: "/gr/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___en",
    path: "/gr/en/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___ar",
    path: "/gr/ar/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___fr",
    path: "/gr/fr/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___de",
    path: "/gr/de/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___es",
    path: "/gr/es/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details-id___ro",
    path: "/gr/ro/podcast/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-episode-id___default",
    path: "/gr/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___en",
    path: "/gr/en/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___ar",
    path: "/gr/ar/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___fr",
    path: "/gr/fr/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___de",
    path: "/gr/de/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___es",
    path: "/gr/es/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode-id___ro",
    path: "/gr/ro/podcast/episode/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-list___default",
    path: "/gr/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___en",
    path: "/gr/en/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___ar",
    path: "/gr/ar/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___fr",
    path: "/gr/fr/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___de",
    path: "/gr/de/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___es",
    path: "/gr/es/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grpodcast-list___ro",
    path: "/gr/ro/podcast/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "grprofile___default",
    path: "/gr/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___en",
    path: "/gr/en/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___ar",
    path: "/gr/ar/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___fr",
    path: "/gr/fr/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___de",
    path: "/gr/de/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___es",
    path: "/gr/es/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile___ro",
    path: "/gr/ro/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___default",
    path: "/gr/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___en",
    path: "/gr/en/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___ar",
    path: "/gr/ar/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___fr",
    path: "/gr/fr/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___de",
    path: "/gr/de/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___es",
    path: "/gr/es/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info-service-subscriptions___ro",
    path: "/gr/ro/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "grprofile-info___default",
    path: "/gr/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___en",
    path: "/gr/en/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___ar",
    path: "/gr/ar/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___fr",
    path: "/gr/fr/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___de",
    path: "/gr/de/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___es",
    path: "/gr/es/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-info___ro",
    path: "/gr/ro/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "grprofile-manage___default",
    path: "/gr/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___en",
    path: "/gr/en/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___ar",
    path: "/gr/ar/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___fr",
    path: "/gr/fr/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___de",
    path: "/gr/de/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___es",
    path: "/gr/es/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-manage___ro",
    path: "/gr/ro/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "grprofile-preferences___default",
    path: "/gr/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___en",
    path: "/gr/en/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___ar",
    path: "/gr/ar/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___fr",
    path: "/gr/fr/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___de",
    path: "/gr/de/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___es",
    path: "/gr/es/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-preferences___ro",
    path: "/gr/ro/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "grprofile-privacy-settings___default",
    path: "/gr/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___en",
    path: "/gr/en/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___ar",
    path: "/gr/ar/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___fr",
    path: "/gr/fr/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___de",
    path: "/gr/de/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___es",
    path: "/gr/es/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grprofile-privacy-settings___ro",
    path: "/gr/ro/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "grresetpassword___default",
    path: "/gr/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___en",
    path: "/gr/en/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___ar",
    path: "/gr/ar/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___fr",
    path: "/gr/fr/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___de",
    path: "/gr/de/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___es",
    path: "/gr/es/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grresetpassword___ro",
    path: "/gr/ro/resetpassword",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "grreward___default",
    path: "/gr/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___en",
    path: "/gr/en/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___ar",
    path: "/gr/ar/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___fr",
    path: "/gr/fr/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___de",
    path: "/gr/de/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___es",
    path: "/gr/es/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grreward___ro",
    path: "/gr/ro/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "grsearch___default",
    path: "/gr/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___en",
    path: "/gr/en/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___ar",
    path: "/gr/ar/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___fr",
    path: "/gr/fr/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___de",
    path: "/gr/de/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___es",
    path: "/gr/es/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch___ro",
    path: "/gr/ro/search",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsubscription___default",
    path: "/gr/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___en",
    path: "/gr/en/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___ar",
    path: "/gr/ar/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___fr",
    path: "/gr/fr/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___de",
    path: "/gr/de/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___es",
    path: "/gr/es/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grsubscription___ro",
    path: "/gr/ro/subscription",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "grtournaments-details-id___default",
    path: "/gr/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___en",
    path: "/gr/en/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___ar",
    path: "/gr/ar/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___fr",
    path: "/gr/fr/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___de",
    path: "/gr/de/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___es",
    path: "/gr/es/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-details-id___ro",
    path: "/gr/ro/tournaments/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___default",
    path: "/gr/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___en",
    path: "/gr/en/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___ar",
    path: "/gr/ar/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___fr",
    path: "/gr/fr/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___de",
    path: "/gr/de/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___es",
    path: "/gr/es/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-news-details-id___ro",
    path: "/gr/ro/tournaments/news/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___default",
    path: "/gr/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___en",
    path: "/gr/en/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___ar",
    path: "/gr/ar/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___fr",
    path: "/gr/fr/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___de",
    path: "/gr/de/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___es",
    path: "/gr/es/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "grtournaments-videos-details-id___ro",
    path: "/gr/ro/tournaments/videos/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "gruser-login-email___default",
    path: "/gr/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___en",
    path: "/gr/en/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___ar",
    path: "/gr/ar/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___fr",
    path: "/gr/fr/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___de",
    path: "/gr/de/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___es",
    path: "/gr/es/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login-email___ro",
    path: "/gr/ro/user/login/email",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "gruser-login___default",
    path: "/gr/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___en",
    path: "/gr/en/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___ar",
    path: "/gr/ar/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___fr",
    path: "/gr/fr/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___de",
    path: "/gr/de/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___es",
    path: "/gr/es/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-login___ro",
    path: "/gr/ro/user/login",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "gruser-register___default",
    path: "/gr/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___en",
    path: "/gr/en/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___ar",
    path: "/gr/ar/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___fr",
    path: "/gr/fr/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___de",
    path: "/gr/de/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___es",
    path: "/gr/es/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "gruser-register___ro",
    path: "/gr/ro/user/register",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "grvideo-ex-category-id___default",
    path: "/gr/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___en",
    path: "/gr/en/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___ar",
    path: "/gr/ar/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___fr",
    path: "/gr/fr/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___de",
    path: "/gr/de/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___es",
    path: "/gr/es/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-category-id___ro",
    path: "/gr/ro/video/:ex()/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___default",
    path: "/gr/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___en",
    path: "/gr/en/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___ar",
    path: "/gr/ar/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___fr",
    path: "/gr/fr/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___de",
    path: "/gr/de/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___es",
    path: "/gr/es/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-details-id___ro",
    path: "/gr/ro/video/:ex()/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___default",
    path: "/gr/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___en",
    path: "/gr/en/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___ar",
    path: "/gr/ar/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___fr",
    path: "/gr/fr/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___de",
    path: "/gr/de/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___es",
    path: "/gr/es/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-ex-stream-id___ro",
    path: "/gr/ro/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"gr"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grvideo-category-name-id___default",
    path: "/gr/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___en",
    path: "/gr/en/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___ar",
    path: "/gr/ar/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___fr",
    path: "/gr/fr/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___de",
    path: "/gr/de/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___es",
    path: "/gr/es/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category-name-id___ro",
    path: "/gr/ro/video/category/:name()/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-details-id___default",
    path: "/gr/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___en",
    path: "/gr/en/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___ar",
    path: "/gr/ar/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___fr",
    path: "/gr/fr/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___de",
    path: "/gr/de/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___es",
    path: "/gr/es/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details-id___ro",
    path: "/gr/ro/video/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-list-name___default",
    path: "/gr/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___en",
    path: "/gr/en/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___ar",
    path: "/gr/ar/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___fr",
    path: "/gr/fr/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___de",
    path: "/gr/de/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___es",
    path: "/gr/es/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-list-name___ro",
    path: "/gr/ro/video/list/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "grvideo-series-details-id___default",
    path: "/gr/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___en",
    path: "/gr/en/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___ar",
    path: "/gr/ar/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___fr",
    path: "/gr/fr/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___de",
    path: "/gr/de/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___es",
    path: "/gr/es/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series-details-id___ro",
    path: "/gr/ro/video/series/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-stream-id___default",
    path: "/gr/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___en",
    path: "/gr/en/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___ar",
    path: "/gr/ar/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___fr",
    path: "/gr/fr/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___de",
    path: "/gr/de/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___es",
    path: "/gr/es/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream-id___ro",
    path: "/gr/ro/video/stream/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-test___default",
    path: "/gr/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___en",
    path: "/gr/en/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___ar",
    path: "/gr/ar/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___fr",
    path: "/gr/fr/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___de",
    path: "/gr/de/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___es",
    path: "/gr/es/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvideo-test___ro",
    path: "/gr/ro/video/test",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "grvoucherbooks-name___default",
    path: "/gr/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___en",
    path: "/gr/en/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___ar",
    path: "/gr/ar/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___fr",
    path: "/gr/fr/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___de",
    path: "/gr/de/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___es",
    path: "/gr/es/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvoucherbooks-name___ro",
    path: "/gr/ro/voucherbooks/:name()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "grvouchers-category-id___default",
    path: "/gr/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___en",
    path: "/gr/en/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___ar",
    path: "/gr/ar/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___fr",
    path: "/gr/fr/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___de",
    path: "/gr/de/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___es",
    path: "/gr/es/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-category-id___ro",
    path: "/gr/ro/vouchers/category/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "grvouchers-details-id___default",
    path: "/gr/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___en",
    path: "/gr/en/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___ar",
    path: "/gr/ar/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___fr",
    path: "/gr/fr/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___de",
    path: "/gr/de/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___es",
    path: "/gr/es/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-id___ro",
    path: "/gr/ro/vouchers/details/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-genre-id___default",
    path: "/gr/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___en",
    path: "/gr/en/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___ar",
    path: "/gr/ar/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___fr",
    path: "/gr/fr/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___de",
    path: "/gr/de/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___es",
    path: "/gr/es/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grvouchers-genre-id___ro",
    path: "/gr/ro/vouchers/genre/:id()",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "grmain___default",
    path: "/gr/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___en",
    path: "/gr/en/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___ar",
    path: "/gr/ar/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___fr",
    path: "/gr/fr/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___de",
    path: "/gr/de/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___es",
    path: "/gr/es/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmain___ro",
    path: "/gr/ro/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "grmusic-track___default",
    path: "/gr/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___en",
    path: "/gr/en/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___ar",
    path: "/gr/ar/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___fr",
    path: "/gr/fr/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___de",
    path: "/gr/de/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___es",
    path: "/gr/es/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmusic-track___ro",
    path: "/gr/ro/music/tracks/:title/:track",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "grmonsooq-app-consent-details___default",
    path: "/gr/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___en",
    path: "/gr/en/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___ar",
    path: "/gr/ar/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___fr",
    path: "/gr/fr/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___de",
    path: "/gr/de/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___es",
    path: "/gr/es/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-consent-details___ro",
    path: "/gr/ro/apps/consent/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___default",
    path: "/gr/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___en",
    path: "/gr/en/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___ar",
    path: "/gr/ar/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___fr",
    path: "/gr/fr/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___de",
    path: "/gr/de/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___es",
    path: "/gr/es/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-detail___ro",
    path: "/gr/ro/apps/partner/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___default",
    path: "/gr/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___en",
    path: "/gr/en/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___ar",
    path: "/gr/ar/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___fr",
    path: "/gr/fr/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___de",
    path: "/gr/de/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___es",
    path: "/gr/es/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grmonsooq-app-partner-details___ro",
    path: "/gr/ro/apps/pd/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "grment-app-partner-details___default",
    path: "/gr/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___en",
    path: "/gr/en/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___ar",
    path: "/gr/ar/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___fr",
    path: "/gr/fr/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___de",
    path: "/gr/de/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___es",
    path: "/gr/es/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-details___ro",
    path: "/gr/ro/mp/:title/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "grment-app-partner-categories-details___default",
    path: "/gr/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___en",
    path: "/gr/en/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___ar",
    path: "/gr/ar/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___fr",
    path: "/gr/fr/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___de",
    path: "/gr/de/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___es",
    path: "/gr/es/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grment-app-partner-categories-details___ro",
    path: "/gr/ro/mp/:category",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "grmanage-subscription-details___default",
    path: "/gr/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___en",
    path: "/gr/en/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___ar",
    path: "/gr/ar/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___fr",
    path: "/gr/fr/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___de",
    path: "/gr/de/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___es",
    path: "/gr/es/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmanage-subscription-details___ro",
    path: "/gr/ro/apps/manage/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "grmusic-artistName-albumName___default",
    path: "/gr/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___en",
    path: "/gr/en/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___ar",
    path: "/gr/ar/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___fr",
    path: "/gr/fr/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___de",
    path: "/gr/de/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___es",
    path: "/gr/es/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artistName-albumName___ro",
    path: "/gr/ro/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "grmusic-artist___default",
    path: "/gr/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___en",
    path: "/gr/en/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___ar",
    path: "/gr/ar/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___fr",
    path: "/gr/fr/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___de",
    path: "/gr/de/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___es",
    path: "/gr/es/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-artist___ro",
    path: "/gr/ro/music/artists/:artistName/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "grmusic-playlist___default",
    path: "/gr/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___en",
    path: "/gr/en/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___ar",
    path: "/gr/ar/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___fr",
    path: "/gr/fr/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___de",
    path: "/gr/de/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___es",
    path: "/gr/es/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grmusic-playlist___ro",
    path: "/gr/ro/music/playlists/:title/:playlist",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "grpodcast-details___default",
    path: "/gr/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___en",
    path: "/gr/en/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___ar",
    path: "/gr/ar/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___fr",
    path: "/gr/fr/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___de",
    path: "/gr/de/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___es",
    path: "/gr/es/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___ro",
    path: "/gr/ro/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-episode___default",
    path: "/gr/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___en",
    path: "/gr/en/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___ar",
    path: "/gr/ar/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___fr",
    path: "/gr/fr/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___de",
    path: "/gr/de/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___es",
    path: "/gr/es/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___ro",
    path: "/gr/ro/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "graudiobook-details___default",
    path: "/gr/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___en",
    path: "/gr/en/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___ar",
    path: "/gr/ar/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___fr",
    path: "/gr/fr/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___de",
    path: "/gr/de/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___es",
    path: "/gr/es/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-details___ro",
    path: "/gr/ro/audiobook/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "graudiobook-artists___default",
    path: "/gr/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___en",
    path: "/gr/en/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___ar",
    path: "/gr/ar/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___fr",
    path: "/gr/fr/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___de",
    path: "/gr/de/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___es",
    path: "/gr/es/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "graudiobook-artists___ro",
    path: "/gr/ro/audiobook/artists/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "grgames-category___default",
    path: "/gr/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___en",
    path: "/gr/en/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___ar",
    path: "/gr/ar/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___fr",
    path: "/gr/fr/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___de",
    path: "/gr/de/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___es",
    path: "/gr/es/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-category___ro",
    path: "/gr/ro/games/category/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "grgames-details___default",
    path: "/gr/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___en",
    path: "/gr/en/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___ar",
    path: "/gr/ar/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___fr",
    path: "/gr/fr/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___de",
    path: "/gr/de/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___es",
    path: "/gr/es/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-details___ro",
    path: "/gr/ro/games/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "grgames-list___default",
    path: "/gr/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___en",
    path: "/gr/en/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___ar",
    path: "/gr/ar/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___fr",
    path: "/gr/fr/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___de",
    path: "/gr/de/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___es",
    path: "/gr/es/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grgames-list___ro",
    path: "/gr/ro/games/list",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "grarcade-details___default",
    path: "/gr/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___en",
    path: "/gr/en/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___ar",
    path: "/gr/ar/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___fr",
    path: "/gr/fr/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___de",
    path: "/gr/de/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___es",
    path: "/gr/es/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grarcade-details___ro",
    path: "/gr/ro/arcade/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "grpodcast-details___default",
    path: "/gr/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___en",
    path: "/gr/en/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___ar",
    path: "/gr/ar/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___fr",
    path: "/gr/fr/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___de",
    path: "/gr/de/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___es",
    path: "/gr/es/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-details___ro",
    path: "/gr/ro/podcast/details/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "grpodcast-episode___default",
    path: "/gr/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___en",
    path: "/gr/en/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___ar",
    path: "/gr/ar/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___fr",
    path: "/gr/fr/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___de",
    path: "/gr/de/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___es",
    path: "/gr/es/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grpodcast-episode___ro",
    path: "/gr/ro/podcast/episode/:title/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "grvideo-details___default",
    path: "/gr/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___en",
    path: "/gr/en/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___ar",
    path: "/gr/ar/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___fr",
    path: "/gr/fr/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___de",
    path: "/gr/de/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___es",
    path: "/gr/es/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grvideo-details___ro",
    path: "/gr/ro/video/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "grex-video-details___default",
    path: "/gr/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___en",
    path: "/gr/en/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___ar",
    path: "/gr/ar/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___fr",
    path: "/gr/fr/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___de",
    path: "/gr/de/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___es",
    path: "/gr/es/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grex-video-details___ro",
    path: "/gr/ro/video/:ex/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "grvideo-series___default",
    path: "/gr/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___en",
    path: "/gr/en/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___ar",
    path: "/gr/ar/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___fr",
    path: "/gr/fr/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___de",
    path: "/gr/de/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___es",
    path: "/gr/es/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-series___ro",
    path: "/gr/ro/video/series/details/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "grvideo-stream___default",
    path: "/gr/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___en",
    path: "/gr/en/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___ar",
    path: "/gr/ar/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___fr",
    path: "/gr/fr/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___de",
    path: "/gr/de/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___es",
    path: "/gr/es/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-stream___ro",
    path: "/gr/ro/video/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "grvideo-category___default",
    path: "/gr/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___en",
    path: "/gr/en/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___ar",
    path: "/gr/ar/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___fr",
    path: "/gr/fr/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___de",
    path: "/gr/de/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___es",
    path: "/gr/es/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grvideo-category___ro",
    path: "/gr/ro/video/category/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "grex-video-stream___default",
    path: "/gr/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___en",
    path: "/gr/en/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___ar",
    path: "/gr/ar/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___fr",
    path: "/gr/fr/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___de",
    path: "/gr/de/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___es",
    path: "/gr/es/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grex-video-stream___ro",
    path: "/gr/ro/video/:ex/stream/:name/:id",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "grservices-page___default",
    path: "/gr/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___en",
    path: "/gr/en/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___ar",
    path: "/gr/ar/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___fr",
    path: "/gr/fr/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___de",
    path: "/gr/de/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___es",
    path: "/gr/es/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grservices-page___ro",
    path: "/gr/ro/services/:name",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "grsearch-q___default",
    path: "/gr/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___en",
    path: "/gr/en/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___ar",
    path: "/gr/ar/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___fr",
    path: "/gr/fr/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___de",
    path: "/gr/de/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___es",
    path: "/gr/es/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grsearch-q___ro",
    path: "/gr/ro/search-q",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "grvouchers-details-voucher___default",
    path: "/gr/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___en",
    path: "/gr/en/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___ar",
    path: "/gr/ar/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___fr",
    path: "/gr/fr/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___de",
    path: "/gr/de/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___es",
    path: "/gr/es/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grvouchers-details-voucher___ro",
    path: "/gr/ro/vouchers/details/:id/:voucherId",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "grarticles-category-article___default",
    path: "/gr/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___en",
    path: "/gr/en/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___ar",
    path: "/gr/ar/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___fr",
    path: "/gr/fr/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___de",
    path: "/gr/de/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___es",
    path: "/gr/es/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "grarticles-category-article___ro",
    path: "/gr/ro/articles/:category?/:article",
    meta: {"country":"gr"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "spapps-consent-id___default",
    path: "/sp/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___en",
    path: "/sp/en/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___ar",
    path: "/sp/ar/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___fr",
    path: "/sp/fr/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___de",
    path: "/sp/de/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___es",
    path: "/sp/es/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-consent-id___ro",
    path: "/sp/ro/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spapps-faq___default",
    path: "/sp/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___en",
    path: "/sp/en/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___ar",
    path: "/sp/ar/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___fr",
    path: "/sp/fr/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___de",
    path: "/sp/de/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___es",
    path: "/sp/es/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-faq___ro",
    path: "/sp/ro/apps/faq",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "spapps-manage-id___default",
    path: "/sp/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___en",
    path: "/sp/en/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___ar",
    path: "/sp/ar/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___fr",
    path: "/sp/fr/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___de",
    path: "/sp/de/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___es",
    path: "/sp/es/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage-id___ro",
    path: "/sp/ro/apps/manage/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spapps-manage___default",
    path: "/sp/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___en",
    path: "/sp/en/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___ar",
    path: "/sp/ar/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___fr",
    path: "/sp/fr/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___de",
    path: "/sp/de/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___es",
    path: "/sp/es/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-manage___ro",
    path: "/sp/ro/apps/manage",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "spapps-partner-name___default",
    path: "/sp/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___en",
    path: "/sp/en/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___ar",
    path: "/sp/ar/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___fr",
    path: "/sp/fr/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___de",
    path: "/sp/de/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___es",
    path: "/sp/es/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-partner-name___ro",
    path: "/sp/ro/apps/partner/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spapps-pd-name___default",
    path: "/sp/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___en",
    path: "/sp/en/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___ar",
    path: "/sp/ar/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___fr",
    path: "/sp/fr/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___de",
    path: "/sp/de/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___es",
    path: "/sp/es/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-pd-name___ro",
    path: "/sp/ro/apps/pd/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spapps-profile___default",
    path: "/sp/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___en",
    path: "/sp/en/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___ar",
    path: "/sp/ar/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___fr",
    path: "/sp/fr/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___de",
    path: "/sp/de/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___es",
    path: "/sp/es/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-profile___ro",
    path: "/sp/ro/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "spapps-register___default",
    path: "/sp/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___en",
    path: "/sp/en/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___ar",
    path: "/sp/ar/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___fr",
    path: "/sp/fr/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___de",
    path: "/sp/de/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___es",
    path: "/sp/es/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-register___ro",
    path: "/sp/ro/apps/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "spapps-viewAll___default",
    path: "/sp/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___en",
    path: "/sp/en/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___ar",
    path: "/sp/ar/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___fr",
    path: "/sp/fr/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___de",
    path: "/sp/de/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___es",
    path: "/sp/es/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "spapps-viewAll___ro",
    path: "/sp/ro/apps/viewAll",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "sparcade-details-id___default",
    path: "/sp/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___en",
    path: "/sp/en/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___ar",
    path: "/sp/ar/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___fr",
    path: "/sp/fr/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___de",
    path: "/sp/de/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___es",
    path: "/sp/es/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details-id___ro",
    path: "/sp/ro/arcade/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparticles-category-subcategory-article___default",
    path: "/sp/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___en",
    path: "/sp/en/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___ar",
    path: "/sp/ar/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___fr",
    path: "/sp/fr/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___de",
    path: "/sp/de/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___es",
    path: "/sp/es/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory-article___ro",
    path: "/sp/ro/articles/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-subcategory___default",
    path: "/sp/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___en",
    path: "/sp/en/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___ar",
    path: "/sp/ar/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___fr",
    path: "/sp/fr/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___de",
    path: "/sp/de/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___es",
    path: "/sp/es/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category-subcategory___ro",
    path: "/sp/ro/articles/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-category___default",
    path: "/sp/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___en",
    path: "/sp/en/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___ar",
    path: "/sp/ar/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___fr",
    path: "/sp/fr/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___de",
    path: "/sp/de/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___es",
    path: "/sp/es/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-category___ro",
    path: "/sp/ro/articles/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___default",
    path: "/sp/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___en",
    path: "/sp/en/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___ar",
    path: "/sp/ar/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___fr",
    path: "/sp/fr/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___de",
    path: "/sp/de/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___es",
    path: "/sp/es/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory-article___ro",
    path: "/sp/ro/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-premium-category-subcategory___default",
    path: "/sp/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___en",
    path: "/sp/en/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___ar",
    path: "/sp/ar/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___fr",
    path: "/sp/fr/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___de",
    path: "/sp/de/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___es",
    path: "/sp/es/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category-subcategory___ro",
    path: "/sp/ro/articles/premium/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "sparticles-premium-category___default",
    path: "/sp/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___en",
    path: "/sp/en/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___ar",
    path: "/sp/ar/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___fr",
    path: "/sp/fr/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___de",
    path: "/sp/de/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___es",
    path: "/sp/es/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium-category___ro",
    path: "/sp/ro/articles/premium/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "sparticles-premium___default",
    path: "/sp/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___en",
    path: "/sp/en/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___ar",
    path: "/sp/ar/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___fr",
    path: "/sp/fr/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___de",
    path: "/sp/de/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___es",
    path: "/sp/es/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "sparticles-premium___ro",
    path: "/sp/ro/articles/premium",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "spaudiobook-artists-id___default",
    path: "/sp/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___en",
    path: "/sp/en/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___ar",
    path: "/sp/ar/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___fr",
    path: "/sp/fr/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___de",
    path: "/sp/de/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___es",
    path: "/sp/es/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists-id___ro",
    path: "/sp/ro/audiobook/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-category___default",
    path: "/sp/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___en",
    path: "/sp/en/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___ar",
    path: "/sp/ar/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___fr",
    path: "/sp/fr/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___de",
    path: "/sp/de/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___es",
    path: "/sp/es/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-category___ro",
    path: "/sp/ro/audiobook/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "spaudiobook-details-id___default",
    path: "/sp/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___en",
    path: "/sp/en/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___ar",
    path: "/sp/ar/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___fr",
    path: "/sp/fr/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___de",
    path: "/sp/de/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___es",
    path: "/sp/es/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details-id___ro",
    path: "/sp/ro/audiobook/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-genre-name___default",
    path: "/sp/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___en",
    path: "/sp/en/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___ar",
    path: "/sp/ar/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___fr",
    path: "/sp/fr/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___de",
    path: "/sp/de/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___es",
    path: "/sp/es/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-genre-name___ro",
    path: "/sp/ro/audiobook/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "spaudiobook-list___default",
    path: "/sp/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___en",
    path: "/sp/en/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___ar",
    path: "/sp/ar/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___fr",
    path: "/sp/fr/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___de",
    path: "/sp/de/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___es",
    path: "/sp/es/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spaudiobook-list___ro",
    path: "/sp/ro/audiobook/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "spbilling-history___default",
    path: "/sp/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___en",
    path: "/sp/en/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___ar",
    path: "/sp/ar/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___fr",
    path: "/sp/fr/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___de",
    path: "/sp/de/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___es",
    path: "/sp/es/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spbilling-history___ro",
    path: "/sp/ro/billing-history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "spexternal-logout___default",
    path: "/sp/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___en",
    path: "/sp/en/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___ar",
    path: "/sp/ar/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___fr",
    path: "/sp/fr/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___de",
    path: "/sp/de/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___es",
    path: "/sp/es/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spexternal-logout___ro",
    path: "/sp/ro/external/logout",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "spfavorites___default",
    path: "/sp/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___en",
    path: "/sp/en/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___ar",
    path: "/sp/ar/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___fr",
    path: "/sp/fr/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___de",
    path: "/sp/de/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___es",
    path: "/sp/es/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spfavorites___ro",
    path: "/sp/ro/favorites",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "spgames-category-name___default",
    path: "/sp/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___en",
    path: "/sp/en/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___ar",
    path: "/sp/ar/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___fr",
    path: "/sp/fr/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___de",
    path: "/sp/de/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___es",
    path: "/sp/es/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category-name___ro",
    path: "/sp/ro/games/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-details-id___default",
    path: "/sp/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___en",
    path: "/sp/en/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___ar",
    path: "/sp/ar/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___fr",
    path: "/sp/fr/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___de",
    path: "/sp/de/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___es",
    path: "/sp/es/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details-id___ro",
    path: "/sp/ro/games/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-list-name-id___default",
    path: "/sp/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___en",
    path: "/sp/en/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___ar",
    path: "/sp/ar/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___fr",
    path: "/sp/fr/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___de",
    path: "/sp/de/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___es",
    path: "/sp/es/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name-id___ro",
    path: "/sp/ro/games/list/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "spgames-list-name___default",
    path: "/sp/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___en",
    path: "/sp/en/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___ar",
    path: "/sp/ar/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___fr",
    path: "/sp/fr/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___de",
    path: "/sp/de/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___es",
    path: "/sp/es/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list-name___ro",
    path: "/sp/ro/games/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___default",
    path: "/sp/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___en",
    path: "/sp/en/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___ar",
    path: "/sp/ar/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___fr",
    path: "/sp/fr/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___de",
    path: "/sp/de/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___es",
    path: "/sp/es/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "spgames-publisher-name___ro",
    path: "/sp/ro/games/publisher/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "sphistory___default",
    path: "/sp/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___en",
    path: "/sp/en/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___ar",
    path: "/sp/ar/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___fr",
    path: "/sp/fr/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___de",
    path: "/sp/de/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___es",
    path: "/sp/es/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "sphistory___ro",
    path: "/sp/ro/history",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "spimpressum___default",
    path: "/sp/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___en",
    path: "/sp/en/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___ar",
    path: "/sp/ar/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___fr",
    path: "/sp/fr/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___de",
    path: "/sp/de/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___es",
    path: "/sp/es/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spimpressum___ro",
    path: "/sp/ro/impressum",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "spindex___default",
    path: "/sp/",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___en",
    path: "/sp/en",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___ar",
    path: "/sp/ar",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___fr",
    path: "/sp/fr",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___de",
    path: "/sp/de",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___es",
    path: "/sp/es",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spindex___ro",
    path: "/sp/ro",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "spinfo-name___default",
    path: "/sp/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___en",
    path: "/sp/en/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___ar",
    path: "/sp/ar/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___fr",
    path: "/sp/fr/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___de",
    path: "/sp/de/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___es",
    path: "/sp/es/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinfo-name___ro",
    path: "/sp/ro/info/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "spinternal-redirect___default",
    path: "/sp/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___en",
    path: "/sp/en/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___ar",
    path: "/sp/ar/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___fr",
    path: "/sp/fr/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___de",
    path: "/sp/de/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___es",
    path: "/sp/es/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "spinternal-redirect___ro",
    path: "/sp/ro/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "splaunch___default",
    path: "/sp/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___en",
    path: "/sp/en/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___ar",
    path: "/sp/ar/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___fr",
    path: "/sp/fr/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___de",
    path: "/sp/de/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___es",
    path: "/sp/es/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "splaunch___ro",
    path: "/sp/ro/launch",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "spmain-name___default",
    path: "/sp/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___en",
    path: "/sp/en/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___ar",
    path: "/sp/ar/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___fr",
    path: "/sp/fr/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___de",
    path: "/sp/de/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___es",
    path: "/sp/es/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain-name___ro",
    path: "/sp/ro/main/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmarketing-name___default",
    path: "/sp/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___en",
    path: "/sp/en/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___ar",
    path: "/sp/ar/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___fr",
    path: "/sp/fr/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___de",
    path: "/sp/de/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___es",
    path: "/sp/es/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmarketing-name___ro",
    path: "/sp/ro/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "spmp-category___default",
    path: "/sp/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___en",
    path: "/sp/en/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___ar",
    path: "/sp/ar/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___fr",
    path: "/sp/fr/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___de",
    path: "/sp/de/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___es",
    path: "/sp/es/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-category___ro",
    path: "/sp/ro/mp/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmp-name___default",
    path: "/sp/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___en",
    path: "/sp/en/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___ar",
    path: "/sp/ar/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___fr",
    path: "/sp/fr/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___de",
    path: "/sp/de/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___es",
    path: "/sp/es/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmp-name___ro",
    path: "/sp/ro/mp/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spmusic-albums-artist-album___default",
    path: "/sp/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___en",
    path: "/sp/en/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___ar",
    path: "/sp/ar/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___fr",
    path: "/sp/fr/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___de",
    path: "/sp/de/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___es",
    path: "/sp/es/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-artist-album___ro",
    path: "/sp/ro/music/albums/:artist()/:album()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-albums-category-name___default",
    path: "/sp/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___en",
    path: "/sp/en/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___ar",
    path: "/sp/ar/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___fr",
    path: "/sp/fr/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___de",
    path: "/sp/de/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___es",
    path: "/sp/es/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums-category-name___ro",
    path: "/sp/ro/music/albums/category/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "spmusic-albums___default",
    path: "/sp/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___en",
    path: "/sp/en/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___ar",
    path: "/sp/ar/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___fr",
    path: "/sp/fr/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___de",
    path: "/sp/de/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___es",
    path: "/sp/es/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-albums___ro",
    path: "/sp/ro/music/albums",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "spmusic-artists-id___default",
    path: "/sp/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___en",
    path: "/sp/en/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___ar",
    path: "/sp/ar/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___fr",
    path: "/sp/fr/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___de",
    path: "/sp/de/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___es",
    path: "/sp/es/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artists-id___ro",
    path: "/sp/ro/music/artists/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-genre-name___default",
    path: "/sp/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___en",
    path: "/sp/en/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___ar",
    path: "/sp/ar/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___fr",
    path: "/sp/fr/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___de",
    path: "/sp/de/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___es",
    path: "/sp/es/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-genre-name___ro",
    path: "/sp/ro/music/genre/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "spmusic-list___default",
    path: "/sp/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___en",
    path: "/sp/en/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___ar",
    path: "/sp/ar/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___fr",
    path: "/sp/fr/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___de",
    path: "/sp/de/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___es",
    path: "/sp/es/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-list___ro",
    path: "/sp/ro/music/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "spmusic-playlists-playlist___default",
    path: "/sp/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___en",
    path: "/sp/en/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___ar",
    path: "/sp/ar/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___fr",
    path: "/sp/fr/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___de",
    path: "/sp/de/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___es",
    path: "/sp/es/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists-playlist___ro",
    path: "/sp/ro/music/playlists/:playlist()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlists___default",
    path: "/sp/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___en",
    path: "/sp/en/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___ar",
    path: "/sp/ar/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___fr",
    path: "/sp/fr/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___de",
    path: "/sp/de/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___es",
    path: "/sp/es/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-playlists___ro",
    path: "/sp/ro/music/playlists",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "spmusic-tracks-track___default",
    path: "/sp/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___en",
    path: "/sp/en/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___ar",
    path: "/sp/ar/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___fr",
    path: "/sp/fr/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___de",
    path: "/sp/de/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___es",
    path: "/sp/es/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-track___ro",
    path: "/sp/ro/music/tracks/:track()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-tracks-category___default",
    path: "/sp/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___en",
    path: "/sp/en/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___ar",
    path: "/sp/ar/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___fr",
    path: "/sp/fr/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___de",
    path: "/sp/de/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___es",
    path: "/sp/es/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks-category___ro",
    path: "/sp/ro/music/tracks/category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "spmusic-tracks___default",
    path: "/sp/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___en",
    path: "/sp/en/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___ar",
    path: "/sp/ar/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___fr",
    path: "/sp/fr/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___de",
    path: "/sp/de/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___es",
    path: "/sp/es/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-tracks___ro",
    path: "/sp/ro/music/tracks",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "spmusic-video-details-id___default",
    path: "/sp/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___en",
    path: "/sp/en/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___ar",
    path: "/sp/ar/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___fr",
    path: "/sp/fr/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___de",
    path: "/sp/de/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___es",
    path: "/sp/es/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmusic-video-details-id___ro",
    path: "/sp/ro/music/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "spmyCart___default",
    path: "/sp/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___en",
    path: "/sp/en/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___ar",
    path: "/sp/ar/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___fr",
    path: "/sp/fr/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___de",
    path: "/sp/de/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___es",
    path: "/sp/es/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spmyCart___ro",
    path: "/sp/ro/myCart",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "spMyPaymentMethods___default",
    path: "/sp/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___en",
    path: "/sp/en/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___ar",
    path: "/sp/ar/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___fr",
    path: "/sp/fr/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___de",
    path: "/sp/de/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___es",
    path: "/sp/es/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spMyPaymentMethods___ro",
    path: "/sp/ro/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "spmyPurchases___default",
    path: "/sp/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___en",
    path: "/sp/en/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___ar",
    path: "/sp/ar/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___fr",
    path: "/sp/fr/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___de",
    path: "/sp/de/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___es",
    path: "/sp/es/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spmyPurchases___ro",
    path: "/sp/ro/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___default",
    path: "/sp/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___en",
    path: "/sp/en/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___ar",
    path: "/sp/ar/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___fr",
    path: "/sp/fr/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___de",
    path: "/sp/de/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___es",
    path: "/sp/es/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory-articlename-article___ro",
    path: "/sp/ro/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "spnews-category-subcategory___default",
    path: "/sp/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___en",
    path: "/sp/en/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___ar",
    path: "/sp/ar/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___fr",
    path: "/sp/fr/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___de",
    path: "/sp/de/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___es",
    path: "/sp/es/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category-subcategory___ro",
    path: "/sp/ro/news/:category()/:subcategory()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "spnews-category___default",
    path: "/sp/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___en",
    path: "/sp/en/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___ar",
    path: "/sp/ar/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___fr",
    path: "/sp/fr/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___de",
    path: "/sp/de/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___es",
    path: "/sp/es/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnews-category___ro",
    path: "/sp/ro/news/:category()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "spnotifications___default",
    path: "/sp/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___en",
    path: "/sp/en/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___ar",
    path: "/sp/ar/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___fr",
    path: "/sp/fr/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___de",
    path: "/sp/de/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___es",
    path: "/sp/es/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spnotifications___ro",
    path: "/sp/ro/notifications",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "spparentalControl___default",
    path: "/sp/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___en",
    path: "/sp/en/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___ar",
    path: "/sp/ar/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___fr",
    path: "/sp/fr/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___de",
    path: "/sp/de/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___es",
    path: "/sp/es/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "spparentalControl___ro",
    path: "/sp/ro/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "sppartner-registration___default",
    path: "/sp/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___en",
    path: "/sp/en/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___ar",
    path: "/sp/ar/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___fr",
    path: "/sp/fr/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___de",
    path: "/sp/de/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___es",
    path: "/sp/es/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-registration___ro",
    path: "/sp/ro/partner-registration",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "sppartner-subscriptions-id___default",
    path: "/sp/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___en",
    path: "/sp/en/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___ar",
    path: "/sp/ar/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___fr",
    path: "/sp/fr/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___de",
    path: "/sp/de/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___es",
    path: "/sp/es/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions-id___ro",
    path: "/sp/ro/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "sppartner-subscriptions___default",
    path: "/sp/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___en",
    path: "/sp/en/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___ar",
    path: "/sp/ar/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___fr",
    path: "/sp/fr/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___de",
    path: "/sp/de/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___es",
    path: "/sp/es/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartner-subscriptions___ro",
    path: "/sp/ro/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "sppartners-name___default",
    path: "/sp/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___en",
    path: "/sp/en/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___ar",
    path: "/sp/ar/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___fr",
    path: "/sp/fr/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___de",
    path: "/sp/de/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___es",
    path: "/sp/es/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-name___ro",
    path: "/sp/ro/partners/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "sppartners-info-services-name___default",
    path: "/sp/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___en",
    path: "/sp/en/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___ar",
    path: "/sp/ar/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___fr",
    path: "/sp/fr/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___de",
    path: "/sp/de/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___es",
    path: "/sp/es/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services-name___ro",
    path: "/sp/ro/partners/info-services/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "sppartners-info-services___default",
    path: "/sp/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___en",
    path: "/sp/en/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___ar",
    path: "/sp/ar/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___fr",
    path: "/sp/fr/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___de",
    path: "/sp/de/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___es",
    path: "/sp/es/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppartners-info-services___ro",
    path: "/sp/ro/partners/info-services",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "sppodcast-details-id___default",
    path: "/sp/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___en",
    path: "/sp/en/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___ar",
    path: "/sp/ar/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___fr",
    path: "/sp/fr/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___de",
    path: "/sp/de/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___es",
    path: "/sp/es/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details-id___ro",
    path: "/sp/ro/podcast/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-episode-id___default",
    path: "/sp/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___en",
    path: "/sp/en/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___ar",
    path: "/sp/ar/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___fr",
    path: "/sp/fr/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___de",
    path: "/sp/de/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___es",
    path: "/sp/es/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode-id___ro",
    path: "/sp/ro/podcast/episode/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-list___default",
    path: "/sp/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___en",
    path: "/sp/en/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___ar",
    path: "/sp/ar/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___fr",
    path: "/sp/fr/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___de",
    path: "/sp/de/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___es",
    path: "/sp/es/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "sppodcast-list___ro",
    path: "/sp/ro/podcast/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "spprofile___default",
    path: "/sp/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___en",
    path: "/sp/en/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___ar",
    path: "/sp/ar/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___fr",
    path: "/sp/fr/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___de",
    path: "/sp/de/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___es",
    path: "/sp/es/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile___ro",
    path: "/sp/ro/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___default",
    path: "/sp/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___en",
    path: "/sp/en/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___ar",
    path: "/sp/ar/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___fr",
    path: "/sp/fr/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___de",
    path: "/sp/de/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___es",
    path: "/sp/es/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info-service-subscriptions___ro",
    path: "/sp/ro/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "spprofile-info___default",
    path: "/sp/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___en",
    path: "/sp/en/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___ar",
    path: "/sp/ar/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___fr",
    path: "/sp/fr/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___de",
    path: "/sp/de/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___es",
    path: "/sp/es/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-info___ro",
    path: "/sp/ro/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "spprofile-manage___default",
    path: "/sp/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___en",
    path: "/sp/en/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___ar",
    path: "/sp/ar/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___fr",
    path: "/sp/fr/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___de",
    path: "/sp/de/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___es",
    path: "/sp/es/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-manage___ro",
    path: "/sp/ro/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "spprofile-preferences___default",
    path: "/sp/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___en",
    path: "/sp/en/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___ar",
    path: "/sp/ar/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___fr",
    path: "/sp/fr/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___de",
    path: "/sp/de/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___es",
    path: "/sp/es/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-preferences___ro",
    path: "/sp/ro/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "spprofile-privacy-settings___default",
    path: "/sp/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___en",
    path: "/sp/en/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___ar",
    path: "/sp/ar/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___fr",
    path: "/sp/fr/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___de",
    path: "/sp/de/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___es",
    path: "/sp/es/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spprofile-privacy-settings___ro",
    path: "/sp/ro/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "spresetpassword___default",
    path: "/sp/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___en",
    path: "/sp/en/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___ar",
    path: "/sp/ar/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___fr",
    path: "/sp/fr/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___de",
    path: "/sp/de/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___es",
    path: "/sp/es/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spresetpassword___ro",
    path: "/sp/ro/resetpassword",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "spreward___default",
    path: "/sp/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___en",
    path: "/sp/en/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___ar",
    path: "/sp/ar/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___fr",
    path: "/sp/fr/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___de",
    path: "/sp/de/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___es",
    path: "/sp/es/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spreward___ro",
    path: "/sp/ro/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "spsearch___default",
    path: "/sp/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___en",
    path: "/sp/en/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___ar",
    path: "/sp/ar/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___fr",
    path: "/sp/fr/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___de",
    path: "/sp/de/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___es",
    path: "/sp/es/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch___ro",
    path: "/sp/ro/search",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsubscription___default",
    path: "/sp/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___en",
    path: "/sp/en/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___ar",
    path: "/sp/ar/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___fr",
    path: "/sp/fr/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___de",
    path: "/sp/de/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___es",
    path: "/sp/es/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "spsubscription___ro",
    path: "/sp/ro/subscription",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "sptournaments-details-id___default",
    path: "/sp/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___en",
    path: "/sp/en/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___ar",
    path: "/sp/ar/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___fr",
    path: "/sp/fr/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___de",
    path: "/sp/de/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___es",
    path: "/sp/es/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-details-id___ro",
    path: "/sp/ro/tournaments/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___default",
    path: "/sp/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___en",
    path: "/sp/en/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___ar",
    path: "/sp/ar/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___fr",
    path: "/sp/fr/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___de",
    path: "/sp/de/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___es",
    path: "/sp/es/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-news-details-id___ro",
    path: "/sp/ro/tournaments/news/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___default",
    path: "/sp/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___en",
    path: "/sp/en/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___ar",
    path: "/sp/ar/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___fr",
    path: "/sp/fr/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___de",
    path: "/sp/de/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___es",
    path: "/sp/es/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "sptournaments-videos-details-id___ro",
    path: "/sp/ro/tournaments/videos/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "spuser-login-email___default",
    path: "/sp/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___en",
    path: "/sp/en/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___ar",
    path: "/sp/ar/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___fr",
    path: "/sp/fr/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___de",
    path: "/sp/de/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___es",
    path: "/sp/es/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login-email___ro",
    path: "/sp/ro/user/login/email",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "spuser-login___default",
    path: "/sp/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___en",
    path: "/sp/en/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___ar",
    path: "/sp/ar/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___fr",
    path: "/sp/fr/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___de",
    path: "/sp/de/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___es",
    path: "/sp/es/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-login___ro",
    path: "/sp/ro/user/login",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "spuser-register___default",
    path: "/sp/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___en",
    path: "/sp/en/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___ar",
    path: "/sp/ar/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___fr",
    path: "/sp/fr/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___de",
    path: "/sp/de/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___es",
    path: "/sp/es/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spuser-register___ro",
    path: "/sp/ro/user/register",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "spvideo-ex-category-id___default",
    path: "/sp/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___en",
    path: "/sp/en/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___ar",
    path: "/sp/ar/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___fr",
    path: "/sp/fr/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___de",
    path: "/sp/de/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___es",
    path: "/sp/es/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-category-id___ro",
    path: "/sp/ro/video/:ex()/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___default",
    path: "/sp/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___en",
    path: "/sp/en/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___ar",
    path: "/sp/ar/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___fr",
    path: "/sp/fr/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___de",
    path: "/sp/de/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___es",
    path: "/sp/es/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-details-id___ro",
    path: "/sp/ro/video/:ex()/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___default",
    path: "/sp/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___en",
    path: "/sp/en/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___ar",
    path: "/sp/ar/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___fr",
    path: "/sp/fr/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___de",
    path: "/sp/de/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___es",
    path: "/sp/es/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-ex-stream-id___ro",
    path: "/sp/ro/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"sp"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spvideo-category-name-id___default",
    path: "/sp/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___en",
    path: "/sp/en/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___ar",
    path: "/sp/ar/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___fr",
    path: "/sp/fr/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___de",
    path: "/sp/de/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___es",
    path: "/sp/es/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category-name-id___ro",
    path: "/sp/ro/video/category/:name()/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-details-id___default",
    path: "/sp/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___en",
    path: "/sp/en/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___ar",
    path: "/sp/ar/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___fr",
    path: "/sp/fr/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___de",
    path: "/sp/de/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___es",
    path: "/sp/es/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details-id___ro",
    path: "/sp/ro/video/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-list-name___default",
    path: "/sp/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___en",
    path: "/sp/en/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___ar",
    path: "/sp/ar/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___fr",
    path: "/sp/fr/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___de",
    path: "/sp/de/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___es",
    path: "/sp/es/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-list-name___ro",
    path: "/sp/ro/video/list/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "spvideo-series-details-id___default",
    path: "/sp/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___en",
    path: "/sp/en/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___ar",
    path: "/sp/ar/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___fr",
    path: "/sp/fr/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___de",
    path: "/sp/de/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___es",
    path: "/sp/es/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series-details-id___ro",
    path: "/sp/ro/video/series/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-stream-id___default",
    path: "/sp/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___en",
    path: "/sp/en/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___ar",
    path: "/sp/ar/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___fr",
    path: "/sp/fr/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___de",
    path: "/sp/de/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___es",
    path: "/sp/es/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream-id___ro",
    path: "/sp/ro/video/stream/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-test___default",
    path: "/sp/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___en",
    path: "/sp/en/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___ar",
    path: "/sp/ar/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___fr",
    path: "/sp/fr/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___de",
    path: "/sp/de/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___es",
    path: "/sp/es/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvideo-test___ro",
    path: "/sp/ro/video/test",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "spvoucherbooks-name___default",
    path: "/sp/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___en",
    path: "/sp/en/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___ar",
    path: "/sp/ar/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___fr",
    path: "/sp/fr/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___de",
    path: "/sp/de/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___es",
    path: "/sp/es/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvoucherbooks-name___ro",
    path: "/sp/ro/voucherbooks/:name()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "spvouchers-category-id___default",
    path: "/sp/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___en",
    path: "/sp/en/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___ar",
    path: "/sp/ar/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___fr",
    path: "/sp/fr/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___de",
    path: "/sp/de/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___es",
    path: "/sp/es/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-category-id___ro",
    path: "/sp/ro/vouchers/category/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "spvouchers-details-id___default",
    path: "/sp/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___en",
    path: "/sp/en/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___ar",
    path: "/sp/ar/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___fr",
    path: "/sp/fr/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___de",
    path: "/sp/de/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___es",
    path: "/sp/es/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-id___ro",
    path: "/sp/ro/vouchers/details/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-genre-id___default",
    path: "/sp/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___en",
    path: "/sp/en/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___ar",
    path: "/sp/ar/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___fr",
    path: "/sp/fr/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___de",
    path: "/sp/de/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___es",
    path: "/sp/es/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spvouchers-genre-id___ro",
    path: "/sp/ro/vouchers/genre/:id()",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "spmain___default",
    path: "/sp/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___en",
    path: "/sp/en/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___ar",
    path: "/sp/ar/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___fr",
    path: "/sp/fr/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___de",
    path: "/sp/de/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___es",
    path: "/sp/es/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmain___ro",
    path: "/sp/ro/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "spmusic-track___default",
    path: "/sp/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___en",
    path: "/sp/en/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___ar",
    path: "/sp/ar/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___fr",
    path: "/sp/fr/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___de",
    path: "/sp/de/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___es",
    path: "/sp/es/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmusic-track___ro",
    path: "/sp/ro/music/tracks/:title/:track",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "spmonsooq-app-consent-details___default",
    path: "/sp/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___en",
    path: "/sp/en/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___ar",
    path: "/sp/ar/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___fr",
    path: "/sp/fr/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___de",
    path: "/sp/de/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___es",
    path: "/sp/es/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-consent-details___ro",
    path: "/sp/ro/apps/consent/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___default",
    path: "/sp/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___en",
    path: "/sp/en/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___ar",
    path: "/sp/ar/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___fr",
    path: "/sp/fr/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___de",
    path: "/sp/de/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___es",
    path: "/sp/es/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-detail___ro",
    path: "/sp/ro/apps/partner/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___default",
    path: "/sp/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___en",
    path: "/sp/en/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___ar",
    path: "/sp/ar/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___fr",
    path: "/sp/fr/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___de",
    path: "/sp/de/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___es",
    path: "/sp/es/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spmonsooq-app-partner-details___ro",
    path: "/sp/ro/apps/pd/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "spment-app-partner-details___default",
    path: "/sp/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___en",
    path: "/sp/en/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___ar",
    path: "/sp/ar/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___fr",
    path: "/sp/fr/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___de",
    path: "/sp/de/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___es",
    path: "/sp/es/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-details___ro",
    path: "/sp/ro/mp/:title/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "spment-app-partner-categories-details___default",
    path: "/sp/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___en",
    path: "/sp/en/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___ar",
    path: "/sp/ar/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___fr",
    path: "/sp/fr/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___de",
    path: "/sp/de/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___es",
    path: "/sp/es/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spment-app-partner-categories-details___ro",
    path: "/sp/ro/mp/:category",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "spmanage-subscription-details___default",
    path: "/sp/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___en",
    path: "/sp/en/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___ar",
    path: "/sp/ar/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___fr",
    path: "/sp/fr/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___de",
    path: "/sp/de/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___es",
    path: "/sp/es/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmanage-subscription-details___ro",
    path: "/sp/ro/apps/manage/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "spmusic-artistName-albumName___default",
    path: "/sp/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___en",
    path: "/sp/en/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___ar",
    path: "/sp/ar/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___fr",
    path: "/sp/fr/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___de",
    path: "/sp/de/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___es",
    path: "/sp/es/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artistName-albumName___ro",
    path: "/sp/ro/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "spmusic-artist___default",
    path: "/sp/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___en",
    path: "/sp/en/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___ar",
    path: "/sp/ar/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___fr",
    path: "/sp/fr/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___de",
    path: "/sp/de/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___es",
    path: "/sp/es/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-artist___ro",
    path: "/sp/ro/music/artists/:artistName/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "spmusic-playlist___default",
    path: "/sp/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___en",
    path: "/sp/en/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___ar",
    path: "/sp/ar/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___fr",
    path: "/sp/fr/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___de",
    path: "/sp/de/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___es",
    path: "/sp/es/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "spmusic-playlist___ro",
    path: "/sp/ro/music/playlists/:title/:playlist",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "sppodcast-details___default",
    path: "/sp/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___en",
    path: "/sp/en/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___ar",
    path: "/sp/ar/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___fr",
    path: "/sp/fr/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___de",
    path: "/sp/de/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___es",
    path: "/sp/es/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___ro",
    path: "/sp/ro/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-episode___default",
    path: "/sp/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___en",
    path: "/sp/en/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___ar",
    path: "/sp/ar/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___fr",
    path: "/sp/fr/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___de",
    path: "/sp/de/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___es",
    path: "/sp/es/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___ro",
    path: "/sp/ro/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "spaudiobook-details___default",
    path: "/sp/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___en",
    path: "/sp/en/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___ar",
    path: "/sp/ar/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___fr",
    path: "/sp/fr/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___de",
    path: "/sp/de/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___es",
    path: "/sp/es/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-details___ro",
    path: "/sp/ro/audiobook/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "spaudiobook-artists___default",
    path: "/sp/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___en",
    path: "/sp/en/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___ar",
    path: "/sp/ar/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___fr",
    path: "/sp/fr/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___de",
    path: "/sp/de/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___es",
    path: "/sp/es/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spaudiobook-artists___ro",
    path: "/sp/ro/audiobook/artists/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "spgames-category___default",
    path: "/sp/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___en",
    path: "/sp/en/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___ar",
    path: "/sp/ar/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___fr",
    path: "/sp/fr/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___de",
    path: "/sp/de/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___es",
    path: "/sp/es/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-category___ro",
    path: "/sp/ro/games/category/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "spgames-details___default",
    path: "/sp/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___en",
    path: "/sp/en/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___ar",
    path: "/sp/ar/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___fr",
    path: "/sp/fr/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___de",
    path: "/sp/de/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___es",
    path: "/sp/es/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-details___ro",
    path: "/sp/ro/games/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "spgames-list___default",
    path: "/sp/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___en",
    path: "/sp/en/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___ar",
    path: "/sp/ar/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___fr",
    path: "/sp/fr/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___de",
    path: "/sp/de/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___es",
    path: "/sp/es/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "spgames-list___ro",
    path: "/sp/ro/games/list",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "sparcade-details___default",
    path: "/sp/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___en",
    path: "/sp/en/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___ar",
    path: "/sp/ar/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___fr",
    path: "/sp/fr/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___de",
    path: "/sp/de/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___es",
    path: "/sp/es/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sparcade-details___ro",
    path: "/sp/ro/arcade/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "sppodcast-details___default",
    path: "/sp/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___en",
    path: "/sp/en/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___ar",
    path: "/sp/ar/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___fr",
    path: "/sp/fr/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___de",
    path: "/sp/de/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___es",
    path: "/sp/es/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-details___ro",
    path: "/sp/ro/podcast/details/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "sppodcast-episode___default",
    path: "/sp/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___en",
    path: "/sp/en/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___ar",
    path: "/sp/ar/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___fr",
    path: "/sp/fr/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___de",
    path: "/sp/de/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___es",
    path: "/sp/es/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "sppodcast-episode___ro",
    path: "/sp/ro/podcast/episode/:title/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "spvideo-details___default",
    path: "/sp/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___en",
    path: "/sp/en/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___ar",
    path: "/sp/ar/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___fr",
    path: "/sp/fr/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___de",
    path: "/sp/de/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___es",
    path: "/sp/es/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spvideo-details___ro",
    path: "/sp/ro/video/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "spex-video-details___default",
    path: "/sp/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___en",
    path: "/sp/en/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___ar",
    path: "/sp/ar/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___fr",
    path: "/sp/fr/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___de",
    path: "/sp/de/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___es",
    path: "/sp/es/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spex-video-details___ro",
    path: "/sp/ro/video/:ex/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "spvideo-series___default",
    path: "/sp/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___en",
    path: "/sp/en/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___ar",
    path: "/sp/ar/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___fr",
    path: "/sp/fr/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___de",
    path: "/sp/de/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___es",
    path: "/sp/es/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-series___ro",
    path: "/sp/ro/video/series/details/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "spvideo-stream___default",
    path: "/sp/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___en",
    path: "/sp/en/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___ar",
    path: "/sp/ar/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___fr",
    path: "/sp/fr/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___de",
    path: "/sp/de/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___es",
    path: "/sp/es/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-stream___ro",
    path: "/sp/ro/video/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "spvideo-category___default",
    path: "/sp/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___en",
    path: "/sp/en/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___ar",
    path: "/sp/ar/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___fr",
    path: "/sp/fr/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___de",
    path: "/sp/de/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___es",
    path: "/sp/es/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spvideo-category___ro",
    path: "/sp/ro/video/category/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "spex-video-stream___default",
    path: "/sp/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___en",
    path: "/sp/en/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___ar",
    path: "/sp/ar/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___fr",
    path: "/sp/fr/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___de",
    path: "/sp/de/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___es",
    path: "/sp/es/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spex-video-stream___ro",
    path: "/sp/ro/video/:ex/stream/:name/:id",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "spservices-page___default",
    path: "/sp/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___en",
    path: "/sp/en/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___ar",
    path: "/sp/ar/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___fr",
    path: "/sp/fr/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___de",
    path: "/sp/de/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___es",
    path: "/sp/es/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spservices-page___ro",
    path: "/sp/ro/services/:name",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "spsearch-q___default",
    path: "/sp/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___en",
    path: "/sp/en/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___ar",
    path: "/sp/ar/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___fr",
    path: "/sp/fr/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___de",
    path: "/sp/de/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___es",
    path: "/sp/es/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spsearch-q___ro",
    path: "/sp/ro/search-q",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "spvouchers-details-voucher___default",
    path: "/sp/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___en",
    path: "/sp/en/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___ar",
    path: "/sp/ar/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___fr",
    path: "/sp/fr/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___de",
    path: "/sp/de/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___es",
    path: "/sp/es/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "spvouchers-details-voucher___ro",
    path: "/sp/ro/vouchers/details/:id/:voucherId",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "sparticles-category-article___default",
    path: "/sp/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___en",
    path: "/sp/en/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___ar",
    path: "/sp/ar/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___fr",
    path: "/sp/fr/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___de",
    path: "/sp/de/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___es",
    path: "/sp/es/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "sparticles-category-article___ro",
    path: "/sp/ro/articles/:category?/:article",
    meta: {"country":"sp"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auapps-consent-id___default",
    path: "/au/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___en",
    path: "/au/en/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___ar",
    path: "/au/ar/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___fr",
    path: "/au/fr/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___de",
    path: "/au/de/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___es",
    path: "/au/es/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-consent-id___ro",
    path: "/au/ro/apps/consent/:id()",
    meta: { ...(_91id_93yzEYYFc3A2Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "auapps-faq___default",
    path: "/au/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___en",
    path: "/au/en/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___ar",
    path: "/au/ar/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___fr",
    path: "/au/fr/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___de",
    path: "/au/de/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___es",
    path: "/au/es/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-faq___ro",
    path: "/au/ro/apps/faq",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/faq/index.vue")
  },
  {
    name: "auapps-manage-id___default",
    path: "/au/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___en",
    path: "/au/en/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___ar",
    path: "/au/ar/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___fr",
    path: "/au/fr/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___de",
    path: "/au/de/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___es",
    path: "/au/es/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage-id___ro",
    path: "/au/ro/apps/manage/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "auapps-manage___default",
    path: "/au/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___en",
    path: "/au/en/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___ar",
    path: "/au/ar/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___fr",
    path: "/au/fr/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___de",
    path: "/au/de/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___es",
    path: "/au/es/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-manage___ro",
    path: "/au/ro/apps/manage",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/index.vue")
  },
  {
    name: "auapps-partner-name___default",
    path: "/au/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___en",
    path: "/au/en/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___ar",
    path: "/au/ar/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___fr",
    path: "/au/fr/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___de",
    path: "/au/de/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___es",
    path: "/au/es/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-partner-name___ro",
    path: "/au/ro/apps/partner/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "auapps-pd-name___default",
    path: "/au/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___en",
    path: "/au/en/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___ar",
    path: "/au/ar/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___fr",
    path: "/au/fr/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___de",
    path: "/au/de/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___es",
    path: "/au/es/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-pd-name___ro",
    path: "/au/ro/apps/pd/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "auapps-profile___default",
    path: "/au/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___en",
    path: "/au/en/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___ar",
    path: "/au/ar/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___fr",
    path: "/au/fr/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___de",
    path: "/au/de/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___es",
    path: "/au/es/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-profile___ro",
    path: "/au/ro/apps/profile",
    meta: { ...(indexS0luP2HbY0Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/apps/profile/index.vue")
  },
  {
    name: "auapps-register___default",
    path: "/au/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___en",
    path: "/au/en/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___ar",
    path: "/au/ar/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___fr",
    path: "/au/fr/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___de",
    path: "/au/de/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___es",
    path: "/au/es/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-register___ro",
    path: "/au/ro/apps/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/register/index.vue")
  },
  {
    name: "auapps-viewAll___default",
    path: "/au/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___en",
    path: "/au/en/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___ar",
    path: "/au/ar/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___fr",
    path: "/au/fr/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___de",
    path: "/au/de/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___es",
    path: "/au/es/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auapps-viewAll___ro",
    path: "/au/ro/apps/viewAll",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/viewAll/index.vue")
  },
  {
    name: "auarcade-details-id___default",
    path: "/au/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___en",
    path: "/au/en/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___ar",
    path: "/au/ar/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___fr",
    path: "/au/fr/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___de",
    path: "/au/de/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___es",
    path: "/au/es/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details-id___ro",
    path: "/au/ro/arcade/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarticles-category-subcategory-article___default",
    path: "/au/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___en",
    path: "/au/en/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___ar",
    path: "/au/ar/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___fr",
    path: "/au/fr/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___de",
    path: "/au/de/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___es",
    path: "/au/es/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory-article___ro",
    path: "/au/ro/articles/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-subcategory___default",
    path: "/au/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___en",
    path: "/au/en/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___ar",
    path: "/au/ar/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___fr",
    path: "/au/fr/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___de",
    path: "/au/de/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___es",
    path: "/au/es/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category-subcategory___ro",
    path: "/au/ro/articles/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-category___default",
    path: "/au/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___en",
    path: "/au/en/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___ar",
    path: "/au/ar/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___fr",
    path: "/au/fr/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___de",
    path: "/au/de/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___es",
    path: "/au/es/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-category___ro",
    path: "/au/ro/articles/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___default",
    path: "/au/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___en",
    path: "/au/en/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___ar",
    path: "/au/ar/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___fr",
    path: "/au/fr/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___de",
    path: "/au/de/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___es",
    path: "/au/es/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory-article___ro",
    path: "/au/ro/articles/premium/:category()/:subcategory()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-premium-category-subcategory___default",
    path: "/au/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___en",
    path: "/au/en/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___ar",
    path: "/au/ar/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___fr",
    path: "/au/fr/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___de",
    path: "/au/de/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___es",
    path: "/au/es/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category-subcategory___ro",
    path: "/au/ro/articles/premium/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/[subcategory]/index.vue")
  },
  {
    name: "auarticles-premium-category___default",
    path: "/au/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___en",
    path: "/au/en/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___ar",
    path: "/au/ar/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___fr",
    path: "/au/fr/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___de",
    path: "/au/de/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___es",
    path: "/au/es/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium-category___ro",
    path: "/au/ro/articles/premium/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/[category]/index.vue")
  },
  {
    name: "auarticles-premium___default",
    path: "/au/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___en",
    path: "/au/en/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___ar",
    path: "/au/ar/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___fr",
    path: "/au/fr/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___de",
    path: "/au/de/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___es",
    path: "/au/es/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auarticles-premium___ro",
    path: "/au/ro/articles/premium",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/premium/index.vue")
  },
  {
    name: "auaudiobook-artists-id___default",
    path: "/au/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___en",
    path: "/au/en/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___ar",
    path: "/au/ar/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___fr",
    path: "/au/fr/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___de",
    path: "/au/de/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___es",
    path: "/au/es/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists-id___ro",
    path: "/au/ro/audiobook/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-category___default",
    path: "/au/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___en",
    path: "/au/en/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___ar",
    path: "/au/ar/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___fr",
    path: "/au/fr/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___de",
    path: "/au/de/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___es",
    path: "/au/es/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-category___ro",
    path: "/au/ro/audiobook/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/category/index.vue")
  },
  {
    name: "auaudiobook-details-id___default",
    path: "/au/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___en",
    path: "/au/en/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___ar",
    path: "/au/ar/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___fr",
    path: "/au/fr/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___de",
    path: "/au/de/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___es",
    path: "/au/es/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details-id___ro",
    path: "/au/ro/audiobook/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-genre-name___default",
    path: "/au/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___en",
    path: "/au/en/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___ar",
    path: "/au/ar/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___fr",
    path: "/au/fr/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___de",
    path: "/au/de/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___es",
    path: "/au/es/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-genre-name___ro",
    path: "/au/ro/audiobook/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/genre/[name].vue")
  },
  {
    name: "auaudiobook-list___default",
    path: "/au/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___en",
    path: "/au/en/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___ar",
    path: "/au/ar/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___fr",
    path: "/au/fr/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___de",
    path: "/au/de/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___es",
    path: "/au/es/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "auaudiobook-list___ro",
    path: "/au/ro/audiobook/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/list/index.vue")
  },
  {
    name: "aubilling-history___default",
    path: "/au/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___en",
    path: "/au/en/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___ar",
    path: "/au/ar/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___fr",
    path: "/au/fr/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___de",
    path: "/au/de/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___es",
    path: "/au/es/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "aubilling-history___ro",
    path: "/au/ro/billing-history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/billing-history/index.vue")
  },
  {
    name: "auexternal-logout___default",
    path: "/au/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___en",
    path: "/au/en/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___ar",
    path: "/au/ar/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___fr",
    path: "/au/fr/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___de",
    path: "/au/de/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___es",
    path: "/au/es/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "auexternal-logout___ro",
    path: "/au/ro/external/logout",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/external/logout.vue")
  },
  {
    name: "aufavorites___default",
    path: "/au/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___en",
    path: "/au/en/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___ar",
    path: "/au/ar/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___fr",
    path: "/au/fr/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___de",
    path: "/au/de/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___es",
    path: "/au/es/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "aufavorites___ro",
    path: "/au/ro/favorites",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/favorites/index.vue")
  },
  {
    name: "augames-category-name___default",
    path: "/au/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___en",
    path: "/au/en/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___ar",
    path: "/au/ar/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___fr",
    path: "/au/fr/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___de",
    path: "/au/de/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___es",
    path: "/au/es/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category-name___ro",
    path: "/au/ro/games/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-details-id___default",
    path: "/au/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___en",
    path: "/au/en/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___ar",
    path: "/au/ar/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___fr",
    path: "/au/fr/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___de",
    path: "/au/de/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___es",
    path: "/au/es/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details-id___ro",
    path: "/au/ro/games/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-list-name-id___default",
    path: "/au/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___en",
    path: "/au/en/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___ar",
    path: "/au/ar/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___fr",
    path: "/au/fr/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___de",
    path: "/au/de/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___es",
    path: "/au/es/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name-id___ro",
    path: "/au/ro/games/list/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/[id].vue")
  },
  {
    name: "augames-list-name___default",
    path: "/au/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___en",
    path: "/au/en/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___ar",
    path: "/au/ar/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___fr",
    path: "/au/fr/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___de",
    path: "/au/de/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___es",
    path: "/au/es/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list-name___ro",
    path: "/au/ro/games/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___default",
    path: "/au/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___en",
    path: "/au/en/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___ar",
    path: "/au/ar/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___fr",
    path: "/au/fr/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___de",
    path: "/au/de/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___es",
    path: "/au/es/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "augames-publisher-name___ro",
    path: "/au/ro/games/publisher/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/publisher/[name]/index.vue")
  },
  {
    name: "auhistory___default",
    path: "/au/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___en",
    path: "/au/en/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___ar",
    path: "/au/ar/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___fr",
    path: "/au/fr/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___de",
    path: "/au/de/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___es",
    path: "/au/es/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auhistory___ro",
    path: "/au/ro/history",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/history/index.vue")
  },
  {
    name: "auimpressum___default",
    path: "/au/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___en",
    path: "/au/en/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___ar",
    path: "/au/ar/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___fr",
    path: "/au/fr/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___de",
    path: "/au/de/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___es",
    path: "/au/es/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auimpressum___ro",
    path: "/au/ro/impressum",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/impressum/index.vue")
  },
  {
    name: "auindex___default",
    path: "/au/",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___en",
    path: "/au/en",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___ar",
    path: "/au/ar",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___fr",
    path: "/au/fr",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___de",
    path: "/au/de",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___es",
    path: "/au/es",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auindex___ro",
    path: "/au/ro",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/index.vue")
  },
  {
    name: "auinfo-name___default",
    path: "/au/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___en",
    path: "/au/en/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___ar",
    path: "/au/ar/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___fr",
    path: "/au/fr/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___de",
    path: "/au/de/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___es",
    path: "/au/es/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinfo-name___ro",
    path: "/au/ro/info/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/info/[name].vue")
  },
  {
    name: "auinternal-redirect___default",
    path: "/au/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___en",
    path: "/au/en/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___ar",
    path: "/au/ar/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___fr",
    path: "/au/fr/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___de",
    path: "/au/de/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___es",
    path: "/au/es/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "auinternal-redirect___ro",
    path: "/au/ro/internal-redirect",
    meta: { ...(indexR6FNvP4FlUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/internal-redirect/index.vue")
  },
  {
    name: "aulaunch___default",
    path: "/au/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___en",
    path: "/au/en/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___ar",
    path: "/au/ar/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___fr",
    path: "/au/fr/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___de",
    path: "/au/de/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___es",
    path: "/au/es/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aulaunch___ro",
    path: "/au/ro/launch",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/launch/index.vue")
  },
  {
    name: "aumain-name___default",
    path: "/au/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___en",
    path: "/au/en/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___ar",
    path: "/au/ar/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___fr",
    path: "/au/fr/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___de",
    path: "/au/de/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___es",
    path: "/au/es/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain-name___ro",
    path: "/au/ro/main/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumarketing-name___default",
    path: "/au/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___en",
    path: "/au/en/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___ar",
    path: "/au/ar/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___fr",
    path: "/au/fr/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___de",
    path: "/au/de/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___es",
    path: "/au/es/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aumarketing-name___ro",
    path: "/au/ro/marketing/:name()",
    meta: { ...(_91name_93BdFXGLczV3Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/marketing/[name].vue")
  },
  {
    name: "aump-category___default",
    path: "/au/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___en",
    path: "/au/en/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___ar",
    path: "/au/ar/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___fr",
    path: "/au/fr/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___de",
    path: "/au/de/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___es",
    path: "/au/es/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-category___ro",
    path: "/au/ro/mp/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aump-name___default",
    path: "/au/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___en",
    path: "/au/en/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___ar",
    path: "/au/ar/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___fr",
    path: "/au/fr/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___de",
    path: "/au/de/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___es",
    path: "/au/es/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aump-name___ro",
    path: "/au/ro/mp/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aumusic-albums-artist-album___default",
    path: "/au/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___en",
    path: "/au/en/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___ar",
    path: "/au/ar/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___fr",
    path: "/au/fr/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___de",
    path: "/au/de/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___es",
    path: "/au/es/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-artist-album___ro",
    path: "/au/ro/music/albums/:artist()/:album()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-albums-category-name___default",
    path: "/au/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___en",
    path: "/au/en/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___ar",
    path: "/au/ar/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___fr",
    path: "/au/fr/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___de",
    path: "/au/de/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___es",
    path: "/au/es/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums-category-name___ro",
    path: "/au/ro/music/albums/category/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/category/[name]/index.vue")
  },
  {
    name: "aumusic-albums___default",
    path: "/au/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___en",
    path: "/au/en/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___ar",
    path: "/au/ar/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___fr",
    path: "/au/fr/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___de",
    path: "/au/de/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___es",
    path: "/au/es/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-albums___ro",
    path: "/au/ro/music/albums",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/index.vue")
  },
  {
    name: "aumusic-artists-id___default",
    path: "/au/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___en",
    path: "/au/en/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___ar",
    path: "/au/ar/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___fr",
    path: "/au/fr/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___de",
    path: "/au/de/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___es",
    path: "/au/es/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artists-id___ro",
    path: "/au/ro/music/artists/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-genre-name___default",
    path: "/au/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___en",
    path: "/au/en/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___ar",
    path: "/au/ar/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___fr",
    path: "/au/fr/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___de",
    path: "/au/de/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___es",
    path: "/au/es/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-genre-name___ro",
    path: "/au/ro/music/genre/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/genre/[name].vue")
  },
  {
    name: "aumusic-list___default",
    path: "/au/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___en",
    path: "/au/en/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___ar",
    path: "/au/ar/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___fr",
    path: "/au/fr/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___de",
    path: "/au/de/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___es",
    path: "/au/es/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-list___ro",
    path: "/au/ro/music/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/list/index.vue")
  },
  {
    name: "aumusic-playlists-playlist___default",
    path: "/au/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___en",
    path: "/au/en/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___ar",
    path: "/au/ar/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___fr",
    path: "/au/fr/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___de",
    path: "/au/de/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___es",
    path: "/au/es/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists-playlist___ro",
    path: "/au/ro/music/playlists/:playlist()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlists___default",
    path: "/au/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___en",
    path: "/au/en/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___ar",
    path: "/au/ar/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___fr",
    path: "/au/fr/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___de",
    path: "/au/de/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___es",
    path: "/au/es/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-playlists___ro",
    path: "/au/ro/music/playlists",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/index.vue")
  },
  {
    name: "aumusic-tracks-track___default",
    path: "/au/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___en",
    path: "/au/en/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___ar",
    path: "/au/ar/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___fr",
    path: "/au/fr/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___de",
    path: "/au/de/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___es",
    path: "/au/es/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-track___ro",
    path: "/au/ro/music/tracks/:track()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-tracks-category___default",
    path: "/au/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___en",
    path: "/au/en/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___ar",
    path: "/au/ar/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___fr",
    path: "/au/fr/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___de",
    path: "/au/de/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___es",
    path: "/au/es/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks-category___ro",
    path: "/au/ro/music/tracks/category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/category/index.vue")
  },
  {
    name: "aumusic-tracks___default",
    path: "/au/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___en",
    path: "/au/en/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___ar",
    path: "/au/ar/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___fr",
    path: "/au/fr/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___de",
    path: "/au/de/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___es",
    path: "/au/es/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-tracks___ro",
    path: "/au/ro/music/tracks",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/index.vue")
  },
  {
    name: "aumusic-video-details-id___default",
    path: "/au/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___en",
    path: "/au/en/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___ar",
    path: "/au/ar/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___fr",
    path: "/au/fr/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___de",
    path: "/au/de/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___es",
    path: "/au/es/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumusic-video-details-id___ro",
    path: "/au/ro/music/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/video/details/[id].vue")
  },
  {
    name: "aumyCart___default",
    path: "/au/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___en",
    path: "/au/en/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___ar",
    path: "/au/ar/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___fr",
    path: "/au/fr/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___de",
    path: "/au/de/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___es",
    path: "/au/es/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "aumyCart___ro",
    path: "/au/ro/myCart",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/myCart/index.vue")
  },
  {
    name: "auMyPaymentMethods___default",
    path: "/au/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___en",
    path: "/au/en/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___ar",
    path: "/au/ar/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___fr",
    path: "/au/fr/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___de",
    path: "/au/de/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___es",
    path: "/au/es/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "auMyPaymentMethods___ro",
    path: "/au/ro/MyPaymentMethods",
    meta: { ...(index6pGKKfDkOHMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/MyPaymentMethods/index.vue")
  },
  {
    name: "aumyPurchases___default",
    path: "/au/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___en",
    path: "/au/en/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___ar",
    path: "/au/ar/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___fr",
    path: "/au/fr/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___de",
    path: "/au/de/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___es",
    path: "/au/es/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aumyPurchases___ro",
    path: "/au/ro/myPurchases",
    meta: { ...(indexIY0ZLhc27tMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/myPurchases/index.vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___default",
    path: "/au/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___en",
    path: "/au/en/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___ar",
    path: "/au/ar/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___fr",
    path: "/au/fr/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___de",
    path: "/au/de/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___es",
    path: "/au/es/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory-articlename-article___ro",
    path: "/au/ro/news/:category()/:subcategory()/:articlename()/:article()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/[articlename]/[article].vue")
  },
  {
    name: "aunews-category-subcategory___default",
    path: "/au/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___en",
    path: "/au/en/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___ar",
    path: "/au/ar/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___fr",
    path: "/au/fr/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___de",
    path: "/au/de/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___es",
    path: "/au/es/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category-subcategory___ro",
    path: "/au/ro/news/:category()/:subcategory()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/[subcategory]/index.vue")
  },
  {
    name: "aunews-category___default",
    path: "/au/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___en",
    path: "/au/en/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___ar",
    path: "/au/ar/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___fr",
    path: "/au/fr/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___de",
    path: "/au/de/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___es",
    path: "/au/es/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunews-category___ro",
    path: "/au/ro/news/:category()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/news/[category]/index.vue")
  },
  {
    name: "aunotifications___default",
    path: "/au/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___en",
    path: "/au/en/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___ar",
    path: "/au/ar/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___fr",
    path: "/au/fr/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___de",
    path: "/au/de/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___es",
    path: "/au/es/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "aunotifications___ro",
    path: "/au/ro/notifications",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/notifications/index.vue")
  },
  {
    name: "auparentalControl___default",
    path: "/au/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___en",
    path: "/au/en/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___ar",
    path: "/au/ar/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___fr",
    path: "/au/fr/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___de",
    path: "/au/de/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___es",
    path: "/au/es/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "auparentalControl___ro",
    path: "/au/ro/parentalControl",
    meta: { ...(indexDsxnMO4uncMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/parentalControl/index.vue")
  },
  {
    name: "aupartner-registration___default",
    path: "/au/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___en",
    path: "/au/en/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___ar",
    path: "/au/ar/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___fr",
    path: "/au/fr/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___de",
    path: "/au/de/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___es",
    path: "/au/es/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-registration___ro",
    path: "/au/ro/partner-registration",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partner-registration/index.vue")
  },
  {
    name: "aupartner-subscriptions-id___default",
    path: "/au/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___en",
    path: "/au/en/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___ar",
    path: "/au/ar/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___fr",
    path: "/au/fr/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___de",
    path: "/au/de/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___es",
    path: "/au/es/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions-id___ro",
    path: "/au/ro/partner-subscriptions/:id()",
    meta: { ...(_91id_93rWtBi4wOgNMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/[id].vue")
  },
  {
    name: "aupartner-subscriptions___default",
    path: "/au/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___en",
    path: "/au/en/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___ar",
    path: "/au/ar/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___fr",
    path: "/au/fr/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___de",
    path: "/au/de/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___es",
    path: "/au/es/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartner-subscriptions___ro",
    path: "/au/ro/partner-subscriptions",
    meta: { ...(index7VVRjMbykUMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/partner-subscriptions/index.vue")
  },
  {
    name: "aupartners-name___default",
    path: "/au/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___en",
    path: "/au/en/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___ar",
    path: "/au/ar/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___fr",
    path: "/au/fr/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___de",
    path: "/au/de/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___es",
    path: "/au/es/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-name___ro",
    path: "/au/ro/partners/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "aupartners-info-services-name___default",
    path: "/au/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___en",
    path: "/au/en/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___ar",
    path: "/au/ar/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___fr",
    path: "/au/fr/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___de",
    path: "/au/de/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___es",
    path: "/au/es/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services-name___ro",
    path: "/au/ro/partners/info-services/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/[name].vue")
  },
  {
    name: "aupartners-info-services___default",
    path: "/au/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___en",
    path: "/au/en/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___ar",
    path: "/au/ar/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___fr",
    path: "/au/fr/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___de",
    path: "/au/de/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___es",
    path: "/au/es/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupartners-info-services___ro",
    path: "/au/ro/partners/info-services",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/info-services/index.vue")
  },
  {
    name: "aupodcast-details-id___default",
    path: "/au/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___en",
    path: "/au/en/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___ar",
    path: "/au/ar/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___fr",
    path: "/au/fr/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___de",
    path: "/au/de/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___es",
    path: "/au/es/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details-id___ro",
    path: "/au/ro/podcast/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-episode-id___default",
    path: "/au/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___en",
    path: "/au/en/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___ar",
    path: "/au/ar/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___fr",
    path: "/au/fr/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___de",
    path: "/au/de/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___es",
    path: "/au/es/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode-id___ro",
    path: "/au/ro/podcast/episode/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-list___default",
    path: "/au/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___en",
    path: "/au/en/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___ar",
    path: "/au/ar/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___fr",
    path: "/au/fr/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___de",
    path: "/au/de/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___es",
    path: "/au/es/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "aupodcast-list___ro",
    path: "/au/ro/podcast/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/list/index.vue")
  },
  {
    name: "auprofile___default",
    path: "/au/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___en",
    path: "/au/en/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___ar",
    path: "/au/ar/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___fr",
    path: "/au/fr/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___de",
    path: "/au/de/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___es",
    path: "/au/es/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile___ro",
    path: "/au/ro/profile",
    meta: { ...(index5dStAfsfgtMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/index.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___default",
    path: "/au/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___en",
    path: "/au/en/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___ar",
    path: "/au/ar/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___fr",
    path: "/au/fr/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___de",
    path: "/au/de/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___es",
    path: "/au/es/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info-service-subscriptions___ro",
    path: "/au/ro/profile/info-service-subscriptions",
    meta: { ...(info_45service_45subscriptionsDCgXVbxQeeMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info-service-subscriptions.vue")
  },
  {
    name: "auprofile-info___default",
    path: "/au/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___en",
    path: "/au/en/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___ar",
    path: "/au/ar/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___fr",
    path: "/au/fr/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___de",
    path: "/au/de/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___es",
    path: "/au/es/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-info___ro",
    path: "/au/ro/profile/info",
    meta: { ...(infol5cACWvfvzMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/info.vue")
  },
  {
    name: "auprofile-manage___default",
    path: "/au/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___en",
    path: "/au/en/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___ar",
    path: "/au/ar/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___fr",
    path: "/au/fr/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___de",
    path: "/au/de/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___es",
    path: "/au/es/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-manage___ro",
    path: "/au/ro/profile/manage",
    meta: { ...(manage53bNHwVbM6Meta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/manage.vue")
  },
  {
    name: "auprofile-preferences___default",
    path: "/au/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___en",
    path: "/au/en/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___ar",
    path: "/au/ar/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___fr",
    path: "/au/fr/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___de",
    path: "/au/de/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___es",
    path: "/au/es/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-preferences___ro",
    path: "/au/ro/profile/preferences",
    meta: { ...(preferencesQDAk4HZ3xZMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/preferences.vue")
  },
  {
    name: "auprofile-privacy-settings___default",
    path: "/au/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___en",
    path: "/au/en/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___ar",
    path: "/au/ar/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___fr",
    path: "/au/fr/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___de",
    path: "/au/de/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___es",
    path: "/au/es/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auprofile-privacy-settings___ro",
    path: "/au/ro/profile/privacy-settings",
    meta: { ...(privacy_45settingsHaWimkB2XAMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/profile/privacy-settings.vue")
  },
  {
    name: "auresetpassword___default",
    path: "/au/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___en",
    path: "/au/en/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___ar",
    path: "/au/ar/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___fr",
    path: "/au/fr/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___de",
    path: "/au/de/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___es",
    path: "/au/es/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "auresetpassword___ro",
    path: "/au/ro/resetpassword",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/resetpassword/index.vue")
  },
  {
    name: "aureward___default",
    path: "/au/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___en",
    path: "/au/en/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___ar",
    path: "/au/ar/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___fr",
    path: "/au/fr/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___de",
    path: "/au/de/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___es",
    path: "/au/es/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "aureward___ro",
    path: "/au/ro/reward",
    meta: { ...(indexlmTaoVSpovMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/reward/index.vue")
  },
  {
    name: "ausearch___default",
    path: "/au/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___en",
    path: "/au/en/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___ar",
    path: "/au/ar/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___fr",
    path: "/au/fr/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___de",
    path: "/au/de/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___es",
    path: "/au/es/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch___ro",
    path: "/au/ro/search",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausubscription___default",
    path: "/au/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___en",
    path: "/au/en/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___ar",
    path: "/au/ar/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___fr",
    path: "/au/fr/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___de",
    path: "/au/de/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___es",
    path: "/au/es/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "ausubscription___ro",
    path: "/au/ro/subscription",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/subscription/index.vue")
  },
  {
    name: "autournaments-details-id___default",
    path: "/au/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___en",
    path: "/au/en/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___ar",
    path: "/au/ar/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___fr",
    path: "/au/fr/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___de",
    path: "/au/de/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___es",
    path: "/au/es/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-details-id___ro",
    path: "/au/ro/tournaments/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___default",
    path: "/au/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___en",
    path: "/au/en/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___ar",
    path: "/au/ar/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___fr",
    path: "/au/fr/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___de",
    path: "/au/de/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___es",
    path: "/au/es/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-news-details-id___ro",
    path: "/au/ro/tournaments/news/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/news/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___default",
    path: "/au/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___en",
    path: "/au/en/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___ar",
    path: "/au/ar/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___fr",
    path: "/au/fr/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___de",
    path: "/au/de/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___es",
    path: "/au/es/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "autournaments-videos-details-id___ro",
    path: "/au/ro/tournaments/videos/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/tournaments/videos/details/[id].vue")
  },
  {
    name: "auuser-login-email___default",
    path: "/au/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___en",
    path: "/au/en/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___ar",
    path: "/au/ar/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___fr",
    path: "/au/fr/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___de",
    path: "/au/de/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___es",
    path: "/au/es/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login-email___ro",
    path: "/au/ro/user/login/email",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/email.vue")
  },
  {
    name: "auuser-login___default",
    path: "/au/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___en",
    path: "/au/en/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___ar",
    path: "/au/ar/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___fr",
    path: "/au/fr/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___de",
    path: "/au/de/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___es",
    path: "/au/es/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-login___ro",
    path: "/au/ro/user/login",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/login/index.vue")
  },
  {
    name: "auuser-register___default",
    path: "/au/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___en",
    path: "/au/en/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___ar",
    path: "/au/ar/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___fr",
    path: "/au/fr/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___de",
    path: "/au/de/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___es",
    path: "/au/es/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auuser-register___ro",
    path: "/au/ro/user/register",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/user/register/index.vue")
  },
  {
    name: "auvideo-ex-category-id___default",
    path: "/au/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___en",
    path: "/au/en/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___ar",
    path: "/au/ar/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___fr",
    path: "/au/fr/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___de",
    path: "/au/de/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___es",
    path: "/au/es/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-category-id___ro",
    path: "/au/ro/video/:ex()/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/category/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___default",
    path: "/au/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___en",
    path: "/au/en/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___ar",
    path: "/au/ar/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___fr",
    path: "/au/fr/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___de",
    path: "/au/de/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___es",
    path: "/au/es/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-details-id___ro",
    path: "/au/ro/video/:ex()/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___default",
    path: "/au/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___en",
    path: "/au/en/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___ar",
    path: "/au/ar/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___fr",
    path: "/au/fr/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___de",
    path: "/au/de/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___es",
    path: "/au/es/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-ex-stream-id___ro",
    path: "/au/ro/video/:ex()/stream/:id()",
    meta: { ...(_91id_93LZFvzd3MRDMeta || {}), ...{"country":"au"} },
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auvideo-category-name-id___default",
    path: "/au/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___en",
    path: "/au/en/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___ar",
    path: "/au/ar/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___fr",
    path: "/au/fr/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___de",
    path: "/au/de/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___es",
    path: "/au/es/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category-name-id___ro",
    path: "/au/ro/video/category/:name()/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-details-id___default",
    path: "/au/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___en",
    path: "/au/en/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___ar",
    path: "/au/ar/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___fr",
    path: "/au/fr/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___de",
    path: "/au/de/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___es",
    path: "/au/es/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details-id___ro",
    path: "/au/ro/video/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-list-name___default",
    path: "/au/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___en",
    path: "/au/en/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___ar",
    path: "/au/ar/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___fr",
    path: "/au/fr/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___de",
    path: "/au/de/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___es",
    path: "/au/es/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-list-name___ro",
    path: "/au/ro/video/list/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/list/[name].vue")
  },
  {
    name: "auvideo-series-details-id___default",
    path: "/au/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___en",
    path: "/au/en/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___ar",
    path: "/au/ar/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___fr",
    path: "/au/fr/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___de",
    path: "/au/de/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___es",
    path: "/au/es/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series-details-id___ro",
    path: "/au/ro/video/series/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-stream-id___default",
    path: "/au/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___en",
    path: "/au/en/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___ar",
    path: "/au/ar/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___fr",
    path: "/au/fr/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___de",
    path: "/au/de/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___es",
    path: "/au/es/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream-id___ro",
    path: "/au/ro/video/stream/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-test___default",
    path: "/au/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___en",
    path: "/au/en/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___ar",
    path: "/au/ar/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___fr",
    path: "/au/fr/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___de",
    path: "/au/de/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___es",
    path: "/au/es/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvideo-test___ro",
    path: "/au/ro/video/test",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/test.vue")
  },
  {
    name: "auvoucherbooks-name___default",
    path: "/au/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___en",
    path: "/au/en/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___ar",
    path: "/au/ar/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___fr",
    path: "/au/fr/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___de",
    path: "/au/de/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___es",
    path: "/au/es/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvoucherbooks-name___ro",
    path: "/au/ro/voucherbooks/:name()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/voucherbooks/[name].vue")
  },
  {
    name: "auvouchers-category-id___default",
    path: "/au/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___en",
    path: "/au/en/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___ar",
    path: "/au/ar/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___fr",
    path: "/au/fr/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___de",
    path: "/au/de/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___es",
    path: "/au/es/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-category-id___ro",
    path: "/au/ro/vouchers/category/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/category/[id].vue")
  },
  {
    name: "auvouchers-details-id___default",
    path: "/au/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___en",
    path: "/au/en/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___ar",
    path: "/au/ar/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___fr",
    path: "/au/fr/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___de",
    path: "/au/de/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___es",
    path: "/au/es/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-id___ro",
    path: "/au/ro/vouchers/details/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-genre-id___default",
    path: "/au/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___en",
    path: "/au/en/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___ar",
    path: "/au/ar/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___fr",
    path: "/au/fr/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___de",
    path: "/au/de/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___es",
    path: "/au/es/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "auvouchers-genre-id___ro",
    path: "/au/ro/vouchers/genre/:id()",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/genre/[id].vue")
  },
  {
    name: "aumain___default",
    path: "/au/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___en",
    path: "/au/en/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___ar",
    path: "/au/ar/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___fr",
    path: "/au/fr/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___de",
    path: "/au/de/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___es",
    path: "/au/es/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumain___ro",
    path: "/au/ro/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/main/[name].vue")
  },
  {
    name: "aumusic-track___default",
    path: "/au/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___en",
    path: "/au/en/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___ar",
    path: "/au/ar/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___fr",
    path: "/au/fr/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___de",
    path: "/au/de/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___es",
    path: "/au/es/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumusic-track___ro",
    path: "/au/ro/music/tracks/:title/:track",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/tracks/[track].vue")
  },
  {
    name: "aumonsooq-app-consent-details___default",
    path: "/au/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___en",
    path: "/au/en/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___ar",
    path: "/au/ar/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___fr",
    path: "/au/fr/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___de",
    path: "/au/de/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___es",
    path: "/au/es/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-consent-details___ro",
    path: "/au/ro/apps/consent/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/consent/[id].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___default",
    path: "/au/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___en",
    path: "/au/en/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___ar",
    path: "/au/ar/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___fr",
    path: "/au/fr/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___de",
    path: "/au/de/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___es",
    path: "/au/es/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-detail___ro",
    path: "/au/ro/apps/partner/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/partner/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___default",
    path: "/au/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___en",
    path: "/au/en/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___ar",
    path: "/au/ar/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___fr",
    path: "/au/fr/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___de",
    path: "/au/de/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___es",
    path: "/au/es/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aumonsooq-app-partner-details___ro",
    path: "/au/ro/apps/pd/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/pd/[name].vue")
  },
  {
    name: "aument-app-partner-details___default",
    path: "/au/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___en",
    path: "/au/en/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___ar",
    path: "/au/ar/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___fr",
    path: "/au/fr/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___de",
    path: "/au/de/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___es",
    path: "/au/es/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-details___ro",
    path: "/au/ro/mp/:title/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[name].vue")
  },
  {
    name: "aument-app-partner-categories-details___default",
    path: "/au/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___en",
    path: "/au/en/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___ar",
    path: "/au/ar/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___fr",
    path: "/au/fr/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___de",
    path: "/au/de/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___es",
    path: "/au/es/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aument-app-partner-categories-details___ro",
    path: "/au/ro/mp/:category",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/mp/[category].vue")
  },
  {
    name: "aumanage-subscription-details___default",
    path: "/au/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___en",
    path: "/au/en/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___ar",
    path: "/au/ar/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___fr",
    path: "/au/fr/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___de",
    path: "/au/de/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___es",
    path: "/au/es/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumanage-subscription-details___ro",
    path: "/au/ro/apps/manage/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/apps/manage/[id].vue")
  },
  {
    name: "aumusic-artistName-albumName___default",
    path: "/au/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___en",
    path: "/au/en/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___ar",
    path: "/au/ar/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___fr",
    path: "/au/fr/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___de",
    path: "/au/de/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___es",
    path: "/au/es/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artistName-albumName___ro",
    path: "/au/ro/music/albums/:artist/:artistName/:albumName/:album",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/albums/[artist]/[album].vue")
  },
  {
    name: "aumusic-artist___default",
    path: "/au/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___en",
    path: "/au/en/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___ar",
    path: "/au/ar/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___fr",
    path: "/au/fr/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___de",
    path: "/au/de/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___es",
    path: "/au/es/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-artist___ro",
    path: "/au/ro/music/artists/:artistName/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/artists/[id].vue")
  },
  {
    name: "aumusic-playlist___default",
    path: "/au/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___en",
    path: "/au/en/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___ar",
    path: "/au/ar/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___fr",
    path: "/au/fr/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___de",
    path: "/au/de/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___es",
    path: "/au/es/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aumusic-playlist___ro",
    path: "/au/ro/music/playlists/:title/:playlist",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/music/playlists/[playlist].vue")
  },
  {
    name: "aupodcast-details___default",
    path: "/au/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___en",
    path: "/au/en/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___ar",
    path: "/au/ar/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___fr",
    path: "/au/fr/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___de",
    path: "/au/de/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___es",
    path: "/au/es/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___ro",
    path: "/au/ro/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-episode___default",
    path: "/au/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___en",
    path: "/au/en/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___ar",
    path: "/au/ar/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___fr",
    path: "/au/fr/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___de",
    path: "/au/de/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___es",
    path: "/au/es/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___ro",
    path: "/au/ro/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "auaudiobook-details___default",
    path: "/au/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___en",
    path: "/au/en/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___ar",
    path: "/au/ar/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___fr",
    path: "/au/fr/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___de",
    path: "/au/de/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___es",
    path: "/au/es/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-details___ro",
    path: "/au/ro/audiobook/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/details/[id].vue")
  },
  {
    name: "auaudiobook-artists___default",
    path: "/au/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___en",
    path: "/au/en/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___ar",
    path: "/au/ar/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___fr",
    path: "/au/fr/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___de",
    path: "/au/de/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___es",
    path: "/au/es/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "auaudiobook-artists___ro",
    path: "/au/ro/audiobook/artists/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/audiobook/artists/[id].vue")
  },
  {
    name: "augames-category___default",
    path: "/au/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___en",
    path: "/au/en/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___ar",
    path: "/au/ar/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___fr",
    path: "/au/fr/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___de",
    path: "/au/de/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___es",
    path: "/au/es/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-category___ro",
    path: "/au/ro/games/category/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/category/[name]/index.vue")
  },
  {
    name: "augames-details___default",
    path: "/au/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___en",
    path: "/au/en/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___ar",
    path: "/au/ar/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___fr",
    path: "/au/fr/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___de",
    path: "/au/de/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___es",
    path: "/au/es/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-details___ro",
    path: "/au/ro/games/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/details/[id].vue")
  },
  {
    name: "augames-list___default",
    path: "/au/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___en",
    path: "/au/en/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___ar",
    path: "/au/ar/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___fr",
    path: "/au/fr/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___de",
    path: "/au/de/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___es",
    path: "/au/es/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "augames-list___ro",
    path: "/au/ro/games/list",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/games/list/[name]/index.vue")
  },
  {
    name: "auarcade-details___default",
    path: "/au/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___en",
    path: "/au/en/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___ar",
    path: "/au/ar/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___fr",
    path: "/au/fr/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___de",
    path: "/au/de/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___es",
    path: "/au/es/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "auarcade-details___ro",
    path: "/au/ro/arcade/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/arcade/details/[id].vue")
  },
  {
    name: "aupodcast-details___default",
    path: "/au/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___en",
    path: "/au/en/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___ar",
    path: "/au/ar/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___fr",
    path: "/au/fr/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___de",
    path: "/au/de/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___es",
    path: "/au/es/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-details___ro",
    path: "/au/ro/podcast/details/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/details/[id].vue")
  },
  {
    name: "aupodcast-episode___default",
    path: "/au/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___en",
    path: "/au/en/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___ar",
    path: "/au/ar/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___fr",
    path: "/au/fr/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___de",
    path: "/au/de/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___es",
    path: "/au/es/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "aupodcast-episode___ro",
    path: "/au/ro/podcast/episode/:title/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/podcast/episode/[id].vue")
  },
  {
    name: "auvideo-details___default",
    path: "/au/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___en",
    path: "/au/en/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___ar",
    path: "/au/ar/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___fr",
    path: "/au/fr/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___de",
    path: "/au/de/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___es",
    path: "/au/es/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auvideo-details___ro",
    path: "/au/ro/video/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/details/[id].vue")
  },
  {
    name: "auex-video-details___default",
    path: "/au/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___en",
    path: "/au/en/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___ar",
    path: "/au/ar/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___fr",
    path: "/au/fr/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___de",
    path: "/au/de/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___es",
    path: "/au/es/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auex-video-details___ro",
    path: "/au/ro/video/:ex/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/details/[id].vue")
  },
  {
    name: "auvideo-series___default",
    path: "/au/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___en",
    path: "/au/en/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___ar",
    path: "/au/ar/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___fr",
    path: "/au/fr/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___de",
    path: "/au/de/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___es",
    path: "/au/es/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-series___ro",
    path: "/au/ro/video/series/details/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/series/details/[id].vue")
  },
  {
    name: "auvideo-stream___default",
    path: "/au/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___en",
    path: "/au/en/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___ar",
    path: "/au/ar/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___fr",
    path: "/au/fr/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___de",
    path: "/au/de/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___es",
    path: "/au/es/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-stream___ro",
    path: "/au/ro/video/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/stream/[id].vue")
  },
  {
    name: "auvideo-category___default",
    path: "/au/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___en",
    path: "/au/en/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___ar",
    path: "/au/ar/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___fr",
    path: "/au/fr/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___de",
    path: "/au/de/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___es",
    path: "/au/es/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auvideo-category___ro",
    path: "/au/ro/video/category/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/category/[name]/[id].vue")
  },
  {
    name: "auex-video-stream___default",
    path: "/au/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___en",
    path: "/au/en/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___ar",
    path: "/au/ar/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___fr",
    path: "/au/fr/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___de",
    path: "/au/de/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___es",
    path: "/au/es/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auex-video-stream___ro",
    path: "/au/ro/video/:ex/stream/:name/:id",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/video/[ex]/stream/[id].vue")
  },
  {
    name: "auservices-page___default",
    path: "/au/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___en",
    path: "/au/en/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___ar",
    path: "/au/ar/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___fr",
    path: "/au/fr/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___de",
    path: "/au/de/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___es",
    path: "/au/es/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "auservices-page___ro",
    path: "/au/ro/services/:name",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/partners/[name].vue")
  },
  {
    name: "ausearch-q___default",
    path: "/au/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___en",
    path: "/au/en/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___ar",
    path: "/au/ar/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___fr",
    path: "/au/fr/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___de",
    path: "/au/de/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___es",
    path: "/au/es/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "ausearch-q___ro",
    path: "/au/ro/search-q",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/search/index.vue")
  },
  {
    name: "auvouchers-details-voucher___default",
    path: "/au/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___en",
    path: "/au/en/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___ar",
    path: "/au/ar/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___fr",
    path: "/au/fr/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___de",
    path: "/au/de/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___es",
    path: "/au/es/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auvouchers-details-voucher___ro",
    path: "/au/ro/vouchers/details/:id/:voucherId",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/vouchers/details/[id].vue")
  },
  {
    name: "auarticles-category-article___default",
    path: "/au/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___en",
    path: "/au/en/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___ar",
    path: "/au/ar/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___fr",
    path: "/au/fr/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___de",
    path: "/au/de/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___es",
    path: "/au/es/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  },
  {
    name: "auarticles-category-article___ro",
    path: "/au/ro/articles/:category?/:article",
    meta: {"country":"au"},
    component: () => import("/build/client/pages/articles/[category]/[subcategory]/[article].vue")
  }
]